export default {
  staffBot: {
    title: "Xodimlar boti",
    subtitle: "Hujjatlarni Telegram orqali yuklash va vazifa bildirishnomalari",
    connected: "Bot ulandi",
    error: "Xatolik",
    disconnect: "Uzish",
    disconnectConfirm: "Botni uzasizmi? Xodimlar qayta ulanishi kerak boʻladi.",
    youLinked: "Sizning Telegram ulangan",
    howToLink: "Botni oching, /start bosing va telefon raqamingizni yuboring — tizimdagi raqamingiz boʻyicha ulanadi.",
    featureDocs: "Rasm yoki PDF + izohda mijoz raqami (#123) — fayl bitimning kerakli hujjat maydoniga tushadi",
    featureCard: "Mijoz raqamini yozsangiz — bitimlari, bosqichi va qarzi",
    featureTasks: "Yangi vazifalar «Bajarildi» tugmasi bilan keladi, /tasks — bugungi vazifalar",
    connectHint: "@BotFather da yangi bot yarating (/newbot) va tokenini shu yerga qoʻying. Bu bot mijozlar uchun emas — faqat xodimlar uchun.",
    connect: "Ulash",
    notConnected: "Bot hali ulanmagan. Administratorga murojaat qiling.",
  },
  dealFinance: {
    tab: "Hisob-kitob",
    title: "Toʻlovlar",
    agreed: "Kelishilgan summa",
    extra: "Qoʻshimcha sotuv",
    paid: "Toʻlangan",
    debt: "Qarz",
    addPayment: "Toʻlov qoʻshish",
    addCharge: "Qoʻshimcha sotuv",
    extraSale: "qoʻshimcha sotuv",
    delete: "Oʻchirish",
    deleteConfirm: "Oʻchirilsinmi? Qarz qayta hisoblanadi",
    error: "Xatolik",
    paymentAdded: "Toʻlov qoʻshildi",
    chargeAdded: "Qoʻshimcha sotuv qoʻshildi",
    cancel: "Bekor qilish",
    save: "Saqlash",
    amount: "Summa",
    date: "Sana",
    methodLabel: "Toʻlov usuli",
    method: {
      cash: "Naqd",
      transfer: "Oʻtkazma",
      card: "Karta",
    },
    note: "Izoh",
    chargeHint: "Kelishilgan summa oʻzgarmaydi — qoʻshimcha xizmat summasi qarzga qoʻshiladi.",
    chargeTitle: "Xizmat nomi",
    valueLocked: "Kelishilgan summani faqat administrator oʻzgartira oladi",
    payments: "Tushumlar",
    debts: "Qarzdorlar",
    from: "Dan",
    to: "Gacha",
    allMethods: "Barcha usullar",
    allFunnels: "Barcha voronkalar",
    received: "Jami tushum",
    noPayments: "Bu davrda toʻlov yoʻq",
    export: "Excel (CSV)",
    totalDebt: "Jami qarz",
    debtors: "Qarzdorlar soni",
    noDebts: "Qarzdorlar yoʻq",
    lastPayment: "oxirgi toʻlov",
    client: "Mijoz",
    deal: "Bitim",
    stage: "Bosqich",
    acceptedBy: "Qabul qilgan",
    phone: "Telefon",
  },
  stageRules: {
    title: "Bosqich qoidalari",
    requiredCount: "{n} ta majburiy maydon",
    autoTaskOn: "avtomatik vazifa",
    requiredFields: "Oʻtish uchun majburiy maydonlar",
    requiredHint: "Bitim bu bosqichga faqat shu maydonlar toʻldirilgandan keyin oʻtadi. Fayl maydonlari — hujjat yuklangan boʻlishi kerak.",
    noFields: "Bitim maydonlari hali yaratilmagan",
    valueField: "Summa",
    autoTask: "Bosqichga kirganda vazifa yaratish",
    taskTitle: "Vazifa matni, masalan: Video otziv olish",
    toDealOwner: "Bitim masʼuliga",
    dueIn: "Muddat:",
    days: "kundan keyin",
    modalTitle: "Avval toʻldiring",
    modalHint: "Bu bosqichga oʻtkazish uchun quyidagilar majburiy",
    chooseFile: "Fayl tanlash",
    removeFile: "Faylni olib tashlash",
    uploadFailed: "Fayl yuklanmadi",
    yes: "Ha",
    select: "Tanlang",
    cancel: "Bekor qilish",
    saveAndMove: "Saqlash va oʻtkazish",
    bulkBlocked: "{n} ta bitim majburiy maydonlari toʻldirilmagani uchun oʻtkazilmadi",
    fromEnterDay: "bosqichga kirgan kundan",
    fromField: "«{name}» sanasidan",
    leadStage: "Birinchi bosqich — lidlar",
    leadStageHint: "Yangi murojaatlar shu bosqichga tushadi, kartalarda «Lid» belgisi koʻrinadi. Bitimlar boshqa voronkadan topshirilib keladigan xizmat voronkalarida oʻchiring.",
    renewalTitle: "Muddat boʻyicha avtomatik bitim",
    renewalHint: "Yutilgan bitimdagi sana yaqinlashganda (masalan ikamet tugashi) mijoz uchun tanlangan voronkada yangi bitim ochiladi va masʼulga vazifa qoʻyiladi. Bitta sana uchun bir marta.",
    renewalEnabled: "Yoqilgan",
    renewalDateField: "Sana maydoni",
    renewalDays: "Necha kun oldin",
    renewalFunnel: "Qaysi voronkaga",
    renewalStage: "Qaysi bosqichga",
    renewalTask: "Vazifa matni",
    renewalTaskPlaceholder: "Masalan: Uzatma taklif qilish",
    save: "Saqlash",
  },
  notif: { title: "Bildirishnomalar", subtitle: "Kim, qachon, nima qildi", markAll: "Hammasini o'qildi", empty: "Bildirishnoma yo'q", seeAll: "Hammasini ko'rish", loadError: "Yuklashda xato" },
  common: { selectPlaceholder: "Tanlang...", searchPlaceholder: "Qidirish...", noResults: "Hech nima topilmadi" },
  proc: {
    title: "Mening jarayonlarim", subtitle: "Bajarish kerak bo'lgan jarayonlar",
    empty: "Jarayon yo'q", emptyHint: "Sizga biriktirilgan jarayonlar shu yerda chiqadi", filesTitle: "Eskiz / fayllar", archiveTitle: "Arxiv", backToWork: "Ishlarga qaytish", archiveEmpty: "Arxiv bo'sh", archiveEmptyHint: "Tugatilgan ishlaringiz shu yerda saqlanadi", proposalTag: "Taklif", tabWork: "Ishlarim", tabRequests: "Pul so'rovi", tabArchive: "Arxiv",
    countSuffix: "ta jarayon", logout: "Chiqish", refresh: "Yangilash",
    saved: "Saqlandi", loadError: "Yuklashda xato",
    problemTitle: "Muammo nima?", problemPlaceholder: "Muammoni qisqacha yozing…", problemSubmit: "Yuborish", problemRequired: "Muammo tavsifini kiriting", cancel: "Bekor qilish",
  },

  snab: {
    title: "Mening zayavkalarim", subtitle: "Olib kelish kerak bo'lgan hujjatlar",
    empty: "Zayavka yo'q", emptyHint: "Sizga biriktirilgan ochiq zayavkalar shu yerda chiqadi",
    createReceipt: "Kirim yaratish", tabProducts: "Mahsulotlar", tabSuppliers: "Ta'minotchilar", suppliersEmpty: "Ta'minotchilar yo'q", needQty: "Kerak", buy: "Sotib olish", zoom: "Kattalashtirish", tabRequests: "Pul so'rovi", needBy: "Muddat:", noItems: "Pozitsiyalar yo'q",
    logout: "Chiqish", refresh: "Yangilash", loadError: "Yuklashda xato",
  },

  roles: {
    title: "Rollar", subtitle: "Maxsus rollar — modul ko'rinishi, amallar va ma'lumotlarni boshqarish",
    addRole: "Rol qo'shish", editRole: "Rolni tahrirlash", name: "Rol nomi", namePlaceholder: "Masalan: Sotuvchi, Omborchi...", nameRequired: "Rol nomi kiritilishi shart",
    modulesSection: "Modullar va amallar", module: "Modul", actionView: "Ko'r", actionCreate: "Qo'sh", actionEdit: "Tahr", actionDelete: "O'ch",
    dataFlagsSection: "Yashiriladigan ma'lumotlar", dataFlagsHint: "Belgilangan ma'lumotlar bu rol uchun yashiriladi (telefon, email, bitim summasi...)",
    ownSection: "Faqat o'zinikini ko'rsatish", ownHint: "Belgilangan bo'limlarda foydalanuvchi faqat o'zi yaratgan hujjatlarni ko'radi (boshqalarnikini emas).",
    save: "Saqlash", cancel: "Bekor", delete: "O'chirish", deleteTitle: "Rolni o'chirish", deleteText: "roli o'chiriladi. Bu roldagi foydalanuvchilar to'liq huquqqa qaytadi.",
    added: "Rol qo'shildi", updated: "Rol yangilandi", deleted: "Rol o'chirildi", loadError: "Yuklashda xato", genericError: "Xato yuz berdi",
    empty: "Rollar yo'q", modulesCount: "modul", hiddenCount: "yashirin",
    restricted: "Bu ma'lumot sizga ko'rinmaydi",
    prodSubActionsLabel: "Ishlab chiqarish: alohida kiritish huquqlari",
    prodEditOutputs: "Tayyor mahsulot partiyasi kiritish",
    prodEditComponents: "Xomashyo sarfi kiritish",
    flags: {
      contacts_phone: "Kontakt telefon raqami", contacts_email: "Kontakt email", deals_value: "Bitim summasi",
      products_costPrice: "Tannarx (xarid narxi)", products_avgCost: "O'rtacha tannarx", products_margin: "Marja / ustama", inventory_stockValue: "Qoldiq qiymati",
      sklad_valuation: "Sklad qiymati (jami tannarx)", sklad_unitCost: "Birlik tannarxi",
      finance_pnl: "Foyda va zarar (P&L)", finance_companyBalance: "Korxona balansi", finance_cashboxBalance: "Kassa balanslari", finance_netProfit: "Sof foyda", finance_cogs: "Tannarx (COGS)", finance_debtsTotals: "Qarz summalari",
      cashbox_balance: "Kassa balansi", cashbox_turnover: "Kassa aylanmasi",
      jobOrder_summary: "Zakaz summalari (statistika + kelishilgan/to'langan/qarz)", jobOrder_profit: "Zakaz foydasi", jobOrder_totalCost: "Zakaz tannarxi", jobOrder_laborCost: "Ish haqi xarajati", jobOrder_materialCost: "Material xarajati",
      jobOrder_lockBasic: "Asosiy ma'lumotlarni o'zgartirishni taqiqlash", jobOrder_lockProcesses: "Jarayonlarni o'zgartirishni taqiqlash", jobOrder_lockMaterials: "Rasxodlarni o'zgartirishni taqiqlash", jobOrder_lockFiles: "Fayllarni o'zgartirishni taqiqlash", jobOrder_lockDelete: "Zakazni o'chirishni taqiqlash",
      jobOrder_otherExpenses: "Boshqa xarajatlar bo'limini yashirish", jobOrder_otherExpensesEdit: "Boshqa xarajat qo'shishni taqiqlash", jobOrder_otherExpensesDelete: "Boshqa xarajatni o'chirishni taqiqlash",
      jobOrder_lockConfirm: "Zakazni tasdiqlashni taqiqlash", jobOrder_lockStart: "Jarayonga o'tkazishni taqiqlash", jobOrder_lockComplete: "Zakazni yakunlashni taqiqlash",
      proposal_cost: "Taklif tannarxi", proposal_margin: "Taklif marjasi",
      reports_inventoryValue: "Hisobot: ombor qiymati", reports_profitColumns: "Hisobot: foyda ustunlari",
    },
  },

  dtp: { now: "Hozir", done: "Tayyor" },
  picker: { placeholder: "Mahsulot...", search: "Qidirish...", notFound: "Topilmadi" },
  catPicker: { all: "Barchasi", back: "Orqaga", empty: "Bo'sh", count: "{n} ta" },
  update: { title: "Yangi versiya mavjud", subtitle: "Yangilab oling", action: "Yangilash", dismiss: "Yopish" },


  production: {
    loadError: "Yuklashda xato", error: "Xato", cancel: "Bekor", save: "Saqlash", saved: "Yangilandi", added: "Qo'shildi", deleted: "O'chirildi", movedToTrash: "Korzinaga o'tkazildi", toTrash: "Korzinaga", delete: "O'chirish", back: "Orqaga", selectPlaceholder: "Tanlang...", row: "Qator", addRow: "Qator qo'shish", print: "Chop", printTitle: "Chop etish", unitSuffix: "dona",
    prodLabel: "Ishlab chiqarish", prodSubtitle: "Xomashyodan tayyor mahsulot", pkgLabel: "Upakovka", pkgSubtitle: "Tayyor mahsulotni qadoqlash",
    searchPlaceholder: "Raqam yoki mahsulot...", new: "Yangi", notFound: "Hujjat topilmadi", notFoundHint: "Yangi hujjat yarating", newBlank: "Bo'sh yaratish", newFromRecipe: "Retsept asosida", recipe: "Retsept", norma: "Norma (necha marta)", normaHint: "Retsept shu songa ko'paytiriladi (1 norma = 1 retsept) — xomashyo va chiqish shunga qarab yoziladi.", noRecipes: "Retseptlar yo'q. Avval Retseptlar (BOM) bo'limidan qo'shing.", recipePickFirst: "Retseptni tanlang",
    thNumber: "Raqam", thDate: "Sana", thOutput: "Tayyor mahsulot", thOut: "Chiqdi", thCost: "Tannarx", thUnit: "Birlik", thStatus: "Holat", thActions: "Amallar", outLabel: "Chiqdi:",
    trashTitle: "Korzinaga o'tkazish", trashText1: "hujjati korzinaga o'tkaziladi. Xomashyo qoldig'i va tayyor mahsulot qoldig'i qaytariladi (30 kun ichida tiklash mumkin).",
    docLoadError: "Hujjat yuklanmadi", bomSelectProductFirst: "Avval tayyor mahsulotni tanlang", bomQtyFirst: "Chiqish miqdorini kiriting", bomNotFound: "Bu mahsulot uchun retsept topilmadi", bomLoaded: "Retsept yuklandi", whRequired: "Omborlar tanlanishi shart", outProductRequired: "Tayyor mahsulot tanlanishi shart", outQtyInvalid: "Chiqish miqdori noto'g'ri", minOneComponent: "Kamida bitta xomashyo kiriting", costShare: "Tannarx ulushi", costShareAuto: "avto", costShareHint: "Ulush bo'sh qoldirilsa — umumiy tannarx chiqish miqdoriga qarab avtomatik taqsimlanadi. Ulush kiritsangiz — shu vaznlar nisbatida.", outAllocCost: "Tannarx", outputsCount: "mahsulot", removeRow: "Qatorni o'chirish", lotLabel: "Partiya:", lotCol: "Partiya", lotAuto: "Avto (eng eski)", lotNoLabel: "Partiyasiz", lotLeft: "qoldiq", uomRequired: "O'lchov birligini tanlang", compProductRequired: "Xomashyo mahsulotini tanlang", compQtyRequired: "Xomashyo miqdorini kiriting", addGroup: "Guruh", newGroup: "Yangi guruh", groupNamePlaceholder: "Guruh nomi", removeGroup: "Guruhni o'chirish", moveTo: "Ko'chirish", moveToUngrouped: "Guruhsizga",
    fromWh: "Xomashyo ombori (qayerdan)", toWh: "Tayyor ombor (qayerga)", outputCard: "Tayyor mahsulot", applyBomTitle: "Tanlangan mahsulot retseptidan xomashyolarni yuklash", applyBom: "Retseptdan yuklash", product: "Mahsulot", outProductPlaceholder: "Tayyor mahsulot...", qty: "Miqdor", uom: "Birlik", uomPlaceholder: "dona, kg...", batchNo: "Partiya №", batchPlaceholder: "(ixtiyoriy)", expiry: "Yaroqlilik muddati", addBatch: "Partiya qo'shish", batchTime: "Vaqt", batchTotal: "Jami", grandTotalLabel: "Umumiy tayyor mahsulot:", normaTitle: "Norma", normaPerUnit: "uchun xomashyo", normaAdd: "Xomashyo qo'shish",
    componentsTitle: "Xomashyolar (rasxod)", noComponents: "Xomashyo qatorlari yo'q", colProduct: "Mahsulot", colQty: "Miqdor", colUom: "Birlik", colEstCost: "Taxm. tannarx", uomPlaceholder2: "birlik", costInline: "Tannarx:", stockInStock: "Sklad:",
    overheadTitle: "Qo'shimcha xarajat (ixtiyoriy)", noOverhead: "Qatorlar yo'q (ish haqi, elektr, amortizatsiya va h.k.)", colCategory: "Kategoriya (kassadan)", colName: "Nomi", colAmount: "Summa", catManual: "— (qo'lda)", overheadNamePlaceholder: "Ish haqi, Elektr...", amountPlaceholder: "Summa", overheadHint: "Kategoriya tanlasangiz, To'lovlardagi chiqim kategoriyasiga bog'lanadi (hisobotlarda birlashtirilgan ko'rinadi). Kategoriyani Moliya → To'lovlar bo'limidan yaratasiz.", colCashbox: "Kassa (naqd)", overheadNoCash: "— (faqat tannarxga)", overheadCashHint: "Kassa tanlansa — bu xarajat shu kassadan naqd chiqim bo'ladi va kassa kartasida ko'rinadi. Tannarxga baribir qo'shiladi; To'lovlar/P&L'ga alohida yozilmaydi (ikki marta sanash yo'q).",
    costTitle: "Tannarx (taxminiy)", costMaterials: "Xomashyolar", costOverhead: "Qo'shimcha xarajat", costTotal: "Jami tannarx", costUnit: "Birlik tannarx", costNote: "Saqlaganda haqiqiy tannarx FIFO/o'rtacha usuli bilan aniqlanadi va tayyor mahsulot avgCost'i shu asosda yangilanadi.", note: "Izoh", optional: "Ixtiyoriy...",
    trashText2: "Hujjat korzinaga o'tkaziladi. Xomashyo qoldig'i va tayyor mahsulot qoldig'i qaytariladi (30 kun ichida tiklash mumkin).",
    bomMahsulotRequired: "Mahsulot tanlanishi shart", bomMinOneComponent: "Kamida bitta tarkib qatori", bomOutQtyInvalid: "Chiqish miqdori noto'g'ri", bomEditTitle: "Retseptni tahrirlash", bomNewTitle: "Yangi retsept (BOM)", bomKind: "Tur", bomOutProduct: "Tayyor mahsulot", bomOutQty: "Chiqish miqdori", bomOutQtyHint: "Ushbu retsept shu sondagi tayyor mahsulot uchun", bomUom: "Birlik", bomComponents: "Xomashyolar", bomNoRows: "Qatorlar yo'q", bomColUom: "Birlik", bomColNote: "Izoh", bomColCategory: "Kategoriya", bomOverheadHint: "Kategoriya tanlasangiz, To'lovlardagi chiqim kategoriyasiga bog'lanadi (hisobotlarda birlashtirilgan ko'rinadi).",
    bomTitle: "Retseptlar (BOM)", bomNavShort: "Retseptlar", recipeSaveBtn: "Retsept saqlash", recipeSaveTitle: "Joriy formani retsept qilib saqlash", recipeSaveHint: "Hozirgi tayyor mahsulot, xomashyo va xarajatlar retsept bo'lib saqlanadi. Keyin 'Retsept asosida' + norma bilan shu ma'lumotlar avtomatik to'ladi.", recipeName: "Retsept nomi", recipeNamePlaceholder: "Masalan: Non (standart)", recipeNameRequired: "Retsept nomini kiriting", recipeSaved: "Retsept saqlandi", bomSubtitle: "Tayyor mahsulot uchun xomashyo retseptlari", all: "Hammasi", bomSearchPlaceholder: "Mahsulot...", bomNewBtn: "Retsept", bomEmpty: "Retseptlar yo'q", bomThProduct: "Mahsulot", bomThKind: "Tur", bomThOut: "Chiqdi", bomThComposition: "Tarkib", bomThOverhead: "Qo'sh.xar.", componentsCount: "ta xomashyo", overheadShort: "Qo'sh.xar.:", bomDeleteTitle: "Retseptni o'chirish", bomDeleteText: "retsepti butunlay o'chiriladi.",
    ppProdTitle: "ISHLAB CHIQARISH HUJJATI", ppPkgTitle: "UPAKOVKA HUJJATI", ppDate: "Sana:", ppRawWh: "Xomashyo ombori:", ppFinishedWh: "Tayyor mahsulot ombori:", ppFinished: "Tayyor mahsulot:", ppBatch: "Partiya №:", ppExpiry: "Yaroqlilik:", ppComponents: "Xomashyolar", ppColNum: "№", ppColName: "Nomi", ppColQty: "Miqdor", ppColUom: "O'lchov", ppColUnitCost: "Birlik tannarx", ppColSum: "Summa", ppMaterialsTotal: "Xomashyolar jami:", ppOverhead: "Qo'shimcha xarajat", ppOverheadTotal: "Qo'shimcha jami:", ppTotalCost: "Jami tannarx:", ppUnitCost: "Birlik tannarx:", ppNote: "Izoh:", ppSignMaker: "Ishlab chiqaruvchi (imzo)", ppSignReceiver: "Qabul qildi (imzo)",
  },

  scheduled: {
    title: "Majburiy to'lovlar", subtitle: "Har oy muayyan kunda to'lanadigan to'lovlar shabloni.",
    new: "Yangi to'lov", add: "Qo'shish", edit: "Tahrirlash", delete: "O'chirish",
    name: "Nomi", namePlaceholder: "Ofis ijarasi, Elektr to'lovi...",
    amount: "Summa", dayOfMonth: "Oyning necha-si", dayHint: "(1–28)",
    cashbox: "Kassa", category: "Kategoriya", counterparty: "Kontragent", note: "Izoh",
    optional: "ixtiyoriy",
    statusPaid: "To'landi", statusPending: "Kutilmoqda", statusOverdue: "Kechikkan",
    lastPaid: "Oxirgi to'lov",
    payBtn: "Chiqim yaratish", payTitle: "To'lov yaratish", payDate: "Sana", payConfirm: "To'lov yaratish",
    paySuccess: "To'lov yaratildi", payError: "Xatolik yuz berdi",
    deleteConfirm: "Shablon o'chirilsinmi?", deleted: "O'chirildi",
    saved: "Saqlandi", loadError: "Yuklab bo'lmadi",
    empty: "Majburiy to'lovlar yo'q", emptyHint: "Har oy to'lanadigan xarajatlarni qo'shing",
    active: "Faol", inactive: "Nofaol", toggleActive: "Holatni o'zgartirish",
    every: "Har oyning", dayLabel: "-si",
    totalMonth: "Jami majburiy to'lov", totalPaid: "To'landi", totalRemain: "Qoldi",
    itemsCount: "ta",
  },
  payReq: {
    title: "So'rovlar", subtitle: "Xodimlarning pul so'rovlari (zayavkalar).", new: "So'rov", newTitle: "Yangi so'rov",
    send: "Yuborish", sent: "So'rov yuborildi", cancel: "Bekor", amount: "Summa", amountInvalid: "Summa noto'g'ri",
    note: "Izoh", notePlaceholder: "Nima uchun kerak...", paymentMethod: "To'lov shakli", paymentMethodPlaceholder: "Naqd / Karta / Perechisleniya...", pmCash: "Naqd", pmCard: "Karta", pmTransfer: "Perechisleniya", jobOrder: "Zakaz", optional: "ixtiyoriy", searchPlaceholder: "Raqam yoki mijoz...", notFound: "Topilmadi", noteRequired: "Izoh kiritilishi shart",
    loadError: "Yuklashda xatolik", error: "Xatolik", empty: "So'rov yo'q", emptyHint: "Yangi so'rov qo'shing",
    byFinance: "Moliya:", reason: "Sabab:", approve: "Tasdiqlash", approved: "Tasdiqlandi", markPaid: "To'landi", approveTitle: "So'rovni tasdiqlash", approveHint: "Ruxsat beriladigan summani kiriting. Bu hali to'lov emas — keyin «To'landi» bilan chiqim yaratiladi.", approvedAmount: "Tasdiqlangan summa", requested: "So'ralgan", statTotal: "Jami so'rovlar", statApproved: "Tasdiqlangan", statPaid: "Berilgan", statRejected: "Rad etilgan", reject: "Rad etish",
    rejectTitle: "So'rovni rad etish", rejectReasonLabel: "Rad etish sababi (ixtiyoriy):", rejectReasonPlaceholder: "Sabab...",
    rejected: "Rad etildi", delete: "O'chirish", deleteConfirm: "So'rov o'chirilsinmi?", deleted: "O'chirildi",
    tabs: { pending: "Kutilmoqda", approved: "Tasdiqlangan", paid: "To'langan", rejected: "Rad etilgan", all: "Hammasi" },
    status: { pending: "Kutilmoqda", approved: "Tasdiqlangan", paid: "To'langan", rejected: "Rad etilgan" },
  },
  integrations: { back: "Orqaga",
    title: "Integratsiyalar", subtitle: "Boshqa servislar bilan integratsiyalarni yoqing.",
    saved: "Saqlandi", error: "Xatolik", on: "Yoqilgan", enable: "Yoqish", disable: "O'chirish", activeSuffix: "faol", off: "O'chiq", soon: "Tez orada", configure: "Sozlash", eskizConn: "Ulanish", eskizOk: "Ulangan", eskizEmail: "Email", eskizPassword: "Parol", eskizPassKeep: "O'zgartirmaslik uchun bo'sh qoldiring", eskizFrom: "Jo'natuvchi (nick)", eskizFromHint: "Test uchun 4546. Haqiqiy nick Eskiz'da tasdiqlanadi.", eskizSave: "Saqlash va ulanish", eskizTest: "Test SMS", eskizPhone: "Telefon", eskizMessage: "Xabar", eskizSendTest: "Test yuborish", eskizTestHint: "Standart matn «Это тест от Eskiz» tasdiqlangan. O'z matningiz uchun my.eskiz.uz → СМС → Мои тексты orqali moderatsiyadan o'tkazing.", eskizEmailReq: "Email kiriting", eskizPhoneReq: "Telefon raqamini kiriting", eskizConnected: "Eskiz ulandi", eskizSent: "SMS yuborildi", smsRulesTitle: "SMS xabarnomalar", smsRulesHint: "Hodisa sodir bo'lganda mijozga avtomatik SMS yuboriladi (matn Eskiz'da tasdiqlangan bo'lishi shart).", smsPlaceholders: "O'rin almashtiruvchilar", smsTplPlaceholder: "Masalan: Hurmatli {customer}, {number}-zakaz qabul qilindi.", smsRulesSave: "Xabarnomalarni saqlash", tabSettings: "Sozlamalar", tabHistory: "Tarix", balTitle: "SMS balans", balTotal: "Jami balans", balPrice: "1 SMS narxi", balSave: "Balansni saqlash", balLow: "Balans kam!", balLowHint: "Balans bitta SMS narxidan kam. Yangilang.", histEmpty: "Hali SMS yuborilmagan", evtJoCreated: "Zakaz (job order) yaratilganda", evtJoDelivered: "Zakaz (job order) yakunlanganda", evtSaleCreated: "Sotuv (faktura) yaratilganda", evtPayIncoming: "To'lov qabul qilinganda",
    cat: { sms: "SMS", hr: "HR" },
    svc: { "hr-line": "Xodimlarni boshqarish (HR Line)", "sms-eskiz": "SMS yuborish (eskiz.uz)", "sms-playmobile": "SMS shlyuz (Play Mobile)", "hr-attendance": "Xodimlar davomati", "hr-payroll": "Ish haqi hisob-kitobi" },
  },
  finance: { total: "Jami",
    loadError: "Yuklashda xato", cancel: "Bekor", save: "Saqlash", add: "Qo'shish", saved: "Yangilandi", added: "Qo'shildi", deleted: "O'chirildi", error: "Xato", delete: "O'chirish", deleteTitle: "O'chirishni tasdiqlang", nameRequired: "Nomi kiritilishi shart", search: "Qidirish...", notFound: "Topilmadi", selectCp: "Kontragent tanlang...", loadMore: "Yana yuklash", clearSelection: "Tanlovni tozalash", edit: "Tahrirlash", back: "Orqaga", kirim: "Kirim", chiqim: "Chiqim", insufficient: "Kassada yetarli mablag' yo'q",
    thName: "Nomi", thCurrency: "Valyuta", thBranch: "Filial", thBalance: "Balans", thActions: "Amallar", thNumber: "Raqam", thDate: "Sana", thType: "Tur", thCp: "Kontragent", thCashbox: "Kassa", thCategory: "Kategoriya", thAmount: "Summa", thStatus: "Status", thDesc: "Tavsif", thDirection: "Yo'nalish",
    debtsTitle: "Qarzlar", debtsSubtitle: "Qarzdorlar va kreditorlar (kontragentlar balansi)", none: "Yo'q", debtors: "Qarzdorlar", debtorsHint: "Debitor qarzdor", creditors: "Kreditorlar", creditorsHint: "Kreditor qarzdorlar",
    cbReportLoadError: "Hisobotni yuklashda xato", cbBase: "Asosiy", cbTitle: "Korxona balansi", cbSubtitle: "Har valyuta bo'yicha sof qiymat (net worth)", noData: "Ma'lumot yo'q", cbGrandTotal: "Umumiy sof qiymat ({base}ga keltirilgan)", cbConvertedNote: "Boshqa valyutalar tashkilot kurslari bo'yicha hisoblangan", cbRatesLabel: "Kurs", cbInventory: "Tovar qoldiqlari tan narxi", cbInventoryHint: "Xomashyo va tayyor mahsulotlar", cbReceivables: "Kontragentdan haqdorlik", cbReceivablesHint: "Kontragentlar to'laydigan pullar", cbCash: "Kassadagi pullar", cbCashHint: "Shu valyutadagi kassalar", cbPayables: "Kontragentga qarz", cbPayablesHint: "Kontragentlarga to'lanadigan qarz", cbFormula: "Formula: Sklad tan narxi + Kontragentdan haqdorlik + Kassadagi pullar − Kontragentga qarz. Sklad tan narxi faqat asosiy valyutada ({base}) saqlanadi.",
    pnlTitle: "P&L (Foyda va zarar)", pnlSubtitle: "Tushum → Tannarx → Yalpi foyda → Xarajatlar → Sof foyda (asosiy valyutada)", pnlReport: "P&L hisobot", pnlRevenue: "Tushum (sotuvlar)", pnlCogs: "− Tannarx", pnlGross: "= Yalpi foyda", pnlOpex: "− Operatsion xarajatlar", pnlOperating: "= Operatsion foyda", pnlFinancial: "− Moliyaviy xarajatlar (foiz/bank)", pnlSecLabel: "P&L turkumi", pnlSecHint: "Operatsion — odatiy xarajat; Moliyaviy — bank foizi/kredit; Hisobga olinmaydi — ta'minotchiga to'lov/qarz.", pnlSec_operating: "Operatsion", pnlSec_financial: "Moliyaviy", pnlSec_excluded: "Hisobga olinmaydi", pnlNet: "≡ Sof foyda", pnlNote: "Eslatma: Tannarx joriy tannarx asosida (taxminiy). Soliqlar va kreditlar hisobga olinmaydi.", pnlExpenseDetail: "Operatsion xarajatlar tafsiloti", pnlNoExpense: "Xarajat to'lovlari yo'q", pnlCashFlow: "Pul oqimi (qo'shimcha)", pnlCashFlowHint: "Kassa harakati, P&L ga ta'sir qilmaydi", pnlNetFlow: "Sof oqim",
    cbxCurrencyRequired: "Valyuta tanlanishi shart", cbxEditTitle: "Kassani tahrirlash", cbxNewTitle: "Yangi kassa", cbxNameLabel: "Nomi *", cbxNamePlaceholder: "Kassa nomi", cbxCurrencyLabel: "Valyuta *", cbxBranchLabel: "Filial", cbxBranchNone: "— Tanlanmagan —", cbxBranchHint: "Filiallar Sozlamalar → Korxona bo'limidan qo'shiladi.", cbxTitle: "Kassalar", cbxSubtitle: "Kassalar ro'yxati", cbxAdd: "Kassa qo'shish", cbxNotFound: "Kassa topilmadi", cbxNotFoundHint: "Yangi kassa qo'shing", cbxDeleteText: "kassasi o'chiriladi.",
    ccTitle: "Kassa kartochkasi", ccNotFound: "Kassa topilmadi", ccBackToList: "Ro'yxatga qaytish", ccConversion: "Konvertatsiya", ccReceipt: "Naqd kirim (xarid)", ccOverhead: "Ishlab chiqarish xarajati", ccConvOut: "(chiqdi)", ccConvIn: "(kirdi)", ccCurrentBalance: "Joriy balans", ccJournal: "Harakatlar jurnali", ccNoMovements: "Harakatlar yo'q",
    convCashboxesRequired: "Kassalar tanlanishi shart", convSameCashbox: "Bir xil kassa tanlab bo'lmaydi", convSameCurrency: "Bir xil valyutani konvertatsiya qilib bo'lmaydi", convTransferMode: "Ko'chirish (kurssiz, 1:1)", convTransferTitle: "Kassadan kassaga ko'chirish", convTransferBtn: "Ko'chirish", convTransferTag: "Ko'chirish", convFromAmountInvalid: "Beriladigan summa noto'g'ri", convRateRequired: "Kursni kiriting", convDone: "Konvertatsiya bajarildi", convEditTitle: "Konvertatsiyani tahrirlash", convNewTitle: "Yangi konvertatsiya", convFrom: "Kassadan", convSelect: "Tanlang...", convBalance: "Balans:", convGive: "Beriladi (summa)", convTo: "Kassaga", convRate: "Kurs", convReverse: "Teskari", convReceive: "Olinadi", convAuto: "(avtomatik)", convDoBtn: "Bajarish", convTitle: "Konvertatsiya", convSubtitle: "Kassadan kassaga valyuta o'tkazish", convNewBtn: "Konvertatsiya", convNotFound: "Konvertatsiya topilmadi", convNotFoundHint: "Yangi konvertatsiya yarating", convThGive: "Beriladi", convThReceive: "Olinadi", convDeleteText: "konvertatsiyasi o'chiriladi.", convVerifyBtn: "Tasdiqlash", convVerified: "Konvertatsiya tasdiqlandi", convVerifiedBadge: "Tasdiqlangan", convDraftBadge: "Tasdiqlanmagan", convVerifiedAt: "Tasdiqlandi", convLockedHint: "Tasdiqlangan hujjat tahrirlanmaydi",
    payTitle: "To'lovlar", paySubtitle: "Pul kirimi va chiqimi", paySearch: "Raqam yoki kontragent...", payFilterCp: "Kontragent", payFilterCashbox: "Barcha kassalar", payFilterCategory: "Barcha kategoriyalar", payIncoming: "Pul kirimi", payOutgoing: "Pul chiqimi", payNotFound: "To'lov topilmadi", payNotFoundHint: "Pul kirimi yoki chiqimi yarating", payDeleteText: "to'lovi o'chiriladi. Kontragent balansi qaytariladi.",
    pfIncomingTitle: "Kirim to'lovi", pfOutgoingTitle: "Chiqim to'lovi", pfJoSelect: "Zakaz tanlang...", pfClearSelection: "— Tanlovni tozalash —", pfJoSearch: "Raqam yoki mijoz...", pfNewCp: "Yangi kontragent", cpAdded: "Kontragent qo'shildi", pfPhone: "Telefon", pfPhonePlaceholder: "+998 ...", smTitle: "Statuslarni boshqarish", smNew: "Yangi status", smNamePlaceholder: "Status nomi...", catIncomingTitle: "Kirim kategoriyalari", catOutgoingTitle: "Chiqim kategoriyalari", catNew: "Yangi kategoriya", catNamePlaceholder: "Kategoriya nomi...",
    pfDocLoadError: "Hujjat yuklanmadi", pfCpRequired: "Kontragent tanlanishi shart", pfCashboxRequired: "Kassa tanlanishi shart", pfAmountInvalid: "Summa noto'g'ri", pfDateInvalid: "Sana noto'g'ri (DD/MM/YYYY HH:MM)", pfHeaderTitle: "To'lovlar", pfFromRequest: "Bu chiqim zayavka asosida yaratilmoqda:", pfPrint: "Chop", pfPrintTitle: "Chop etish", pfAddAnother: "Yana kirim qo'shish", pfAddAnotherTitle: "Shu zakaz uchun yana kirim qo'shish (boshqa kassadan)", pfJoRemainTitle: "Zakazda qoldiq qarz bor", pfJoRemainHint: "To'lov saqlandi. Mijoz boshqa kassaga ham to'lov qilmoqchi bo'lsa, \"Yana kirim qo'shish\" tugmasini bosing.", pfDateLabel: "Sana:", pfStatusless: "Statussiz", pfCpLabel: "Kontragent *", pfNewCpTitle: "Yangi kontragent qo'shish", pfCashboxLabel: "Kassa *", pfCashboxSelect: "Kassa tanlang...", pfBalance: "Balans:", pfAmountLabel: "Summa *", pfCategoryLabel: "Kategoriya", pfManage: "Boshqarish", pfCategoryless: "Kategoriyasiz", pfJobOrder: "Zakaz", pfJobOrderHint: "Tanlasangiz, to'lov shu zakaz balansiga bog'lanadi. Bo'sh qoldirilsa — oddiy kirim.", pfProcess: "Jarayon (mehnat)", pfProcessHint: "To'lov summasi shu jarayon mehnatiga yoziladi.", pfProcessRequired: "Jarayon tanlanishi shart", pfProcessCurrencyMismatch: "To'lov valyutasi zakaz valyutasi bilan bir xil bo'lishi kerak", pfOptional: "ixtiyoriy", pfNote: "Izoh", pfNotePlaceholder: "Izoh (ixtiyoriy)...", pfJoTotal: "Zakaz summasi", pfJoPaid: "To’langan", pfJoRemaining: "Qoldiq", pfJoHistory: "To’lovlar tarixi", pfJoNoPayments: "Hali to’lov yo’q", pfJoLoading: "Yuklanmoqda...", pfDeleteText: "To'lov o'chiriladi va kontragent balansi qaytariladi.", pfNameLabel: "Nomi *", pfNamePlaceholder: "Nomi", pfCommissionAdd: "Komissiya qo'shish", pfCommission: "Komissiya (2-chiqim)", pfCommissionPct: "Foiz", pfSecondAdd: "2-kassaga bo'lib to'lash", pfSecondTitle: "2-kassa kirimi (naqd + karta)", pfSecondCashboxLabel: "2-kassa", pfSecondAmountLabel: "2-kassa summasi", pfSecondRemove: "Bekor", pfSecondCashboxRequired: "2-kassa tanlanishi shart", pfSecondSameCashbox: "2-kassa boshqa bo'lishi kerak", pfSecondInvalid: "2-kassa summasi noto'g'ri", pfCommissionInvalid: "Komissiya summasi noto'g'ri", pfCommissionEmpty: "Komissiya kategoriyalari belgilanmagan — «Boshqarish» orqali tanlang.", pfCommissionMgrTitle: "Komissiya kategoriyalari", pfCommissionMgrHint: "Belgilangan chiqim kategoriyalari komissiyada tanlash uchun chiqadi.",
    ppIncomingTitle: "KIRIM ORDERI", ppOutgoingTitle: "CHIQIM ORDERI", ppDate: "Sana:", ppReceivedFrom: "Qabul qilindi (kim)", ppGivenTo: "Berildi (kim)", ppCashbox: "Kassa:", ppCategory: "Kategoriya:", ppAmount: "Summa:", ppNote: "Izoh:", ppSignedIncomingLeft: "Topshirdi (imzo)", ppSignedOutgoingLeft: "Berdi (imzo)", ppSignedIncomingRight: "Qabul qildi (imzo)", ppSignedOutgoingRight: "Oldim (imzo)",
  },

  contracts: { optional: "ixtiyoriy", legalNamePlaceholder: "Yuridik nomi", managerLabel: "Mas'ul (kim ishlaydi)", managerNone: "Tanlanmagan",
    selectCp: "Kontragent tanlang...", search: "Qidirish...", notFound: "Topilmadi",
    editTitle: "Shartnomani tahrirlash", newTitle: "Yangi shartnoma",
    number: "Raqam", date: "Sana", cpLabel: "Kontragent *", legalName: "Yuridik nom", inn: "INN", legalMissing: "Kontragent kartasida yuridik nom/INN to'ldirilmagan.", amount: "Summa *", currency: "Valyuta",
    description: "Tavsif", descPlaceholder: "Shartnoma mavzusi...", note: "Izoh", notePlaceholder: "Ixtiyoriy...",
    filesLabel: "Fayllar (PDF, skanlar)", cancel: "Bekor", save: "Saqlash", add: "Qo'shish",
    cpRequired: "Kontragent tanlanishi shart", amountInvalid: "Summa noto'g'ri",
    saved: "Yangilandi", added: "Qo'shildi", error: "Xato", loadError: "Yuklashda xato", deleted: "O'chirildi",
    title: "Shartnomalar", subtitle: "Shartnomalar reestri — har bir shartnomaga avtomatik raqam beriladi",
    searchPlaceholder: "Raqam, kontragent...", newBtn: "Shartnoma", empty: "Shartnoma yo'q", emptyHint: "Yangi shartnoma qo'shing",
    thCp: "Kontragent", thAmount: "Summa", thCreatedBy: "Yaratdi", thActions: "Amallar",
    deleteTitle: "O'chirishni tasdiqlang", deleteText: "shartnomasi o'chiriladi.", delete: "O'chirish",
  },

  aktSverka: { tabCustomer: "Mijoz bilan", tabSupplier: "Ta'minotchi bilan",
    selectCp: "Kontragent tanlang...", search: "Qidirish...", notFound: "Topilmadi",
    cpRequired: "Kontragent tanlanishi shart", error: "Xato", copied: "Nusxa olindi",
    regenConfirm: "Eski havola bekor qilinadi va yangisi yaratiladi. Davom etilsinmi?", urlUpdated: "Havola yangilandi",
    title: "Akt-sverka", subtitle: "Kontragent bilan o'zaro hisob-kitob hujjati", cpLabel: "Kontragent",
    fromDate: "Boshlanish sanasi", toDate: "Tugash sanasi", generate: "Hosil qilish", print: "Chop etish / PDF",
    permUrlTitle: "Kontragent uchun doimiy URL", permUrlHint: "Bu URL doimiy — kontragent uni saqlab qo'yib istalgan vaqtda o'z hisob-kitobini ko'rishi mumkin. Davrlar public sahifada tanlanadi.",
    copyTitle: "Nusxa olish", copy: "Nusxa", regenTitle: "Yangi URL (eski bekor bo'ladi)", regen: "Yangilash",
    loadError: "Yuklashda xato", linkError: "Havola ochilmadi", printShort: "Chop / PDF",
    docTitle: "AKT SVERKA", docSubtitle: "Kontragentlar o'rtasidagi o'zaro hisob-kitob", ourOrg: "Bizning tashkilot", tel: "Tel", period: "Davr",
    noTx: "Bu davrda tranzaksiyalar yo'q", currencyLabel: "Valyuta", thDate: "Sana", thDoc: "Hujjat", thDebit: "Debet", thCredit: "Kredit", thBalance: "Saldo",
    openingBalance: "Boshlang'ich saldo", totalRow: "Jami",
    theyOweA: " tomonidan bizga ", theyOweB: " qarz qoldi.", weOwePre: "Biz tomonidan ", weOweMid: "'ga ", weOweSuf: " qarz qoldi.",
    noDebtPre: "Bu davrda ", noDebt: "qarz yo'q (saldo 0)",
    signOur: "Bizning tashkilot tomonidan:", signCp: "Kontragent tomonidan:", signLine: "(F.I.Sh., lavozim, imzo, sana)",
  },

  sklad: { allCategories: "Barcha kategoriyalar", lowOnly: "Kam qolganlar", totalValue: "Jami qoldiq qiymati", thCategory: "Kategoriya", thValue: "Qiymat",
    loadError: "Yuklashda xato", cancel: "Bekor", save: "Saqlash", add: "Qo'shish", saved: "Yangilandi", added: "Qo'shildi", deleted: "O'chirildi", error: "Xato", delete: "O'chirish", deleteTitle: "O'chirishni tasdiqlang", nameRequired: "Nomi kiritilishi shart", total: "Jami", thName: "Nomi", thProduct: "Mahsulot", thUom: "O'lchov", sku: "SKU",
    sbTitle: "Qoldiqlar", sbSubtitle: "Mahsulotlarning ombor bo'yicha qoldig'i", sbSearch: "Mahsulot qidirish...", sbNotFound: "Mahsulot topilmadi", sbNotFoundHint: "Qoldiqlar kirim hujjatlari orqali shakllanadi",
    rTitle: "Jami tannarxlar", rSubtitle: "Mahsulotlar qoldig'i va tannarx asosida ombor qiymati", rKpi: "Ombor umumiy qiymati (tannarx)", rEmpty: "Qoldiq yo'q", rStock: "Qoldiq", rCost: "Tannarx", rValue: "Qiymat",
    tTitle: "Ko'chirishlar", tSubtitle: "Omborlararo tovar ko'chirish", tNew: "Ko'chirish", tSearch: "Raqam bo'yicha qidirish...", tNotFound: "Ko'chirish topilmadi", tNotFoundHint: "Yangi ko'chirish hujjati yarating", tNumber: "Raqam", tDate: "Sana", tDirection: "Yo'nalish", tProducts: "Mahsulotlar", itemCountSuffix: "ta mahsulot",
    whEditTitle: "Omborni tahrirlash", whNewTitle: "Yangi ombor", whNameLabel: "Nomi *", whNamePlaceholder: "Ombor nomi", whTitle: "Omborxonalar", whSubtitle: "Omborlar ro'yxati", whAdd: "Ombor qo'shish", whNotFound: "Ombor topilmadi", whNotFoundHint: "Yangi ombor qo'shing", thActions: "Amallar", whDeleteText: "ombori o'chiriladi.",
    lsTitle: "Kam qolgan mahsulotlar", lsSubtitleSearch: "Mahsulot topib, minimal qoldiqni belgilang", lsSubtitle: "Qoldig'i belgilangan minimal darajadan past mahsulotlar", lsAlerts: "Ogohlantirishlar", lsEmpty: "Kam qolgan mahsulot yo'q", lsEmptyHint: "Minimal qoldiqni belgilash uchun mahsulot qidiring", lsLow: "Kam", lsEnough: "Yetarli", lsCurrentStock: "Joriy qoldiq", lsMinStock: "Minimal qoldiq", lsStatus: "Holat",
    tfNotFound: "Topilmadi", tfCatalogEmpty: "Katalog bo'sh", tfTypeProduct: "Mahsulot nomini yozing...", tfDocLoadError: "Hujjat yuklanmadi", tfFromRequired: "Qayerdan ombor tanlanishi shart", tfToRequired: "Qayerga ombor tanlanishi shart", tfSameWarehouse: "Bir xil ombor tanlab bo'lmaydi", tfDateInvalid: "Sana noto'g'ri (DD/MM/YYYY HH:MM)", tfMinOneProduct: "Kamida bitta mahsulot kiriting", tfMoved: "Ko'chirildi", back: "Orqaga", tfHeaderTitle: "Omborlararo ko'chirish", tfDocTitle: "Ko'chirish hujjati", tfFrom: "Qayerdan *", tfTo: "Qayerga *", tfSelectWarehouse: "Ombor tanlang...", tfThAvailFrom: "Mavjud (qayerdan)", tfQty: "Miqdor", tfAvailable: "Mavjud", tfNote: "Izoh", tfNotePlaceholder: "Izoh...", tfDeleteText: "ko'chirish hujjati o'chiriladi. Qoldiqlar qaytariladi.",
  },

  cpCard: {
    kind: { purchaseOrder: "Xarid buyurtmasi", purchaseReceipt: "Kirim", purchaseReturn: "Xarid qaytarish", salesOrder: "Sotuv buyurtmasi", salesInvoice: "Sotuv", salesReturn: "Sotuv qaytarish" },
    payIn: "To'lov (kirim)", payOut: "To'lov (chiqim)", weOwe: "Biz qarzdormiz", theyOwe: "Bizga qarzdor",
    tabs: { documents: "Hujjatlar", payments: "To'lovlar", ledger: "Balans tarixi", products: "Tovarlar", prices: "Narxlar" },
    loadError: "Yuklashda xato", cardTitle: "Kontragent kartochkasi", back: "Orqaga", notFound: "Kontragent topilmadi", backToList: "Ro'yxatga qaytish", debtTitle: "Qarzdorlik",
    thKind: "Tur", thNumber: "Raqam", thDate: "Sana", thStatus: "Status", thSum: "Summa", thCashbox: "Kassa", thCategory: "Kategoriya", thDoc: "Hujjat", thChange: "O'zgarish", thBalance: "Balans",
    noDocuments: "Hujjatlar yo'q", noPayments: "To'lovlar yo'q", ledgerEmpty: "Balans tarixi bo'sh",
  },

  counterparties: { addBtn: "Qo'shish", statTotal: "Jami", statCustomers: "Mijozlar", statSuppliers: "Ta'minotchilar",
    folderNamePlaceholder: "Papka nomi...", cancel: "Bekor", error: "Xato", subFolderTitle: "Sub-papka qo'shish",
    folders: "Papkalar", statusMgrTitle: "Statuslarni boshqarish", editLabel: "Tahrirlash", newStatus: "Yangi status",
    statusNamePlaceholder: "Status nomi...", save: "Saqlash", add: "Qo'shish",
    all: "Barchasi", statusless: "Statussiz", status: "Status",
    loadError: "Yuklashda xato", saved: "Yangilandi", added: "Qo'shildi", deleted: "O'chirildi",
    title: "Kontragentlar", subtitle: "Mijozlar va ta'minotchilar", allFolders: "Barcha papkalar", searchPlaceholder: "Qidirish...",
    notFound: "Kontragent topilmadi", createHint: "Yangi kontragent qo'shing",
    weOwe: "Biz qarzdormiz", theyOwe: "Bizga qarzdor",
    thName: "Nomi", thPhone: "Telefon", thContacts: "Kontaktlar", thDebt: "Qarzdorlik", thActions: "Amallar", contactsSuffix: "kontakt",
    editTitle: "Tahrirlash", newTitle: "Kontragent qo'shish", nameLabel: "Nomi", namePlaceholder: "Kompaniya yoki shaxs nomi",
    folderLabel: "Papka", noFolder: "Papkasiz", configure: "Sozlash",
    phone: "Telefon", phonePlaceholder: "+998 90 000 00 00", email: "Email", emailPlaceholder: "example@mail.com", comment: "Komment", commentPlaceholder: "Izoh...",
    contactsTitle: "Kontaktli shaxslar", addContact: "Qo'shish", noContacts: "Kontakt qo'shilmagan",
    cName: "Ismi", cNamePlaceholder: "Ism Familiya", cRole: "Lavozimi", cRolePlaceholder: "Direktor, Menejer...", cPhone: "Nomeri",
    requisitesTitle: "Rekvizitlar", inn: "INN (STIR)", innPlaceholder: "123456789",
    legalName: "Yuridik nomi", legalNamePlaceholder: "OOO \"Kompaniya\"", legalAddr: "Yuridik manzil", legalAddrPlaceholder: "Toshkent sh., Chilonzor t., ...",
    bankAccount: "Bank hisob raqami", bankPlaceholder: "2020 8000 0000 0000 0000", update: "Yangilash",
    location: "Manzil / Lokatsiya", locationPlaceholder: "Shahar, ko'cha, bino...",
    deleteTitle: "O'chirishni tasdiqlang", deleteText: "kontragenti o'chiriladi.", delete: "O'chirish",
  },

  uomNames: {
    pcs: "dona", kg: "kilogramm", g: "gramm", t: "tonna", l: "litr", ml: "millilitr",
    m: "metr", cm: "santimetr", mm: "millimetr", "m²": "kvadrat metr", "m³": "kub metr", km: "kilometr",
    pair: "juft", roll: "rulon", box: "quti", pack: "pachka", bag: "qop", set: "to'plam",
    bottle: "shisha", can: "banka", cyl: "ballon", coil: "g'altak", spool: "g'altak (spool)", sheet: "list", bunch: "bog'lam",
    hr: "soat", min: "daqiqa", day: "kun", week: "hafta", month: "oy", year: "yil",
    visit: "tashrif", session: "seans", project: "loyiha", page: "sahifa", word: "so'z", trip: "reys",
  },
  productForm: {
    variantsTitle: "Variantlar", variantsHint: "Rang, o'lcham kabi atributlar bo'yicha variantlar",
    attributesTitle: "Atributlar", attrNamePlaceholder: "Atribut nomi (mas. Rang)", attrValuePlaceholder: "Qiymat qo'shish + Enter",
    addAttribute: "Atribut qo'shish", generateVariants: "Variantlarni yaratish",
    variantsListTitle: "Variantlar", totalStock: "Jami qoldiq", variantCol: "Variant", imageCol: "Rasm", skuCol: "SKU", priceCol: "Narx", costCol: "Tannarx", stockCol: "Qoldiq",
    stockHint: "Har variant uchun boshlang'ich qoldiqni kiriting; mahsulot qoldig'i = variantlar yig'indisi",
    ptTitle: "Sotuv narx turlari", ptHint: "Qo'shing, tahrirlang yoki o'chiring", ptPlaceholder: "Masalan: Ulgurji, Chakana...", ptAdd: "Narx turi qo'shish",
    added: "Qo'shildi", deleted: "O'chirildi", error: "Xato",
    images: "Rasmlar", imagesHint: "ta • birinchisi muqova", setCover: "Muqova qil", uploading: "Yuklanmoqda...", imageDrop: "Rasm tanlang yoki bu yerga tashlang", imageError: "Rasm yuklashda xato",
    dimsTitle: "O'lchamlari", dimsHint: "— bir dona uchun", length: "Uzunlik", width: "Kenglik", height: "Balandlik",
    pkgTitle: "Qadoqlash birliklarini", pkgBase: "Asosiy:", pkgNoBase: "Avval \"Ma'lumotlar\" bo'limidan asosiy o'lchov birligini (UOM) tanlang",
    pkgUnit: "Qadoqlash birlik", pkgQty: "Miqdori", pkgUomSelect: "O'lchov...", pkgAdd: "Qadoqlash qo'shish",
    editTitle: "Tahrirlash", newProduct: "Yangi mahsulot", newService: "Yangi xizmat",
    saved: "Yangilandi", saveError: "Xato yuz berdi", saving: "Saqlanmoqda...", update: "Yangilash", save: "Saqlash", cancel: "Bekor qilish",
    nameLabel: "Nomi", productNamePlaceholder: "Mahsulot nomi", serviceNamePlaceholder: "Xizmat nomi",
    infoTitle: "Ma'lumotlar", descLabel: "Tavsif", descPlaceholder: "Mahsulot haqida qisqacha...",
    folderLabel: "Papka", noFolder: "Papkasiz", select: "Tanlang...", skuLabel: "SKU", skuPlaceholder: "Masalan: PRD-001",
    pricesTitle: "Narxlar", buyPrice: "Xarid narxi", salePricesTitle: "Sotuv narxlari", statusTitle: "Holat", back: "Orqaga", uomLabel: "O'lchov birligi", minStockLabel: "Minimal qoldiq", minStockHint: "Qoldiq shu miqdordan kam yoki teng bo'lsa — \"Kam qoldiq\"da chiqadi (0 = nazorat yo'q)", configure: "Sozlash", active: "Faol", activeBadge: "Aktiv", isManufacturedLabel: "Ishlab chiqariladi", prodNormaTitle: "Ishlab chiqarish normasi", prodNormaHint: "1 birlik mahsulot ishlab chiqarilganda sarf bo'ladigan xomashyolar", prodNormaAdd: "Qo'shish", prodNormaProduct: "Xomashyo", prodNormaQty: "Miqdor", prodNormaUom: "Birlik", prodNormaFooter: "Ishlab chiqarishda bu mahsulot tanlanganda norma avtomatik tortiladi", manufacturingUomLabel: "Ishlab chiqarish o'lchov birligi", manufacturingUomHint: "Ishlab chiqarish formasida bu mahsulot tanlanganda avtomatik qo'yiladi va o'zgartirib bo'lmaydi.", manufacturingUomNone: "Belgilanmagan (ixtiyoriy)",
    mkixCodeLabel: "MKIX kod", mkixCodePlaceholder: "Masalan: 3926909709",
    nameRequired: "Mahsulot nomi kiritilishi shart", uomRequired: "O'lchov birligi tanlanishi shart",
  },

  products: {
    variantTag: "variant",
    typeAll: "Hammasi", product: "Mahsulot", service: "Xizmat",
    cols: { category: "Papka", uom: "OB", sku: "SKU", costPrice: "Tannarx", avgCost: "O'rt. tannarx", salePrice: "Sotuv narxi", stock: "Qoldiq", description: "Tavsif", createdAt: "Yaratilgan", updatedAt: "Yangilangan", isActive: "Holat" },
    active: "Faol", inactive: "Faol emas",
    searchPlaceholder: "Qidirish...", colsMenuTitle: "Ustunlarni sozlash", colsMenu: "Ustunlar", colsAll: "Hammasi", colsDefault: "Standart",
    folders: "Papkalar", newFolder: "Yangi papka", allFolders: "Hammasi", noFolders: "Papka yo'q", mobileAllFolders: "Hammasi (papka)",
    resizeHint: "Sudrab kengligini o'zgartiring (qayta ishlash uchun ikki marta bosing)",
    thName: "Nomi", notFound: "Mahsulot topilmadi", createHint: "Birinchi mahsulot yoki xizmatni qo'shing", inactiveBadge: "Nofaol", stockLabel: "Qoldiq",
    uomRequired: "O'lchov birligi tanlang", editTitle: "Tahrirlash —", newProductTitle: "+ Yangi mahsulot", newServiceTitle: "+ Yangi xizmat",
    nameLabel: "Nomi", productNamePlaceholder: "Mahsulot nomi", serviceNamePlaceholder: "Xizmat nomi",
    skuLabel: "SKU / Kod", uomLabel: "O'lchov birligi", select: "Tanlang...",
    folderLabel: "Papka", noFolder: "Papkasiz", salePrice: "Sotuv narxi", costPriceLabel: "Tan narxi", descLabel: "Tavsif", optional: "Ixtiyoriy...",
    activeCheck: "Faol", cancel: "Bekor", save: "Saqlash", add: "Qo'shish", saving: "Saqlanmoqda...",
    folderEditTitle: "Papkani tahrirlash", folderNamePlaceholder: "Papka nomi", parentFolder: "Yuqori papka", rootFolder: "Asosiy papka",
    deleteTitle: "O'chirishni tasdiqlang", deleteText: "ni o'chirishni tasdiqlaysizmi? Bu amalni qaytarib bo'lmaydi.", delete: "O'chirish", deleting: "O'chirilmoqda...",
    saved: "Yangilandi", added: "Qo'shildi", folderSaved: "Papka yangilandi", folderAdded: "Papka qo'shildi", deleted: "O'chirildi", folderDeleted: "Papka o'chirildi", error: "Xato yuz berdi",
  },

  files: {
    empty: "Hali fayl yuklanmagan", fileName: "Fayl", uploading: "Yuklanmoqda...", upload: "Fayl yuklash",
    hint: "PDF, rasm, Word, Excel — maksimum 15MB", uploaded: "Yuklandi", uploadError: "Yuklashda xato",
  },

  smeta: {
    title: "Smeta", save: "Saqlash",
    companyName: "Korxona nomi", companyNamePh: "Korxona nomini kiriting",
    directorName: "Direktor F.I.O.", directorNamePh: "Familiya Ism Sharif",
    colName: "Ish nomi", colCountry: "Mamlakat", colUom: "O'lchov birligi",
    colQty: "Miqdor", colPrice: "Narx", colDeliveryCost: "Yetkazib berish",
    colVat: "QQS %", colTotal: "QQS bilan jami",
    total: "Итого", addRow: "Qator qo'shish",
    comment: "Izoh", commentPh: "Qo'shimcha izohlar...",
    validUntil: "Tijorat taklifi amal qilish muddati", validUntilLabel: "Muddati:",
    positions: "Tovarlar va xizmatlar", preview: "Ko'rish", close: "Yopish",
    download: "PDF yuklab olish", printPdf: "Chop etish / PDF", orderNum: "Buyurtma №",
    delivery: "Yetkazib berish qiymati", vat: "QQS", grandTotal: "Jami QQS bilan",
    shareLink: "Ulashish", linkCopied: "Nusxalandi!", linkError: "Havola yaroqsiz",
  },

  jobOrderForm: { dimW: "Eni", dimL: "Bo'yi",
    back: "Orqaga", title: "Zakaz",
    procStatus: { waiting: "Boshlanmagan", "in-progress": "Jarayonda", paused: "Pauzada", done: "Yakunlandi", problem: "Problemada" },
    durMin: "daq", durHour: "soat", distFromInstall: "O'rnatish joyidan masofa",
    select: "Tanlang...", search: "Qidirish...", clearSelection: "— Tanlovni tozalash —", notFound: "Topilmadi",
    nameRequired: "Nomi kiritilishi shart", customerAdded: "Mijoz qo'shildi", error: "Xato",
    newCustomer: "Yangi mijoz", nameLabel: "Nomi", customerNamePlaceholder: "Mijoz nomi", phone: "Telefon", cancel: "Bekor", add: "Qo'shish",
    docLoadError: "Hujjat yuklanmadi", cashboxRequired: "Kassa tanlanishi shart", amountInvalid: "Summa noto'g'ri",
    paymentReceived: "Pul qabul qilindi", movedToTrash: "Korzinaga o'tkazildi", customerRequired: "Mijoz tanlanishi shart",
    warehouseRequired: "Ombor tanlanishi shart", agreedInvalid: "Kelishilgan summa noto'g'ri",
    deadlineRequired: "Topshirish muddati kiritilishi shart", managerRequired: "Loyiha menejeri tanlanishi shart", agreedRequired: "Kelishilgan summa kiritilishi shart", descriptionRequired: "Tavsif kiritilishi shart",
    savedToast: "Saqlandi", createdToast: "Yaratildi", saveFirst: "Avval zakazni saqlang", delivered: "Yetkazib berildi", reverted: "Bekor qilindi",
    modalTitle: "Yangi zakaz", modalCreate: "Yaratish va davom etish", modalHint: "Saqlangach jarayonlar, rasxodlar va hisob-kitobni qo'shasiz.",
    fManager: "Loyiha menejeri", managerNone: "— Tanlanmagan —",
    fSketch: "Eskiz (rasm/PDF)", sketchUpload: "Eskiz yuklash",
    basicInfo: "Asosiy ma'lumotlar", moveLeft: "Chapga surish", moveRight: "O'ngga surish",
    toTrash: "Korzinaga", print: "Chop", printTitle: "Chop etish", deliver: "Yakunlandi", revertDelivery: "Yakunlashni bekor qilish", confirmAction: "Tasdiqlash", startAction: "Jarayonga o'tkazish", completeAction: "Yakunlash", statusChanged: "Status o'zgartirildi", startNeedProcess: "Avval jarayon (etap) qo'shing", startNeedResponsible: "Har bir jarayonga mas'ul shaxs biriktiring", save: "Saqlash",
    deliveredLockTitle: "Yetkazib berilgan zakazni tahrir qilish uchun avval bekor qiling",
    deliveredBanner: "Yetkazib berilgan. Tahrir qilish uchun avval yetkazib berishni bekor qiling.",
    invoiceTitle: "Shot-faktura yuborish kerak",
    invoiceText1: "Bu zakaz bo'yicha ish tugadi. Kontragent ", invoiceText2: "'ga ", invoiceText3: " shartnomasi bo'yicha shot-faktura yuborilishi kerak.",
    contractAmount: "Shartnoma summasi:",
    fNumber: "Raqam", fDate: "Sana", fCustomer: "Mijoz", customerPlaceholder: "Mijoz...", newCustomerTitle: "Yangi mijoz qo'shish",
    fContract: "Shartnoma", noContract: "— Shartnomasiz —", fAgreedPrice: "Kelishilgan summa", fCurrency: "Valyuta", fDeadline: "Topshirish muddati",
    fWarehouse: "Ombor (xomashyo)", fFolder: "Papka", noFolder: "— Papkasiz —",
    fDescription: "Tavsif (nima ishlanadi)", fShortName: "Qisqa nom", shortNamePlaceholder: "Masalan: Oshxona mebeli", shortNameRequired: "Qisqa nom kiritilishi shart", sketchRequired: "Eskiz yuklash shart", descPlaceholder: "Stol, oshxona mebeli...",
    fLocation: "O'rnatish lokatsiyasi", fLocationHint: "— mijozdagi havola (Google Maps, Yandex)", openLink: "Havolani ochish", copyLink: "Nusxa olish", copied: "Nusxalandi",
    createdBy: "Yaratdi:", priceLabel: "Narx:", paidLabel: "To'lov:", debtLabel: "Qarz:", workedLabel: "Ishlandi:", receivePayment: "Pul qabul qilish",
    processes: "Jarayonlar", addProcess: "Jarayon", noProcesses: "Jarayonlar yo'q. \"+ Jarayon\" tugmasini bosing.",
    addProcessTitle: "Yangi jarayon", editProcessTitle: "Jarayonni tahrirlash", addProcessHint: "Bo'lim va ma'sulni tanlang", deptRequired: "Bo'lim tanlanishi shart",
    pDept: "Bo'lim", pResponsible: "Ma'sul", pStatus: "Holat", pLabor: "Mehnat", pAllocated: "Ajratilgan summa", pNote: "Izoh", pNotePlaceholder: "Izoh / maxsus ko'rsatma...", workedShort: "Ishlandi:", historyTitle: "Vaqt tarixi", calLoad: "zakaz", calBusy: "band", historyEmpty: "Hali harakat yo'q", fromProposal: "Bu zakaz taklifdan yaratilgan:", viewProposal: "Taklifni ko'rish", proposalTitle: "Taklif", prDate: "Sana", prCustomer: "Mijoz", prAssignee: "Biriktirilgan xodim", prCreatedBy: "Yaratdi", prDescription: "Tavsif", prNote: "Izoh", prFiles: "Fayllar",
    trackStart: "Boshla", trackPause: "Pauza", trackDone: "Tugat", trackProblem: "Problema", trackResume: "Davom",
    materials: "Rasxodlar (xomashyo)", addRow: "Qator", noMaterials: "Rasxod yo'q. \"Qator\" tugmasini bosing.",
    mProduct: "Mahsulot", mQty: "Miqdor", mUom: "OB", mCost: "Tannarx", mSum: "Summa", mProcess: "Jarayon",
    stockLeft: "Qoldiq",
    selectVariant: "Variant tanlang",
    uomPlaceholder: "dona", costFromProductTitle: "Mahsulot kartasidan olingan tannarx", costOwnTitle: "Bu zakaz uchun tannarx", totalExpense: "Jami rasxod",
    files: "Fayllar va loyihalar",
    totalsTitle: "Yakuniy hisob", tAgreed: "Kelishilgan summa", tMaterials: "Xomashyo", tLabor: "Mehnat", tTotalCost: "Jami tannarx", tOtherExpenses: "Boshqa xarajatlar", otherExpenses: "Boshqa xarajatlar", addExpense: "Xarajat qo'shish", noExpenses: "Xarajat yo'q", expCashbox: "Kassa", expCashboxHint: "Faqat zakaz valyutasidagi ({cur}) kassalar", expCashboxRequired: "Kassa tanlang", expAmount: "Summa", expAmountRequired: "Summani kiriting", expNote: "Izoh", expNotePlaceholder: "Xarajat tavsifi…", expAdded: "Xarajat qo'shildi", expDeleted: "Xarajat o'chirildi", tProfit: "Foyda",
    totalsHint: "Saqlangach haqiqiy tannarx (FIFO/o'rtacha) yoziladi va foyda aniq bo'ladi.",
    freezeAction: "Muzlatish", unfreezeAction: "Davom ettirish",
    freezeTitle: "Zakazni muzlatish (pauza)", freezeHint: "Muzlatilganda muddat uzaytiriladi. Davom ettirishni bossangiz, muddat o'sha qadar o'tgan kun miqdorida qaytarilmaydi.",
    freezeUntilLabel: "Qachon davom ettiriladi (sana)",
    freezeExtendInfo: "Muddat {days} kun uzaytiriladi.",
    freezeConfirm: "Muzlatish", freezeDateRequired: "Davom etish sanasi kiritilishi shart",
    freezeSuccess: "Zakaz muzlatildi", unfreezeSuccess: "Zakaz davom ettirildi",
    frozenBanner: "Muzlatilgan (pauza)", frozenFrom: "dan:", frozenUntil: "gacha:",
    deleteTitle: "Korzinaga o'tkazish", deleteText: "Zakaz korzinaga o'tkaziladi. Xomashyo qoldig'i qaytariladi.",
    deleteTextInvoice: " Avtomatik faktura ham o'chiriladi va mijoz balansi qaytariladi.",
    payTitle: "Pul qabul qilish", remainingDebt: "Qoldiq qarz:", cashbox: "Kassa", noCashbox: "valyutasidagi kassa topilmadi",
    amount: "Summa", payNote: "Izoh", optional: "Ixtiyoriy...", receive: "Qabul qilish",
  },

  proposals: {
    title: "Tijorat taklifi", countSuffix: "ta", new: "Taklif", newTitle: "Yangi taklif", editTitle: "Taklifni tahrirlash", colNumber: "Raqam", colDate: "Sana", colCustomer: "Mijoz", colDescription: "Tavsif", colAmount: "Summa", colAssignee: "Xodim", colCreatedBy: "Yaratdi",
    searchPlaceholder: "Raqam, mijoz, tavsif...", notFound: "Taklif topilmadi", loadError: "Yuklashda xato",
    resizeHint: "Sudrab kengligini o'zgartiring", backToList: "Ro'yxatga qaytish",
    emptyTitle: "Taklif tanlanmagan", emptyHint: "Chapdan tanlang yoki yangi yarating",
    wonToast: "Zakaz yaratildi! Zakazlar bo'limidan ko'rishingiz mumkin.",
    tabs: { open: "Ochiq", won: "Yutdi", lost: "Rad" },
    statWon: "yutdi", statLost: "rad", statOpen: "ochiq",
    status: { new: "Yangi", "in-discussion": "Muhokamada", won: "Yutdi (zakaz)", lost: "Rad etildi" },
    customerSelect: "Mijoz tanlang...", search: "Qidirish...", searchEmpty: "Topilmadi", clearSelection: "Tanlovni tozalash", fAssignee: "Biriktirilgan xodim", assigneePlaceholder: "Xodim tanlang...", assigneeHint: "Belgilangan xodim o'z sahifasida (Ishlarim) boshladim/tugatdim bosadi", fManager: "Mas'ul (Dogovor)", managerPlaceholder: "Admin yoki loyiha menejeri...", managerHint: "Dogovor shu foydalanuvchiga bog'lanadi", workStatus: { waiting: "Boshlanmagan", "in-progress": "Jarayonda", done: "Tugatildi" },
    docLoadError: "Hujjat yuklanmadi", customerRequired: "Mijoz tanlanishi shart",
    savedToast: "Saqlandi", createdToast: "Yaratildi", error: "Xato",
    warehouseRequired: "Avval ombor tanlang", orderCreated: "Zakaz yaratildi!",
    markedLost: "Rad etildi deb belgilandi", deleteConfirm: "Bu taklifni o'chirasizmi?", deletedToast: "O'chirildi",
    wonBannerTitle: "Zakaz yaratilgan", wonBannerText1: "Bu taklif yutuq sifatida belgilangan va Zakaz №",
    wonBannerText2: "'ga aylantirilgan.", openOrder: "Zakazni ochish",
    lostBannerTitle: "Rad etilgan taklif", reasonLabel: "Sabab:",
    delete: "O'chirish", rejected: "Rad etildi", convertToOrder: "Zakazga aylantirish", cancel: "Bekor", save: "Saqlash",
    fNumber: "Raqam", fDate: "Sana", fStatus: "Holat", fCurrency: "Valyuta", fCustomer: "Mijoz",
    fAgreedPrice: "Kelishilgan summa", fWarehouse: "Ombor (zakaz uchun)", notSelected: "— Tanlanmagan —",
    fDescription: "Tavsif (nima ishlanadi)", descPlaceholder: "Mijoz dizayni / loyihasi tavsifi...",
    fAdvance: "Avans (bron) summasi", advancePaid: "Avans to'langan", fNote: "Izoh", optional: "Ixtiyoriy...", fFiles: "Fayllar (eskiz/rasm/hujjat)", createdBy: "Yaratdi:",
    lostModalTitle: "Taklifni rad etish", lostReasonLabel: "Sabab (ixtiyoriy):", lostReasonPlaceholder: "Mijoz qaror qildi...",
    winModalTitle: "Zakazga aylantirish",
    winModalText: "Yangi zakaz (JobOrder) yaratiladi va bu taklifga bog'lanadi. Jarayonlar va materiallar zakaz ichida qo'shiladi.",
    warehouseRequiredLabel: "Ombor *", selectPlaceholder: "Tanlang...", createOrder: "Zakaz yaratish",
  },

  jobOrders: { colsReorderHint: "Surib tartibini o'zgartiring",
    title: "Zakazlar",
    subtitle: "Mijoz buyurtmasi: ishlab chiqarish → yetkazib berish",
    searchPlaceholder: "Raqam, mijoz, tavsif...",
    newOrder: "Zakaz",
    notFound: "Zakaz topilmadi",
    createHint: "Yangi zakaz yarating",
    loadError: "Yuklashda xato",
    thNumber: "Raqam",
    thActions: "Amallar",
    filterAll: "Hammasi",
    tabAll: "Hammasi", tabFrozen: "Muzlatilgan", overdue: "Muddat o'tib ketdi", costOverrun: "Tannarx oshib ketdi",
    status: { new: "Yangi", confirmed: "Tasdiqlangan", "in-progress": "Jarayonda", delivered: "Yakunlangan", cancelled: "Bekor qilindi" },
    cols: { sketch: "Eskiz", shortName: "Qisqa nom",
      date: "Sana", customer: "Mijoz", description: "Tavsif", folder: "Papka", processes: "Jarayonlar",
      manager: "Loyiha menejeri", agreedPrice: "Kelishilgan", paid: "To'langan", debt: "Qarz",
      totalCost: "Tannarx", materialsCost: "Xomashyo", laborCost: "Mehnat",
      profit: "Foyda", status: "Status", createdBy: "Yaratdi", expectedDeliveryDate: "Topshirish",
      deliveryDate: "Yetkazildi sana", currency: "Valyuta",
    },
    colsMenu: "Ustunlar", colsMenuTitle: "Ustunlarni sozlash", colsAll: "Hammasi", colsDefault: "Standart",
    statAgreed: "Jami summa", filterCustomer: "Mijoz", filterAllCustomers: "Barcha mijozlar", filterAllManagers: "Barcha menejerlar", filterYear: "Yil", filterPeriod: "Davr", filterWholeYear: "Butun yil", filterAllMonths: "Barcha oylar", filterClear: "Tozalash", statPaid: "To'langan", statDebt: "Qarz", statCount: "Zakazlar soni",
    folders: "Papkalar", newFolder: "Yangi papka", allFolders: "Hammasi", noFolder: "Papkasiz",
    noFolders: "Papka yo'q", mobileAllFolders: "Hammasi (papka)",
    folderEdit: "Papkani tahrirlash", folderNameLabel: "Nomi", folderNamePlaceholder: "Papka nomi",
    parentFolder: "Yuqori papka", rootFolder: "Asosiy papka",
    folderDeleteTitle: "Papkani o'chirish",
    folderDeleteText: "papkasi o'chiriladi. Ichidagi zakazlar saqlanadi (faqat papka bog'lanishi olib tashlanadi).",
    trashTitle: "Korzinaga o'tkazish",
    trashText: "zakaz korzinaga o'tkaziladi. Xomashyo qoldig'i qaytariladi.",
    cancel: "Bekor", save: "Saqlash", add: "Qo'shish", delete: "O'chirish", toTrash: "Korzinaga",
    saved: "Yangilandi", addedToast: "Qo'shildi", deletedToast: "O'chirildi", movedToTrash: "Korzinaga o'tkazildi", error: "Xato",
    resizeHint: "Sudrab kengligini o'zgartiring (qayta tiklash uchun ikki marta bosing)",
  },

  // Auth
  login: "Kirish",
  register: "Ro'yxatdan o'tish",
  logout: "Chiqish",
  email: "Email",
  phone: "Telefon",
  password: "Parol",
  confirmPassword: "Parolni tasdiqlang",
  forgotPassword: "Parolni unutdingizmi?",

  // Register
  createOrganization: "Tashkilot yaratish",
  organizationName: "Tashkilot nomi",
  organizationType: "Tashkilot turi",
  yourName: "Ismingiz",
  yourEmail: "Email manzilingiz",
  yourPassword: "Parol",
  alreadyHaveAccount: "Akkauntingiz bormi?",
  dontHaveAccount: "Akkauntingiz yo'qmi?",

  // Org types
  retail: "Chakana savdo",
  wholesale: "Ulgurji savdo",
  manufacturing: "Ishlab chiqarish",
  service: "Xizmat ko'rsatish",
  other: "Boshqa",

  // Dashboard
  dashboard: "Bosh sahifa",
  welcome: "Xush kelibsiz",

  // Common
  save: "Saqlash",
  cancel: "Bekor qilish",
  delete: "O'chirish",
  edit: "Tahrirlash",
  add: "Qo'shish",
  search: "Qidirish",
  loading: "Yuklanmoqda...",
  error: "Xato",
  success: "Muvaffaqiyatli",

  // Errors
  required: "Bu maydon to'ldirilishi shart",
  invalidEmail: "Email manzili noto'g'ri",
  passwordMin: "Parol kamida 4 ta belgidan iborat bo'lishi kerak",
  passwordMatch: "Parollar mos kelmadi",

  // Login page
  login_page: {
    server: "Kompaniya kodi",
    serverPlaceholder: "masalan, miko",
    checking: "tekshirilmoqda...",
    serverNotFound: "Server topilmadi",
    serverNotFoundHint: "«{slug}» nomli server mavjud emas. Manzilni tekshiring.",
    phonePlaceholder: "90 123 45 67",
    passwordPlaceholder: "••••••",
    submitting: "Kirilmoqda...",
    forgotPassword: "Parolni unutdingizmi?",
    rights: "© 2025 CRM Line. Barcha huquqlar himoyalangan.",
  },

  // Sales module (list pages: orders / invoices / returns)
  sales: {
    dateLocale: "uz-UZ",
    types: {
      orders:   { label: "Buyurtmalar", subtitle: "Mijoz buyurtmalari", docLabel: "Sotuv buyurtmasi" },
      invoices: { label: "Sotuvlar",    subtitle: "Sotuv fakturalari (hisob-fakturalar)", docLabel: "Sotuv fakturasi" },
      returns:  { label: "Qaytarishlar", subtitle: "Mijozdan tovar qaytarish", docLabel: "Sotuv qaytarish" },
    },
    statusDraft: "Qoralama",
    statusConfirmed: "Tasdiqlangan",
    searchPlaceholder: "Raqam yoki mijoz...",
    notFound: "Hujjat topilmadi",
    createHint: "Yangi hujjat yarating",
    thNumber: "Raqam",
    thDate: "Sana",
    thCustomer: "Mijoz",
    thLines: "Qatorlar",
    thSum: "Summa",
    thStatus: "Status",
    thVerified: "Verified",
    thState: "Holat",
    thCurrency: "Valyuta", thNote: "Izoh",
    thActions: "Amallar",
    linesSuffix: "ta",
    view: "Ko'rish",
    edit: "Tahrirlash",
    deleteConfirmTitle: "O'chirishni tasdiqlang",
    deleteConfirmText: "hujjati o'chiriladi.",
    deleteInvoiceExtra: " Qoldiq va mijoz qarzi qaytariladi.",
    cancel: "Bekor",
    deleteBtn: "O'chirish",
    deleted: "O'chirildi",
    loadError: "Yuklashda xato",
    error: "Xato",
  },

  // Purchases module (list pages: orders / receipts / returns)
  purchases: {
    dateLocale: "uz-UZ",
    types: {
      orders:   { label: "Zayavkalar", subtitle: "Ta'minotchiga buyurtmalar hujjatlari", docLabel: "Xarid buyurtmasi" },
      receipts: { label: "Kirimlar",   subtitle: "Ta'minotchi shot-fakturalari (kirimlar)", docLabel: "Kirim hujjati" },
      returns:  { label: "Qaytarishlar", subtitle: "Ta'minotchiga tovar qaytarish", docLabel: "Xarid qaytarish" },
    },
    statusDraft: "Qoralama",
    statusConfirmed: "Tasdiqlangan",
    searchPlaceholder: "Raqam yoki ta'minotchi...",
    notFound: "Hujjat topilmadi",
    createHint: "Yangi hujjat yarating",
    thNumber: "Raqam",
    thDate: "Sana",
    thSupplier: "Ta'minotchi",
    thLines: "Qatorlar",
    thSum: "Summa",
    thStatus: "Status",
    thVerified: "Verified",
    thState: "Holat",
   thCurrency: "Valyuta", thWarehouse: "Ombor", thNote: "Izoh", thPayment: "To'lov", payCash: "Naqd", payCredit: "Qarz",
    thActions: "Amallar",
    linesSuffix: "ta",
    view: "Ko'rish",
    edit: "Tahrirlash",
    deleteConfirmTitle: "O'chirishni tasdiqlang",
    deleteConfirmText: "hujjati o'chiriladi.",
    cancel: "Bekor",
    deleteBtn: "O'chirish",
    deleted: "O'chirildi",
    loadError: "Yuklashda xato",
    error: "Xato",
  },

  // Sales form page (SalesFormPage.jsx — orders/invoices/returns editor)
  salesForm: {
    docTypes: {
      orders: "Sotuv buyurtmasi",
      invoices: "Sotuv fakturasi",
      returns: "Sotuv qaytarish",
    },
    back: "Orqaga",
    delete: "O'chirish",
    print: "Chop etish",
    copy: "Nusxa",
    cancel: "Bekor",
    save: "Saqlash",
    add: "Qo'shish",
    error: "Xato",
    statusManage: "Statuslarni boshqarish",
    statusEdit: "Tahrirlash",
    statusNew: "Yangi status",
    statusNamePlaceholder: "Status nomi...",
    statusAdd: "Qo'shish",
    productSearchPlaceholder: "Mahsulot qidirish...",
    productNotFoundCreate: "Topilmadi. Yangi tovarni",
    productNotFoundCreate2: "orqali yarating.",
    catalogEmpty: "Katalog bo'sh — + orqali tovar qo'shing",
    productTypeName: "Mahsulot nomini yozing...",
    notFound: "Topilmadi",
    searchPlaceholder: "Qidirish...",
    customerSelect: "Mijoz tanlang...",
    customerAdded: "Mijoz qo'shildi",
    newCustomer: "Yangi mijoz",
    nameRequired: "Nomi *",
    customerNamePlaceholder: "Mijoz nomi",
    phone: "Telefon",
    nameRequiredToast: "Nomi kiritilishi shart",
    warehouseSelect: "Ombor tanlang...",
    warehouseUpdated: "Yangilandi",
    warehouseAdded: "Ombor qo'shildi",
    editWarehouse: "Omborni tahrirlash",
    newWarehouse: "Yangi ombor",
    warehouseNamePlaceholder: "Ombor nomi",
    currency: "Valyuta",
    baseLabel: "asosiy",
    uploaded: "Yuklandi",
    uploadError: "Yuklashda xato",
    file: "Fayl",
    uploading: "Yuklanmoqda...",
    uploadFile: "Fayl yuklash",
    noFiles: "Hali fayl yuklanmagan",
    fileHint: "PDF, rasm, Word, Excel — maksimum 15MB",
    productAdded: "Tovar qo'shildi",
    newProduct: "Yangi tovar",
    productNamePlaceholder: "Tovar nomi",
    costPrice: "Tannarx",
    docLoadError: "Hujjat yuklanmadi",
    customerRequired: "Mijoz tanlanishi shart",
    warehouseRequired: "Ombor tanlanishi shart",
    deadlineRequired: "Topshirish muddati kiritilishi shart",
    managerRequired: "Loyiha menejeri tanlanishi shart",
    agreedRequired: "Kelishilgan summa kiritilishi shart",
    descriptionRequired: "Tavsif kiritilishi shart",
    currencyRequired: "Valyuta tanlanishi shart",
    cashboxRequired: "Kassa tanlanishi shart",
    dateInvalid: "Sana noto'g'ri (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Yetkazib berish sanasi noto'g'ri (DD/MM/YYYY)",
    needQty: "Kamida bitta pozitsiyaga miqdor kiriting",
    saved: "Saqlandi",
    created: "Qo'shildi",
    copyNeedRow: "Nusxa olish uchun kamida bitta qator kerak",
    copyCreated: "Nusxa yaratildi",
    deleted: "O'chirildi",
    productAlready: "Bu mahsulot allaqachon qo'shilgan",
    dateLabel: "Sana:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    statusless: "Statussiz",
    verified: "Tasdiqlangan",
    counterparty: "Kontragent *",
    newCounterpartyTitle: "Yangi kontragent qo'shish",
    warehouse: "Sklad",
    editWarehouseTitle: "Skladni tahrirlash",
    newWarehouseTitle: "Yangi sklad qo'shish",
    currencyReq: "Valyuta *",
    payment: "To'lov",
    payCredit: "Nasiya (mijoz qarzdor)",
    payCreditHint: "Mijoz balansiga yoziladi — keyin Pul kirimi orqali to'lanadi.",
    payCash: "Naqd to'lov (kassaga tushadi)",
    payCashHint: "Summa darhol kassaga tushadi, mijoz balansiga ta'sir qilmaydi.",
    cashbox: "Kassa",
    selectPlaceholder: "Tanlang...",
    notSelected: "— Tanlanmagan —",
    arrivalDate: "Kelish sana",
    createInvoice: "Sotuv yaratish",
    customerReq: "Mijoz *",
    invoiceCreated: "Sotuv yaratildi (skladdan chiqarildi)",
    newCustomerTitle: "Yangi mijoz qo'shish",
    priceType: "Narx turi",
    priceTypeDefault: "Standart (1-narx)",
    cashboxBalance: "qoldiq",
    noCashbox: "\"{currency}\" valyutasidagi kassa topilmadi (yoki sizga biriktirilmagan)",
    tabItems: "Tovar va xizmatlar",
    tabFiles: "Fayllar",
    thName: "Nomi",
    thSells: "Sotiladi",
    thUom: "Birlik",
    uomSelect: "Birlik",
    uomRequired: "Har bir mahsulot uchun o'lchov birligini tanlang",
    overStock: "\"{name}\" omborda yetarli emas (mavjud: {qty} {uom})",
    thAvailable: "Mavjud",
    thPrice: "Narx",
    thDiscount: "Chegirma %",
    thSum: "Summa",
    thVatRate: "QQS stavka",
    thVatAmount: "QQS miqdori",
    thTotal: "Jami",
    newProductTitle: "Yangi tovar yaratish",
    total: "Jami summa",
    totalVat: "QQS",
    grandTotal: "Jami (QQS bilan)",
    note: "Izoh",
    notePlaceholder: "Izoh yoki qo'shimcha ma'lumot...",
    saleConfirmed: "Sotuv tasdiqlangan",
    saleConfirmedHint: "Mahsulot qoldig'i kamaydi va mijoz qarzi oshdi (+{amount}).",
    deleteConfirmTitle: "O'chirishni tasdiqlang",
    deleteConfirmText: "hujjati butunlay o'chiriladi.",
    partyLabel: "Mijoz",
  },

  // Purchase form page (PurchaseFormPage.jsx — orders/receipts/returns editor)
  purchaseForm: {
    docTypes: {
      orders: "Xarid buyurtmasi",
      receipts: "Kirim hujjati",
      returns: "Xarid qaytarish",
    },
    back: "Orqaga",
    delete: "O'chirish",
    save: "Saqlash",
    createReceipt: "Kirim yaratish",
    cancel: "Bekor",
    error: "Xato",
    // Status manager
    statusManage: "Statuslarni boshqarish",
    statusEdit: "Tahrirlash",
    statusNew: "Yangi status",
    statusNamePlaceholder: "Status nomi...",
    statusAdd: "Qo'shish",
    // Product search
    productSearchPlaceholder: "Mahsulot qidirish...",
    productNotFoundCreate: "Topilmadi. Yangi tovarni",
    productNotFoundCreate2: "orqali yarating.",
    catalogEmpty: "Katalog bo'sh — + orqali tovar qo'shing",
    productTypeName: "Mahsulot nomini yozing...",
    notFound: "Topilmadi",
    // Supplier picker + modal
    supplierSelect: "Ta'minotchi tanlang...",
    supplierAdded: "Ta'minotchi qo'shildi",
    newSupplier: "Yangi ta'minotchi",
    nameRequired: "Nomi *",
    supplierNamePlaceholder: "Ta'minotchi nomi",
    phone: "Telefon",
    // Warehouse picker + modal
    warehouseSelect: "Ombor tanlang...",
    warehouseUpdated: "Yangilandi",
    warehouseAdded: "Ombor qo'shildi",
    editWarehouse: "Omborni tahrirlash",
    newWarehouse: "Yangi ombor",
    warehouseNamePlaceholder: "Ombor nomi",
    nameRequiredToast: "Nomi kiritilishi shart",
    add: "Qo'shish",
    // Currency
    currency: "Valyuta",
    // Files
    uploadError: "Yuklashda xato",
    file: "Fayl",
    uploading: "Yuklanmoqda...",
    uploadFile: "Fayl yuklash",
    uploaded: "Yuklandi",
    noFiles: "Hali fayl yuklanmagan",
    fileHint: "PDF, rasm, Word, Excel — maksimum 15MB",
    // Product modal
    productAdded: "Tovar qo'shildi",
    newProduct: "Yangi tovar",
    productNamePlaceholder: "Tovar nomi",
    costPrice: "Tannarx",
    // Doc load / validation
    docLoadError: "Hujjat yuklanmadi",
    procLoadError: "Snabjeniya so'rovi yuklanmadi",
    productAlready: "Bu mahsulot allaqachon qo'shilgan",
    selectVariant: "Variant tanlang",
    variantRequired: "Variantli mahsulot uchun variant tanlang",
    supplierRequired: "Ta'minotchi tanlanishi shart", linkedProductsHint: "Faqat ushbu ta'minotchi tovarlarini ko'rsatyapti",
    warehouseRequired: "Ombor tanlanishi shart",
    currencyRequired: "Valyuta tanlanishi shart",
    cashboxRequired: "Kassa tanlanishi shart",
    dateInvalid: "Sana noto'g'ri (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Yetkazib berish sanasi noto'g'ri (DD/MM/YYYY)",
    needQty: "Kamida bitta pozitsiyaga miqdor kiriting",
    saved: "Saqlandi",
    created: "Qo'shildi",
    copyNeedRow: "Nusxa olish uchun kamida bitta qator kerak",
    copyCreated: "Nusxa yaratildi",
    receiptCreated: "Kirim yaratildi va skladga kiritildi",
    deleted: "O'chirildi",
    // Header / form
    statusless: "Status yo'q",
    dateLabel: "Sana:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    verified: "Tasdiqlandi",
    verifiedLockTitle: "Tasdiqlangan hujjatni faqat admin qaytara oladi",
    counterparty: "Kontragent *",
    newCounterpartyTitle: "Yangi kontragent qo'shish",
    editWarehouseTitle: "Omborxonani tahrirlash",
    newWarehouseTitle: "Yangi omborxona qo'shish",
    arrivalDate: "Kelish sana",
    dateOnlyPlaceholder: "DD/MM/YYYY",
    currencyReq: "Valyuta *",
    paymentMode: "To'lov shakli",
    payDebt: "Qarz (ta'minotchi qarzdor)",
    payDebtHint: "Ta'minotchi balansi ko'tariladi — keyin Pul chiqimi orqali to'lanadi.",
    payCash: "Naqd (kassadan to'lanadi)",
    payCashHint: "Kassadan summa darhol chiqadi, ta'minotchi balansiga ta'sir qilmaydi.",
    cashbox: "Kassa",
    selectPlaceholder: "Tanlang...",
    noCashbox: "\"{currency}\" valyutasidagi kassa topilmadi (yoki sizga biriktirilmagan)",
      convRate: "Konvertatsiya kursi", convEdit: "Kursni tahrirlash", convDeducted: "Kassadan yechiladi",
    // Items table
    thName: "Nomi",
    thNeed: "Kerak",
    thReceived: "Olindi",
    thOrdered: "Buyurtma",
    thAvailable: "Mavjud",
    thPrice: "Narx",
    thDiscount: "Chegirma %",
    thSum: "Summa",
    newProductTitle: "Yangi tovar yaratish",
    overReceiveError: "Kerakli miqdordan ortiq olib bo'lmaydi",
    excludeFromReceipt: "Bu Kirimga kiritmaslik",
    total: "Jami",
    note: "Izoh",
    notePlaceholder: "Izoh yoki qo'shimcha ma'lumot...",
    receiptConfirmed: "Kirim tasdiqlangan",
    receiptConfirmedHint: "Mahsulot qoldig'i yangilandi va ta'minotchi balansi oshdi (+{amount}).",
    deleteConfirmTitle: "O'chirishni tasdiqlang",
    deleteConfirmText: "hujjati butunlay o'chiriladi.",
    partyLabel: "Ta'minotchi",
    warehouse: "Omborxona",
    warehouseNone: "— Tanlanmagan —",
    baseLabel: "asosiy",
    print: "Chop etish",
    copy: "Nusxa",
    tabItems: "Tovar va xizmatlar",
    tabFiles: "Hujjatlar",
    searchPlaceholder: "Qidirish...",
    docNumberDash: "—",
    addRow: "Qator qo'shish",
  },

  // Procurement editor (ProcurementEditor.jsx) + form-page chrome
  procEditor: {
    pageTitle: "Snabjeniya so'rovi",
    back: "Orqaga",
    lockedTitle: "Hujjat tahrirlanmaydi",
    lockedText: "Bu so'rov o'tgan kunga tegishli ({date}). O'tgan kunlardagi hujjatlar faqat ko'rib chiqish uchun ochiq.",
    toTrash: "Korzinaga",
    createReceipt: "Kirim yaratish",
    close: "Yopish",
    cancel: "Bekor",
    save: "Saqlash",
    number: "Raqam",
    date: "Sana",
    needBy: "Topshirish muddati",
    assignee: "Snabjenist (ma'sul)",
    statusPrefix: "Holat:",
    receiptsLinked: "· {n} ta kirim bog'langan",
    overdue: "Muddati o'tgan",
    neededProducts: "Kerakli mahsulotlar",
    rowsCount: "{n} ta qator",
    thProduct: "Mahsulot",
    thImage: "Rasm",
    thNeed: "Kerak",
    thUom: "Birlik",
    thReceived: "Olingan",
    thRemaining: "Qoldiq",
    thNote: "Izoh",
    uomPlaceholder: "dona",
    optional: "Ixtiyoriy",
    addRow: "Qator qo'shish",
    note: "Izoh",
    notePlaceholder: "Ixtiyoriy...",
    attachments: "Ilova (rasm/fayl)",
    trashModalTitle: "Korzinaga o'tkazish",
    trashModalText: "So'rov korzinaga o'tkaziladi. Bog'langan kirim hujjatlari saqlanib qoladi.",
    needRow: "Kamida bitta qator kiriting", assigneeRequired: "Snabjenist tanlanishi shart",
    saved: "Saqlandi",
    created: "Yaratildi",
    movedToTrash: "Korzinaga o'tkazildi",
    loadDocError: "Hujjat yuklanmadi",
    error: "Xato",
  },

  // Procurement (Snabjeniya) list
  procurement: {
    dateLocale: "uz-UZ",
    title: "Snabjeniya",
    countSuffix: "ta so'rov",
    newRequestShort: "So'rov",
    newRequestTitle: "Yangi so'rov",
    searchPlaceholder: "Raqam, izoh...",
    notFound: "So'rov topilmadi",
    unassigned: "— belgilanmagan",
    positionsSuffix: "ta pozitsiya", boughtOf: "{total} dan {bought} olindi", uploadError: "Yuklashda xato", imgZoom: "Kattalashtirish", selectVariant: "Variant tanlang",  thDate: "Sana", thProduct: "Mahsulot", thNeed: "Kerak", thUom: "Birlik", thNote: "Izoh", optional: "Ixtiyoriy...", thBuy: "Olish", addRow: "Qator qo'shish", flatHint: "Pastdagi qator orqali mahsulot qo'shing — u bugungi zayavkaga yoziladi. Muddati o'tgan qatorlar qizil.", error: "Xato",
    resizeHint: "Sudrab kengligini o'zgartiring (qayta tiklash uchun ikki marta bosing)",
    backToList: "Ro'yxatga qaytish",
    newDocTitle: "Yangi snabjeniya so'rovi",
    emptyTitle: "So'rov tanlanmagan",
    emptyHint: "Chap tomondan ro'yxatdan tanlang yoki yangi so'rov yarating",
    loadError: "Yuklashda xato",
    tabs: {
      overdue: "Muddati o'tgan",
      new: "Yangi",
      partial: "Qisman",
      fulfilled: "Bajardi",
    },
    status: {
      new: "Yangi",
      partial: "Qisman",
      fulfilled: "Bajarildi",
      cancelled: "Bekor",
    },
  },

  // Dashboard home (Bosh sahifa)
  dashboardHome: {
    dateLocale: "uz-UZ",
    greeting: "Xush kelibsiz, {name}!",
    today: "Bugun {date}",
    noAccess: "Ko'rsatkichlarni ko'rish uchun ruxsat yo'q yoki ma'lumot yuklanmadi.",
    noWidgets: "Sizning rolingiz uchun bosh sahifada ko'rsatkichlar yo'q. Chap menyudan bo'limni tanlang.",
    kpiTodaySales: "Bugungi sotuv",
    kpiMonthSales: "Oylik sotuv",
    kpiMonthProfit: "Oylik foyda",
    kpiInventory: "Ombor qiymati",
    trendTitle: "Sotuv dinamikasi",
    trendPeriod: "14 kun",
    debtTitle: "Qarzdorlik",
    debtTheyOwe: "Debitor qarzdor",
    debtWeOwe: "Kreditor qarzdorlar",
    debtNet: "Sof daromad",
    counterparties: "Kontragentlar",
    cashTitle: "Kassa qoldiqlari",
    cashEmpty: "Kassa yo'q",
    topDebtorsTitle: "Eng katta qarzdorlar",
    noDebtors: "Qarzdor yo'q", debtorThresholdHint: "Minimal summa (meyorni belgilash)",
    viewAll: "Barchasi",
    recentTitle: "So'nggi operatsiyalar",
    recentEmpty: "Hali operatsiyalar yo'q",
    recent: {
      salesInvoice: "Sotuv",
      purchaseReceipt: "Kirim",
      paymentIn: "To'lov kirim",
      paymentOut: "To'lov chiqim",
    },
  },

  // Sidebar navigation (keyed by NAV_ITEMS key)
  nav: { education: "Ta’lim", "education-groups": "Ta’lim: guruhlar va sozlamalar", integrations: "Integratsiyalar",
    dashboard: "Bosh sahifa",
    contacts: "Kontaktlar",
    tasks: "Vazifalar",
    inbox: "Xabarlar",
    calls: "Qo'ng'iroqlar",
    reviews: "Sharhlar",
    funnels: "Varonkalar",
    purchases: "Tovar va xizmatlar xaridi",
    "purchases-procurement": "Snabjeniya",
    "purchases-orders": "Zayavkalar",
    "purchases-receipts": "Kirimlar",
    "purchases-returns": "Qaytarishlar",
    sales: "Tovar va xizmatlar sotuvi",
    "sales-orders": "Buyurtmalar",
    "sales-invoices": "Sotuvlar",
    "sales-returns": "Qaytarishlar",
    "job-orders": "Zakazlar",
    "job-orders-proposals": "Tijorat taklifi",
    "job-orders-orders": "Zakazlar",
    inventory: "Tovar va xizmatlar",
    counterparties: "Kontragentlar",
    "counterparties-list": "Kontragentlar",
    "counterparties-contracts": "Shartnomalar",
    "counterparties-aktsverka": "Akt-sverka",
    sklad: "Ombor",
    "sklad-balances": "Tovar qoldiqlari",
    "sklad-valuation": "Tovarlar tan narxlari",
    "sklad-transfers": "Omborlar o'rtasida tovar ko'chirish",
    "sklad-warehouses": "Omborxonalar",
    "sklad-lowstock": "Kam qoldiq",
    finance: "Moliya bo'limi",
    "finance-balance": "Korxona balansi",
    "finance-pnl": "Foyda va zarar",
    "finance-analysis": "Analiz",
    "finance-payments": "To'lovlar", "finance-requests": "So'rovlar",
    "finance-debts": "Qarzlar",
    "finance-conversions": "Konvertatsiya",
    "finance-cashboxes": "Kassalar",
    "finance-scheduled": "Majburiy to'lovlar",
    "finance-assets": "Aktivlar",
    production: "Ishlab chiqarish",
    "production-orders": "Ishlab chiqarish",
    "production-packaging": "Upakovka",
    "production-bom": "Retseptlar (BOM)",
  
    analytics: "Analitika",
  },

  analysis: {
    title: "Analiz",
    subtitle: "Oylar kesimida kelgan pulning rasxod normalariga taqsimlanishi",
    income: "Kelgan pul",
    allocated: "Ajratilgan",
    spent: "Sarflangan",
    available: "Mavjud",
    carryIn: "Oldingi oydan",
    normSum: "Normalar yig'indisi",
    normHint: "Normalar yig'indisi 100% bo'lishi tavsiya etiladi.",
    empty: "Rasxod kategoriyalari yo'q.",
    remain: "Qoldiq",
    over: "Oshib ketdi",
    toNextMonth: "Kelasi oyga o'tadi",
    loadError: "Ma'lumotni yuklashda xatolik",
    error: "Xatolik yuz berdi",
    date: "Sana",
    total: "Jami",
    noSpend: "Bu oyda rasxod qilinmagan.",
    spentTotal: "Jami sarflangan",
    allocatedRow: "Mavjud (norma)",
    carryShort: "(o'tgan oy)",
    diffRow: "Farq → keyingi oyga",
    diffHint: "Farq musbat — qoldiq keyingi oyga o'tadi; manfiy — byudjet oshib ketdi.",
    readonly: "Faqat o'qish uchun",
    noCounterparty: "Kontragentsiz",
    unitK: "ming", unitM: "mln", unitB: "mlrd",
    configNorms: "Foizlarni sozlash",
    normsTitle: "Kategoriya foizlari (norma)",
    normsHint: "Har bir kategoriyaga oylik kelgan puldan necha foiz ajratilishini belgilang.",
    normsSaved: "Foizlar saqlandi",
    byCategoryTitle: "Kategoriyalar bo'yicha (oylik)",
    colName: "Nomi",
    colSumma: "Summa",
    colNorma: "Norma",
    colReal: "Real %",
    colResult: "Natija",
    resultHint: "Natija = Norma − Real. Musbat (yashil) — normadan kam sarflandi; manfiy (qizil) — oshib ketdi.",
    save: "Saqlash",
    cancel: "Bekor",
  },

  // Account settings page
  account: {
    title: "Akkaunt sozlamalari",
    subtitle: "Shaxsiy ma'lumotlarni tahrirlash",
    personalInfo: "Shaxsiy ma'lumotlar",
    name: "Ism",
    email: "Email",
    emailHint: "(parol tiklash uchun)",
    emailPlaceholder: "example@mail.com",
    phone: "Telefon",
    phoneHint: "Telefon raqamni o'zgartirib bo'lmaydi",
    save: "Saqlash",
    saving: "Saqlanmoqda...",
    profileUpdated: "Profil yangilandi",
    genericError: "Xato yuz berdi",
    changePassword: "Parolni o'zgartirish",
    currentPassword: "Joriy parol",
    newPassword: "Yangi parol",
    confirmPassword: "Yangi parolni tasdiqlang",
    passwordMismatch: "Yangi parollar mos kelmaydi",
    passwordTooShort: "Parol kamida 4 ta belgi bo'lishi kerak",
    passwordChanged: "Parol muvaffaqiyatli o'zgartirildi",
    changePasswordBtn: "Parolni o'zgartirish",
    namePlaceholder: "Ism familiya",
    role: "Rol",
    hide: "Yopish",
    show: "Ochish",
  },

  // Settings page
  settings: {
    title: "Sozlamalar",
    back: "Orqaga",
    tabs: {
      general: "Umumiy sozlamalar",
      branding: "Brending",
      modules: "Menyu",
      users: "Foydalanuvchilar",
      workers: "Ishchilar",
      roles: "Rollar",
      currencies: "Valyutalar",
      uom: "O'lchov birliklari",
      company: "Korxona",
      assets: "Aktivlar",
      trash: "Korzina",
      funnels: "Varonkalar",
      tasks: "Vazifalar",
      "deal-sources": "Savdo manbalari",
      "close-reasons": "Yopish sabablari",
      "lead-forms": "Formalar",
      goals: "Maqsadlar",
      integrations: "Integratsiyalar",
      inbox: "Xabarlar",
      atc: "Telefoniya (ATC)",
      "ai-calls": "Qo'ng'iroqlar AI tahlili",
      "api-keys": "API kalitlar",
      "google-sheets": "Google Jadvallar",
      "owner-bot": "Rahbar boti",
      education: "Ta’lim",
      "lead-fields": "Lid maydonlari",
      audit: "Audit jurnali",
    },
    groups: {
      team: "Xodimlar",
      general: "Umumiy", crm: "CRM", channels: "Integratsiyalar", system: "Tizim",
    },
    atc: {
      title: "ATC / IP-ATS integratsiyasi",
      subtitle: "Mediateka (Sarkor Telekom), Sipuni yoki Utel ATC webhook sozlamalari",
      connected: "Ulangan",
      notConnected: "Ulanmagan",
      provider: "ATC provayder",
      callBtn: "\"Qo'ng'iroq qilish\" tugmasi",
      modeAtc: "Faqat ATC orqali",
      modePersonal: "Faqat shaxsiy telefondan",
      modeBoth: "Ikkalasi ham - xodim tanlaydi",
      callBtnHint: "Contacts, Lid va Qo'ng'iroqlar sahifalaridagi barcha \"Qo'ng'iroq qilish\" tugmalariga taalluqli. ATC ulanmagan bo'lsa, bu sozlamadan qat'i nazar har doim shaxsiy telefondan ishlaydi.",
      popupTitle: "Kiruvchi qo'ng'iroq bildirishnomasi (o'ng yuqori burchak) kimlarga ko'rinsin",
      popupHint: "Hech qaysisi tanlanmasa — hammaga ko'rinadi (standart). Egasi/admin har doim ko'radi.",
      popupNoRoles: "Maxsus rol yaratilmagan — hozircha bu sozlama hammaga taalluqli",
      crmToken: "CRM Token",
      tokenPlaceholder: "Maxfiy token kiriting...",
      tokenHint: "ATC webhook URL-ga qo'shiladi. Istalgan qiymat bo'lishi mumkin.",
      webhookTitle: "ATC-ga qo'yiladigan Webhook URL:",
      copied: "Nusxalandi!",
      copy: "Nusxalash",
      sipuniWebhookHint: "Sipuni kabinetida: Sozlamalar → API → «Событие звонка» (PBX Events) bo'limiga qo'ying.",
      utelDomain: "Utel domeni",
      utelDomainHint: "ATS subdomeni, masalan cc999 (manzil cc999.utel.uz).",
      utelEmail: "Utel email",
      utelPassword: "Utel paroli",
      utelPasswordHint: "Parol token olish uchun bir marta kerak; CRM da saqlanmaydi.",
      utelConnect: "Utelni ulash",
      utelReconnect: "Qayta ulash",
      utelConnecting: "Ulanmoqda…",
      utelConnectedTo: "Ulangan: {domain}",
      utelConnectedOk: "Utel ulandi",
      utelNeedConnect: "Avval Utelni ulang (kabinet logini va paroli).",
      utelCheck: "Ulanishni tekshirish",
      utelTokenOk: "Utel API ga kirish ishlayapti",
      utelTokenBad: "Utel tokenni qabul qilmadi: qayta ulang",
      utelWebhookFound: "Webhook Utelda ko'rsatilgan",
      utelWebhookMissing: "Utelda bizning manzil bilan webhook topilmadi: uni qo'shing (pastga qarang)",
      utelEventsOn: "Yoqilgan hodisalar",
      utelEventsOff: "O'chiq",
      utelExtensions: "Utel dagi ichki raqamlar",
      utelNoExtensions: "Raqamlar ro'yxati olinmadi",
      utelSync: "3 kunlik qo'ng'iroqlarni yuklash",
      utelSynced: "Yuklangan qo'ng'iroqlar: {n}",
      utelSyncFailed: "Tarixni yuklab bo'lmadi",
      utelWebhookHint: "Utel panelida: Integratsiya → Webhook ga shu manzilni qo'ying va call_started, dial_answered, call_ended, call_saved hodisalarini yoqing (dial_started ham mumkin).",
      utelNoClickToCall: "«Qo'ng'iroq» tugmasi Utel metodi (services/originate) orqali ishlaydi. Hujjatda so'rov maydonlari tavsiflanmagan, shuning uchun birinchi qo'ng'iroqda CRM formatni o'zi tanlaydi: sinov qo'ng'irog'i qilib tekshiring.",
      unknownTitle: "Noma'lum raqamdan kelgan qo'ng'iroqlar",
      unknownHint: "Mos kontakt topilmasa — kontakt avtomatik yaratiladi. Lid ham avtomatik yaratilishini xohlasangiz, qayerga tushishini tanlang (ixtiyoriy).",
      noLead: "— Lid yaratilmasin —",
      noStage: "— Bosqich tanlanmagan —",
      apiToken: "API Token (Click-to-call uchun)",
      apiTokenHint: "Mediateka ATC (ibrat.sip.uz) management API tokeni (originate qo'ng'iroq uchun)",
      sipDomainHint: "Faqat domen nomi. Click-to-call uchun:",
      sipuniUser: "Sipuni akkaunt raqami (user)",
      sipuniUserHint: "Sipuni shaxsiy kabinetidagi akkaunt raqami",
      sipuniSecret: "Sipuni Secret Key",
      sipuniSecretHint: "Sipuni → Sozlamalar → API bo'limidagi maxfiy kalit (click-to-call uchun)",
      save: "Saqlash",
      saved: "Saqlandi",
      error: "Xato",
    },
    branding: {
      title: "Brending",
      subtitle: "Tashkilot nomi, logosi va brend rangi — dastur shu ko'rinishda ochiladi",
      orgName: "Tashkilot nomi",
      orgNamePlaceholder: "Kompaniya nomi",
      logo: "Logo",
      upload: "Yuklash",
      removeLogo: "O'chirish",
      brandColor: "Brend rangi",
      defaultGreen: "Standart (yashil)",
      customColor: "Maxsus rang", solidTitle: "Sidebar/yuqori panel asl rangda", solidHint: "Yoqilsa — chap menyu va yuqori panel tanlangan rangning aynan o'zida ko'rinadi (to'qlashtirilmaydi). O'chiq bo'lsa — hozirgidek to'q soyada.",
      preview: "Ko'rinish",
      primaryBtn: "Asosiy tugma",
      badge: "Yorliq",
      linkText: "Havola matni",
      save: "Saqlash",
      imageOnly: "Faqat rasm fayli",
      uploadError: "Yuklashda xato",
      nameRequired: "Tashkilot nomi kiritilishi shart",
      saved: "Brending saqlandi",
      error: "Xato",
    },
    users: {
      countPrefix: "Jami",
      countSuffix: "ta foydalanuvchi", searchPlaceholder: "Ism yoki telefon...", noResults: "Hech narsa topilmadi",
      seats: "Tarif bo'yicha o'rinlar: {used} / {total}",
      add: "Qo'shish",
      thUser: "Foydalanuvchi",
      thPhone: "Telefon",
      thRole: "Rol",
      thDept: "Bo'lim", noDept: "Bo'limsiz",
      thStatus: "Holat",
      you: "Siz",
      userType: "Xodim turi", userTypeNone: "Oddiy xodim", userTypeHint: "Snabjenist / jarayon xodimi / loyiha menejeri rolini tanlang (ixtiyoriy)",
      snabjenist: "Snabjenist",
      active: "Faol",
      inactive: "Faol emas",
      editTitle: "Tahrirlash",
      changePasswordTitle: "Parolni o'zgartirish",
      deleteTitle: "O'chirish",
      newUser: "Yangi foydalanuvchi",
      editUser: "Foydalanuvchini tahrirlash",
      name: "Ism",
      namePlaceholder: "To'liq ism",
      role: "Rol", position: "Lavozim",
      dept: "Bo'lim",
      deptNone: "— Tanlanmagan —", deptMulti: "Bo'limlar (bir nechta)", noDeptsYet: "Hali bo'lim yo'q", cpFolders: "Kontragent papkalari (dostup)", cpFoldersHint: "Snabjenist faqat belgilangan papkalardagi ta'minotchilarni ko'radi. Hech biri belgilanmasa — barchasi.", noFoldersYet: "Hali papka yo'q",
      snabjenistHint: "Yoqilgan bo'lsa, Snabjeniya formasida \"Ma'sul\" ro'yxatida ko'rinadi",
      customRole: "Rol (RBAC)",
      customRoleNone: "— Cheklovsiz (to'liq) —",
      customRoleHint: "Maxsus rol biriktirilsa, foydalanuvchi shu rol ruxsatlari bilan cheklanadi. owner/admin doim to'liq.", roleHint: "Administrator - barcha huquqlar (RBAC ishlamaydi). User - cheklangan; pastda maxsus rol tanlash mumkin.", adminFullHint: "Administrator barcha modullarga kira oladi - maxsus rol (RBAC) kerak emas.",
      processWorker: "Jarayon xodimi",
      processWorkerHint: "Zakaz jarayonlariga tayinlanadi va ularni boshlash/tugatish/pauza qila oladi",
      projectManager: "Loyiha menejeri", cashier: "Kassir",
      projectManagerHint: "Zakazda mas'ul menejer sifatida tanlanishi mumkin (zakaz qo'shishda ro'yxatda chiqadi)",
      permissions: "Ruxsatlar",
      cashboxes: "Biriktirilgan kassalar (snabjenist uchun)",
      cashboxesHint: "Foydalanuvchi naqd Kirim qilganda faqat shu kassalardan tanlay oladi. Bo'sh qoldirilsa, foydalanuvchi naqd Kirim qila olmaydi.",
      phone: "Telefon",
      phonePlaceholder: "90 123 45 67",
      email: "Email",
      emailHint: "(parol tiklash uchun)",
      emailPlaceholder: "example@mail.com",
      password: "Parol",
      passwordPlaceholder: "Kamida 6 ta belgi",
      newPassword: "Yangi parol",
      passwordModalTitle: "Parol —",
      cancel: "Bekor",
      save: "Saqlash",
      saving: "Saqlanmoqda...",
      change: "O'zgartirish",
      deleteUser: "Foydalanuvchini o'chirish",
      deleteConfirmPrefix: "",
      deleteConfirmSuffix: "ni o'chirishni tasdiqlaysizmi? Bu amalni qaytarib bo'lmaydi.",
      deleteBtn: "O'chirish",
      deleting: "O'chirilmoqda...",
      accountOwner: "Account owner",
      loadError: "Foydalanuvchilarni yuklab bo'lmadi",
      updated: "Foydalanuvchi yangilandi",
      passwordChanged: "Parol o'zgartirildi",
      deleted: "Foydalanuvchi o'chirildi",
      added: "Foydalanuvchi qo'shildi",
      genericError: "Xato yuz berdi",
      passwordTooShort: "Parol kamida 4 ta belgi bo'lishi kerak",
      roles: { owner: "Egasi", admin: "Administrator", user: "Foydalanuvchi", cashier: "Kassir" },
      perms: { products: "Mahsulotlar", clients: "Mijozlar", suppliers: "Ta'minotchilar", sales: "Sotuv", purchases: "Xarid", reports: "Hisobotlar" },
    },
    currencies: {
      baseTitle: "Asosiy valyuta",
      baseSubtitle: "Barcha narxlar shu valyutada ko'rsatiladi",
      change: "O'zgartirish",
      baseTag: "Asosiy",
      basePickTitle: "Asosiy valyutani tanlang",
      basePickHint: "Birinchi tanlagan valyutangiz asosiy bo'ladi",
      addTitle: "Qo'shimcha valyutalar",
      addSubtitle: "Asosiy valyutaga nisbatan kurs ko'rsatiladi",
      add: "Qo'shish",
      empty: "Hali qo'shimcha valyuta qo'shilmagan",
      pickBaseModal: "Asosiy valyutani tanlang",
      pickAddModal: "Valyuta tanlang",
      searchPlaceholder: "Qidirish (USD, dollar...)",
      notFound: "Topilmadi",
      rateModalTitle: "Kurs —",
      editRateModalTitle: "Kursni tahrirlash —",
      editRateTooltip: "Kursni tahrirlash", bankRate: "Bank kursi:", useBankRate: "Bank kursi", bankRateHint: "Yoqilsa, kurs Markaziy bank (CBU) kursidan olinadi va saqlashda yangilanadi.", bankRateOn: "Bank kursidan olinmoqda", bankSource: "Markaziy bank kursi, sana:", bankError: "Bank kursini olishda xatolik (qoʻlda kiritishingiz mumkin).",
      ratePlaceholder: "Masalan: 12700",
      rateHint: "1 {code} necha {base}ga teng ekanligini kiriting",
      cancel: "Bekor",
      save: "Saqlash",
      saving: "Saqlanmoqda...",
      addBtn: "Qo'shish",
      rateInvalid: "Kursni to'g'ri kiriting",
      baseFirst: "Avval asosiy valyutani tanlang",
      saved: "Valyuta sozlamalari saqlandi",
      error: "Xato yuz berdi",
      names: {
        UZS: "O'zbek so'mi", USD: "AQSh dollari", EUR: "Yevro", RUB: "Rossiya rubli",
        KZT: "Qozog'iston tengesi", GBP: "Britaniya funt sterlingi", JPY: "Yaponiya iyenasi",
        CNY: "Xitoy yuani", TRY: "Turk lirasi", AED: "BAA dirhami", KGS: "Qirg'iziston somi",
        TJS: "Tojikiston somoniysi", TMT: "Turkmaniston manati", AZN: "Ozarbayjon manati",
        GEL: "Gruziya larisi", UAH: "Ukraina grivnasi", BYN: "Belarus rubli",
        SAR: "Saudiya Arabistoni riyoli", CAD: "Kanada dollari", AUD: "Avstraliya dollari",
        CHF: "Shveytsariya franki", INR: "Hindiston rupiyasi", KRW: "Janubiy Koreya voni",
        SEK: "Shvetsiya kronasi", NOK: "Norvegiya kronasi", DKK: "Daniya kronasi",
        PLN: "Polsha zlotiyi", CZK: "Chexiya kronasi", HUF: "Vengriya forinti", RON: "Ruminiya leyi",
      },
    },
    general: {
      saved: "Saqlandi",
      error: "Xato",
      soonBadge: "(tez orada)",
      businessTitle: "Biznes turi",
      businessSubtitle: "Qaysi modullar tashkilotingiz uchun kerakligini tanlang — sidebar shu asosda tozalanadi",
      businessNote: "Rejim faqat UI'ga ta'sir qiladi — ma'lumotlar har doim saqlanib qoladi. Modulni qaytadan ko'rsatish uchun \"Hammasi\"ni tanlang.",
      skladTitle: "Sklad",
      skladSubtitle: "Sotuv va qoldiqlar bo'yicha sozlamalar",
      jobFoldersSectionTitle: "Zakazlar — papkalar",
      jobFoldersTitle: "Papkalashni ko'rsatish",
      jobFoldersHint: "Zakazlar bo'limida papka tashkil qilish (papka daraxti) imkoniyatini yoqadi. Standart holatda o'chiq.", paymentsTitle: "To’lovlar", paymentsSubtitle: "Pul kirim/chiqim hujjatlari sozlamalari.", paymentStatusesTitle: "To’lov holatlari", paymentStatusesHint: "Yoqilsa, pul kirimi va chiqimida holat (status) maydoni ko’rinadi — holat qo’shish/o’chirish mumkin. O’chiq bo’lsa, status maydoni yashiriladi.", purchasesTitle: "Xaridlar", purchasesSubtitle: "Xarid hujjatlari sozlamalari.", purchaseReturnsTitle: "Xarid qaytarish (vozvrat)", salesTitle: "Sotuv bo'limlari", salesSubtitle: "Sotuvlar menyusida qaysi pastki bo'limlar ko'rinishini tanlang.", salesOrders: "Buyurtmalar", salesInvoices: "Sotuvlar (faktura)", salesReturns: "Qaytarishlar", salesSectionsHint: "O'chirilgan bo'lim sidebardan yashiriladi. Hammasi o'chsa — Sotuvlar guruhi umuman ko'rinmaydi.", salesProductFolder: "Mahsulot papkasi", salesProductFolderHint: "Sotuv formasida faqat shu papkadagi (va ichki papkalardagi) mahsulotlar ko'rinadi. Bo'sh = hammasi.", purchaseReturnsHint: "Yoqilsa, Xaridlar bo'limida \"Qaytarishlar\" ko'rinadi. O'chiq bo'lsa — yashiriladi.", discountFieldTitle: "Chegirma maydoni", discountFieldHint: "Yoqilsa, kirim va sotuv fakturalarida chegirma (%) ustuni ko'rinadi. O'chiq bo'lsa (default) — yashiriladi.", purchaseDefaultWarehouse: "Standart ombor", purchaseDefaultWarehouseHint: "Kirim hujjatlari yaratilganda avtomatik tanlanadigan ombor. Bo'sh = tanlanmagan.", productionDefaultWarehouses: "Standart omborlar", productionDefaultWarehousesHint: "Ishlab chiqarish hujjati yaratilganda avtomatik tanlanadigan omborlar.", productionDefaultRawWarehouse: "Xomashyo ombori", productionDefaultFinishedWarehouse: "Tayyor mahsulot ombori", jobProcLaborTitle: "Jarayonda ish haqi", jobProcLaborHint: "Zakaz jarayonida ish haqi (mehnat) maydoni ko'rinadi. O'chiq bo'lsa — yashiriladi.", jobProcAllocatedTitle: "Jarayonga ajratilgan summa", jobProcAllocatedHint: "Zakaz jarayonida ajratilgan summa maydoni ko'rinadi. O'chiq bo'lsa — yashiriladi.", sketchRequiredTitle: "Eskiz majburiy", sketchRequiredHint: "Yoqilsa, zakaz yaratishda eskiz (rasm/PDF) yuklash shart bo'ladi. O'chiq bo'lsa (default) — ixtiyoriy.", sketchInListTitle: "Zakazlar ro'yxatida eskiz", sketchInListHint: "Yoqilsa, zakazlar ro'yxatida (# dan keyin) 1-rasm (eskiz) ko'rinadi — lupani bossangiz to'liq ochiladi. Rasm bo'lmasa bo'sh kvadrat. Default o'chiq.", costWarnTitle: "Tannarx ogohlantirish foizi", costWarnHint: "Zakaz tannarxi kelishilgan narxning shu foizidan oshsa, ro'yxatda qizil ogohlantirish chiqadi (jarayonda va yakunlangan zakazlarda). Masalan 50% — tannarx narxning yarmidan oshsa. Default 50%.", ndsTitle: "Soliq (QQS)", ndsSubtitle: "Tashkilot QQS to'lovchi bo'lsa yoqing — sotuv fakturalarida QQS ustunlari paydo bo'ladi.", hasNdsTitle: "QQS to'lovchi tashkilot", hasNdsHint: "Yoqilsa, sotuv fakturalarida MKIX kod, QQS stavkasi, QQS miqdori va Jami ustunlari ko'rinadi.", negCashboxTitle: "Kassa minusga ketsin", negCashboxHint: "Yoqilsa, chiqim kassadagi qoldiqdan oshib, balans minusga o'tishi mumkin. O'chiq bo'lsa (default) — qoldiqdan ortiq chiqim qilinmaydi.", cashierTitle: "Kassir", cashierSubtitle: "Kassir turidagi xodimlarga qaysi kassalar ko'rinadi.", cashierNoCashboxes: "Kassalar yo'q.", cashierHint: "Belgilangan kassalargina kassirga ko'rinadi. Hech biri belgilanmasa — hech qaysi.", cashierCpTitle: "Kassir — kontragent papkalari", cashierCpSubtitle: "Kassir prixod qilganda qaysi papkadagi kontragentlar chiqadi.", cashierNoFolders: "Papkalar yo'q.", cashierCpHint: "Belgilangan papkalardagi kontragentlargina kassirga ko'rinadi. Hech biri belgilanmasa — hech qaysi.", snabjenistCpTitle: "Snabjenist — ta'minotchi papkalari", snabjenistCpSubtitle: "Snabjenist ta'minotchilarini ko'rganda qaysi papkalar ko'rinadi.", snabjenistCpHint: "Belgilangan papkalardagi kontragentlargina snabjenistga ko'rinadi. Hech biri belgilanmasa — hammasi ko'rinadi.", catCpTitle: "Kategoriya \u2014 kontragent papkasi", catCpSubtitle: "To'lovda kategoriya tanlanganda kontragent ro'yxati shu papkaga filtrlanadi.", catCpEmpty: "Kategoriyalar yo'q.", catCpHint: "\"Kontragentsiz\" tanlangan kategoriyada (masalan Oziq-ovqat) kontragent so'ralmaydi.", catCpAll: "Barcha kontragentlar", catCpNone: "Kontragentsiz", catCpIncoming: "kirim", catCpOutgoing: "chiqim",
      negStockTitle: "Manfiy qoldiqqa ruxsat",
      negStockHint: "Yoqilsa, omborda yo'q tovarni ham sotish mumkin (qoldiq minusga ketadi). O'chirilsa, yetarli tovar bo'lmasa sotuv fakturasi bloklanadi.",
      servSellTitle: "Xizmat sotish",
      servSellHint: "Yoqilsa, Inventoriyada \"+ Xizmat\" tugmasi va \"Xizmat\" filtri ko'rinadi — xizmat turidagi pozitsiyalarni qo'shish va sotish mumkin. O'chirilsa, faqat mahsulotlar bilan ishlanadi.",
      purchasesTitle: "Xaridlar",
      purchasesSubtitle: "Sidebar'dagi \"Xaridlar\" bo'limida qaysi pastki menyu ko'rinishini tanlang",
      purchasesNote: "Rejim faqat UI'ga ta'sir qiladi — mavjud ma'lumotlar saqlanib qoladi.",
      costingTitle: "Tannarx hisobi (COGS)",
      costingSubtitle: "Foyda va ombor qiymati qaysi usulda hisoblanadi",
      costingNote: "Eslatma: sotuv paytida tannarx \"muzlatib\" yoziladi — usulni o'zgartirsangiz, eski hujjatlar foydasi o'zgarmaydi.",
      cpSectionTitle: "Kontragentlar", cpStatusTitle: "Kontragent statusi", cpStatusHint: "Kontragentlarda status (holat) maydoni ishlatiladi. O'chiq bo'lsa — holat ustuni/filtri/maydoni yashiriladi.", cpFolderTitle: "Kontragent filtri", cpFolderSubtitle: "Formalarda kontragentlarni papka bo'yicha filtrlash",
      cpFolderAll: "Hammasi (filtrlanmasin)",
      cpSupplierFolder: "Xarid / Snabjeniya papkasi", cpSupplierFolderHint: "Xarid va snabjeniya formalarida faqat shu papkadagi ta'minotchilar chiqadi",
      cpCustomerFolder: "Sotuv / Zakaz papkasi", cpCustomerFolderHint: "Sotuv va zakaz formalarida faqat shu papkadagi mijozlar chiqadi",
      cpFolderNone: "Papkasiz",
      cpJobOrderNewCustomerFolder: "Zakaz ichida yangi mijoz papkasi", cpJobOrderNewCustomerFolderHint: "Zakaz yaratishda ichidan qo'shilgan yangi mijoz shu papkaga tushadi", prodFolderTitle: "Ishlab chiqarish — mahsulot papkalari", prodFolderSubtitle: "Ishlab chiqarish formasida xomashyo va tayyor mahsulot piker'lari shu papkalardan (ichki papkalar bilan) ko'rsatiladi.", prodRawFolder: "Xomashyo papkasi", prodRawFolderHint: "Ishlab chiqarish tarkibida (xomashyo) faqat shu papkadagi mahsulotlar ko'rinadi. Bo'sh = hammasi.", prodFinishedFolder: "Tayyor mahsulot papkasi", prodFinishedFolderHint: "Ishlab chiqarish chiqishida (tayyor mahsulot) faqat shu papkadagi mahsulotlar ko'rinadi. Bo'sh = hammasi.", prodOutputBatchTitle: "Tayyor mahsulot partiyasi va muddati", prodOutputBatchHint: "Yoqilsa — ishlab chiqarishda tayyor mahsulotga partiya № va yaroqlilik muddati maydonlari ko'rinadi. Default o'chiq.", navOrderTitle: "Sidebar tartibi", navOrderSubtitle: "Bo'limlar sidebar'da qaysi tartibda ko'rinishini sozlang.", navOrderReset: "Asl tartib",
      costing: {
        average: { label: "O'rtacha-vaznli (AVCO)", hint: "Kirimlardan o'rtacha tannarx avtomatik hisoblanadi" },
        manual:  { label: "Qo'lda (mahsulot tannarxi)", hint: "Mahsulotga qo'lda kiritilgan tannarx ishlatiladi" },
        fifo:    { label: "FIFO (birinchi kirgan — birinchi chiqadi)", hint: "Qatlamli tannarx: eng eski partiya birinchi sotiladi" },
        batch:   { label: "Partiya (lot) bo'yicha", hint: "Sotuvda partiya tanlanadi, muddat bilan" },
      },
      business: {
        retail:      { label: "Do'kon (sotuv)", hint: "Magazinday do'kon — tovarni omborda saqlab, mijozga sotadi. Zakaz va Ishlab chiqarish modullari yashirin." },
        "job-order": { label: "Yig'uvchi (zakaz)", hint: "Mijoz buyurtmasi bo'yicha ishlaydi — tayyor mahsulot ombor saqlanmaydi, to'g'ridan mijozga beriladi. Sotuv va Ishlab chiqarish modullari yashirin." },
        production:  { label: "Ishlab chiqarish", hint: "Xom ashyodan tayyor mahsulot ishlab chiqaradi va sotadi. Ishlab chiqarish bo'limi ko'rinadi, Zakaz moduli yashirin." },
        all:         { label: "Hammasi (aralash)", hint: "Sotuv, Zakaz va Ishlab chiqarish — barchasi ko'rinadi. Eng moslashuvchan, ko'p ko'rinadi." },
      },
      procurement: {
        orders:      { label: "Zayavkalar", hint: "Ta'minotchiga to'g'ridan-to'g'ri buyurtma (PO) — sodda ishlash modeli." },
        procurement: { label: "Snabjeniya", hint: "Ichki ta'minot jarayoni: snabjenist so'rovi → ombor kirimi. Kompaniya kattaroq jamoa uchun." },
        both:        { label: "Ikkalasi", hint: "Zayavkalar va Snabjeniya — ikkala pastki menyu ham ko'rinadi." },
        none:        { label: "Faqat Kirimlar", hint: "Zayavkalar ham, Snabjeniya ham yashiriladi — faqat Kirimlar (va Qaytarishlar)." },
      },
    },
  },

  // Settings → UOM & Company tabs
  settingsExtra: {
    uom: {
      customTitle: "Mening o'lchov birliklarim",
      customSubtitle: "Siz qo'shgan, o'chirish mumkin",
      add: "Qo'shish",
      customEmpty: "Hali o'z o'lchov birligingiz yo'q",
      thShort: "Qisqa nom",
      thFull: "To'liq nom",
      deleteTitle: "O'chirish",
      systemTitle: "Tizim o'lchov birliklari",
      systemSubtitle: "Barcha tashkilotlarga umumiy, o'chirib bo'lmaydi",
      systemBadge: "Tizim", thVisible: "Ko'rinadi", visibleHint: "Belgilansa — tizimda (forma va ro'yxatlarda) ko'rinadi", addDisabled: "Hozircha o'chirilgan",
      newUnit: "Yangi o'lchov birligi",
      shortName: "Qisqa nom",
      shortNamePlaceholder: "Masalan: kg, dona, m²",
      shortNameHint: "Mahsulot kartasida ko'rsatiladigan qisqa belgi",
      fullName: "To'liq nom",
      fullNamePlaceholder: "Masalan: Kilogram, Dona, Kvadrat metr",
      cancel: "Bekor",
      saving: "Saqlanmoqda...",
      addBtn: "Qo'shish",
      added: "O'lchov birligi qo'shildi",
      deleted: "O'lchov birligi o'chirildi",
      loadError: "O'lchov birliklarini yuklab bo'lmadi",
      error: "Xato yuz berdi",
      groups: {
        count: "Soni",
        weight: "Og'irlik",
        length: "Uzunlik",
        areaVol: "Yuza va hajm",
        liquid: "Suyuqlik",
        packaging: "Qadoq va idish",
        time: "Vaqt",
        service: "Xizmat",
        other: "Boshqa",
      },
    },
    trash: {
      retentionLabel: "Saqlash muddati",
      never: "Hech qachon o'chmasin",
      neverMark: "O'chmaydi",
      retentionSaved: "Muddat saqlandi",
      subtitleNever: "yozuvlar hech qachon avtomatik o'chmaydi. Tiklanganda bog'liq ma'lumotlar (izohlar, havolalar) ham qaytariladi.",
      title: "Korzina",
      subtitlePrefix: "O'chirilgan yozuvlar",
      subtitleSuffix: "kundan keyin butunlay o'chib ketadi. Tiklanganda bog'liq ma'lumotlar (izohlar, havolalar) ham qaytariladi.",
      searchPlaceholder: "Nomi, telefon...",
      empty: "Korzina bo'sh",
      thType: "Turi",
      thDetails: "Tafsilot",
      thName: "Nomi",
      thDeletedBy: "O'chirgan", allTypes: "Barcha turlar", allUsers: "Barcha foydalanuvchilar",
      kinds: { Contact: "Kontakt", Deal: "Bitim", Task: "Vazifa", Funnel: "Varonka" },
      thDate: "Sana",
      thLeft: "Qoldi",
      daysSuffix: "kun",
      restoreTitle: "Tiklash",
      permDeleteTitle: "Butunlay o'chirish",
      modalTitle: "Butunlay o'chirish",
      confirmSuffix: "ni butunlay o'chirasizmi? Bu amalni qaytarib bo'lmaydi — yozuv va biriktirilgan fayllar o'chib ketadi. Varonka bo'lsa, uning bitimlari ham o'chadi.",
      cancel: "Bekor",
      deleting: "O'chirilmoqda...",
      permDeleteBtn: "Butunlay o'chirish",
      restored: "Tiklandi",
      restoreError: "Tiklashda xato",
      permDeleted: "Butunlay o'chirildi",
      deleteError: "O'chirishda xato",
      loadError: "Yuklashda xato",
    },
    audit: {
      title: "Audit jurnali",
      subtitle: "Kim, qachon, nima qilgani",
      empty: "Yozuvlar yo'q",
      thTime: "Vaqt",
      thUser: "Foydalanuvchi",
      thAction: "Amal",
      thBranch: "Bo'lim",
      thObject: "Obyekt",
      thIp: "IP",
      view: "Ko'rish",
      detailTitle: "Yozuv tafsiloti",
      fResource: "Bo'lim / resurs",
      fId: "Obyekt ID",
      fMethod: "Metod",
      fPath: "Manzil",
      fStatus: "Holat (status)",
      allUsers: "Barcha foydalanuvchilar",
      dateFrom: "Sanadan",
      dateTo: "Sanagacha",
      thModule: "Modul",
      modules: { trash: "Korzina", organization: "Sozlamalar", uom: "O'lchov birliklari", inventory: "Mahsulotlar", counterparty: "Kontragentlar", warehouse: "Omborxonalar", purchases: "Xaridlar", sales: "Sotuvlar", payments: "To'lovlar", "payment-requests": "To'lov so'rovlari", integrations: "Integratsiyalar", cashbox: "Kassalar", conversions: "Konvertatsiya", transfers: "Ko'chirishlar", reports: "Hisobotlar", upload: "Fayllar", trash: "Korzina", export: "Eksport", production: "Ishlab chiqarish", departments: "Bo'limlar", branches: "Filiallar", "job-orders": "Zakazlar", proposals: "Takliflar", "job-order-folders": "Zakaz papkalari", contracts: "Shartnomalar", "akt-sverka": "Akt-sverka", procurement: "Snabjeniya",
        contacts: "Kontaktlar", funnels: "Voronkalar", tasks: "Vazifalar", "lead-forms": "Lid formalar", inbox: "Xabarlar", instagram: "Instagram", facebook: "Facebook", whatsapp: "WhatsApp", atc: "IP-telefoniya", "lead-journey": "Lid yo'li", email: "Email", push: "Push xabarnoma", reviews: "Sharhlar", yandex: "Yandex",
        "organization-users": "Foydalanuvchilar", "organization-roles": "Rollar", "organization-currencies": "Valyuta sozlamalari", "organization-settings": "Umumiy sozlamalar", "organization-contact-fields": "Kontakt maydonlari", "organization-deal-fields": "Bitim maydonlari", "organization-task-stages": "Vazifa bosqichlari", "organization-deal-sources": "Bitim manbalari", "organization-close-reasons": "Yopish sabablari", "organization-goals": "Maqsadlar", "organization-sticker-packs": "Stiker to'plamlari", "organization-telegram-bot": "Telegram bot", "organization-telegram-accounts": "Telegram akkaunt",
        "funnels-deals": "Bitimlar", "funnels-deal-activities": "Bitim izohlari", "funnels-deal-files": "Bitim fayllari", "call-analysis": "Qo'ng'iroqlar AI tahlili", "contacts-activities": "Kontakt izohlari" },
      actions: { create: "Yaratdi", update: "O'zgartirdi", delete: "O'chirdi", login: "Kirdi", logout: "Chiqdi", register: "Ro'yxatdan o'tdi", password_change: "Parol o'zgartirdi", profile_update: "Profil yangiladi", view: "Ko'rdi" },
      loadError: "Yuklashda xato",
    },
    company: {
      subBranches: "Filiallar",
      subDepartments: "Bo'limlar",
      branches: {
        title: "Filiallar",
        subtitle: "Tashkilotning filiallari — bo'limlarni shu filiallarga biriktirish mumkin",
        add: "Qo'shish",
        empty: "Filiallar yo'q",
        thName: "Nomi",
        thActions: "Amallar",
        newBranch: "Yangi filial",
        editBranch: "Filialni tahrirlash",
        name: "Nomi",
        namePlaceholder: "Markaziy ofis, Chilonzor filiali...",
        nameRequired: "Nom kiritilishi shart",
        cancel: "Bekor",
        save: "Saqlash",
        deleteTitle: "Filialni o'chirish",
        deleteSuffix: "filialini o'chirasizmi? Shu filialdagi bo'limlardan filial bog'lanishi olib tashlanadi (bo'limlarning o'zi saqlanadi).",
        deleteBtn: "O'chirish",
        added: "Qo'shildi",
        updated: "Yangilandi",
        deleted: "O'chirildi",
        loadError: "Yuklashda xato",
        error: "Xato",
      },
      departments: {
        title: "Bo'limlar (ishlab chiqarish jarayonlari)",
        subtitle: "Zakaz ichidagi jarayonlar shu bo'limlardan tanlanadi (kesish, yopishtirish, bo'yash...)",
        add: "Qo'shish",
        empty: "Bo'limlar yo'q",
        thName: "Nomi",
        thBranch: "Filial",
        thActions: "Amallar",
        newDept: "Yangi bo'lim",
        editDept: "Bo'limni tahrirlash",
        name: "Nomi",
        namePlaceholder: "Kesish, Bo'yash...",
        branch: "Filial",
        branchNone: "— Tanlanmagan —",
        thType: "Turi",
        type: "Bo'lim turi",
        typeProcess: "Ish jarayonidagi",
        typeManagement: "Boshqaruv",
        typeHint: "Zakaz jarayoni qo'shganda faqat \"ish jarayonidagi\" bo'limlar ko'rinadi (boshqaruv emas).",
        cancel: "Bekor",
        save: "Saqlash",
        deleteTitle: "Bo'limni o'chirish",
        deleteSuffix: "bo'limini o'chirasizmi? Foydalanuvchilardagi tegishli bog'lanish olib tashlanadi (lekin foydalanuvchilarning o'zlari saqlanadi).",
        deleteBtn: "O'chirish",
        added: "Bo'lim qo'shildi",
        updated: "Yangilandi",
        deleted: "O'chirildi",
        loadError: "Yuklashda xato",
        error: "Xato",
      },
    },
  },

  // Top navbar
  units: {
    billion: "mlrd",
    million: "mln",
    thousand: "ming",
  },

  analytics: {
    title: "Analitika",
    subtitle: "Savdo, qo'ng'iroqlar, kontaktlar va kanallar bo'yicha barcha statistika bir joyda",
    tabs: {
      director: "Rahbar",
      sales: "Savdo",
      calls: "Qo'ng'iroqlar",
      funnels: "Voronkalar",
      journey: "Lid yo'li",
      quality: "Qo'ng'iroq sifati",
      contacts: "Kontaktlar",
      inbox: "Xabarlar",
      reviews: "Sharhlar",
    },
    period: {
      "7d": "7 kun",
      "30d": "30 kun",
      "90d": "90 kun",
      month: "Shu oy",
      custom: "Davr",
    },
    director: {
      reportFor: "Hisobot:",
      allStaff: "Barcha xodimlar",
      staffN: "Xodimlar: {n}",
      period: {
        today: "Bugun",
        yesterday: "Kecha",
        thisWeek: "Shu hafta",
        lastWeek: "O'tgan hafta",
        thisMonth: "Shu oy",
        lastMonth: "O'tgan oy",
        quarter: "Shu chorak",
        year: "Shu yil",
        custom: "Boshqa davr",
      },
      sum: {
        dealsInWork: "Ishdagi bitimlar",
        notes: "Qo'shilgan izohlar",
        tasksInWork: "Ishdagi vazifalar",
        purchases: "Muvaffaqiyatli bitimlar (xaridlar summasi)",
      },
      deals: {
        title: "Bitimlar",
        inWork: "Ishda",
        new: "Yangi",
        lost: "Yo'qotilgan",
        won: "Muvaffaqiyatli",
        note: "«Ishda» — hozir ochiq bitimlar. «Yangi» — davr ichida yaratilgan. «Yo'qotilgan» va «Muvaffaqiyatli» — davr ichida yopilgan. Foiz — barcha bitimlar ichida muvaffaqiyatlilar ulushi.",
      },
      contacts: {
        title: "Kontaktlar",
        total: "Jami",
        new: "Davrdagi yangilari",
      },
      events: {
        title: "Voqealar",
        dealsCreated: "Yaratilgan bitimlar",
        contactsCreated: "Yaratilgan kontaktlar",
        stageChanges: "Bosqich o'zgarishlari",
        tasksCompleted: "Yakunlangan vazifalar",
        withResult: "natija bilan: {n}",
        notes: "Qo'shilgan izohlar",
        files: "Biriktirilgan fayllar",
        callsIn: "Kiruvchi qo'ng'iroqlar",
        callsOut: "Chiquvchi qo'ng'iroqlar",
      },
      tasks: {
        title: "Vazifalar",
        type: {
          call: "Bog'lanish",
          meeting: "Uchrashuv",
          other: "Boshqa",
        },
        new: "Yangi",
        overdue: "Muddati o'tgan",
        done: "Bajarilgan",
        completion: "Bajarilish ulushi",
        avgTime: "O'rtacha bajarilish vaqti",
        hours: "soat",
        days: "kun",
        dueToday: "Bugunga",
        unassigned: "Mas'ulsiz",
      },
      staff: {
        title: "Xodimlar: umumiy ko'rinish",
        employee: "Xodim",
        dealsCreated: "Bitimlar",
        contactsCreated: "Kontaktlar",
        stageChanges: "Bosqich o'zg.",
        notes: "Izohlar",
        tasksCompleted: "Bajarilgan vazifa",
        tasksOpen: "Ishdagi vazifa",
        tasksOverdue: "Muddati o'tgan",
        callsIn: "Kiruvchi",
        callsOut: "Chiquvchi",
      },
    },
    loadError: "Ma'lumotlar yuklanmadi",
    empty: "Tanlangan davrda ma'lumot yo'q",
    sales: {
      created: "Yangi bitimlar",
      won: "Yutilgan",
      lost: "Yo'qotilgan",
      conversion: "Konversiya",
      cycle: "Bitim sikli",
      days: "kun",
      avgDeal: "O'rtacha chek {v}",
      activeNow: "Hozir jarayonda: {n}",
      dynamics: "Bitimlar dinamikasi",
      lostReasons: "Rad etish sabablari",
      noReason: "Sabab ko'rsatilmagan",
      byManager: "Menejerlar bo'yicha",
      thManager: "Menejer",
      thSum: "Savdo summasi",
      noManager: "Mas'ulsiz",
      ownership: "Xodimlarga biriktirilganlar",
      ownLeads: "Ishdagi lidlar",
      ownLeadsShared: "shundan hamkorlikda",
      ownContacts: "Kontaktlar",
      ownContactsShared: "shundan hamkorlikda",
      ownershipNote: "Lid yoki kontaktda bir nechta mas'ul bo'lsa, u har biriga hisoblanadi.",
      bySource: "Manbalar: kelgan → yutilgan",
      noSource: "Manba ko'rsatilmagan",
      allFunnels: "Barcha voronkalar",
      allManagers: "Barcha menejerlar",
      pipeline: "Voronka hozir",
    },
    funnels: {
      view_intake: "Lidlar kelishi",
      view_staff: "Xodimlar bo'yicha",
      noFunnels: "Hali voronkalar yo'q",
      total: "Jami lidlar",
      assigned: "Menejerga biriktirilgan",
      notAssigned: "Biriktirilmagan",
      assignRate: "Biriktirilish foizi",
      noLeads: "Bu davrda lid kelmagan",
      staffHint: "Har bir xodim shu voronkadan qancha lid kiritgani va ularning hozirgi holati (boshqa voronkaga o'tkazilganlar ham hisobga kiradi).",
      thEmployee: "Xodim",
      thTotal: "Jami",
      thActive: "Faol",
      thWon: "Yutilgan",
      thLost: "Yo'qotilgan",
    },
    reviews: {
      scans: "QR skanlar",
      clicks: "Sharhga o'tishlar",
      conversion: "Konversiya",
      pending: "Yangi shikoyatlar",
      newReviews: "Xaritadan yangi sharhlar",
    },
  },

  ui: {
    filters: "Filtrlar",
    reset: "Tozalash",
    done: "Tayyor",
    more: "Yana",
    clearAll: "Hammasini tozalash",
    search: "Qidirish",
    sort: "Saralash",
    assignee: "Mas'ul",
    source: "Manba",
    created: "Yaratilgan sana",
    dateFrom: "Dan",
    dateTo: "Gacha",
    all: "Hammasi",
    none: "Ko'rsatilmagan",
    back: "Orqaga",
    cancel: "Bekor qilish",
    save: "Saqlash",
    delete: "O'chirish",
    selected: "Tanlandi: {n}",
  },

  // Автоматически вынесенные тексты интерфейса (loc.<файл>.<ключ>)
  loc: {
    registerPage: {
      thisSlugIsTakenChoose: "Bu slug band. Boshqa slug tanlang",
      takeYourBusiness: "Biznesingizni",
      digital: "raqamlashtiring",
      warehouseSalesCustomersAndFinance: "Sklad, sotuv, mijozlar va moliya — barchasi bitta tizimda.",
      whatIsASlug: "Slug nima?",
      aSlugIsYourOrganization: "Slug — tashkilotingizning tizimda noyob identifikatori. Masalan:",
      youWillUseThisSlug: ". Login vaqtida shu slugni ishlatasiz.",
      "2025CrmLineAllRights": "© 2025 CRM Line. Barcha huquqlar himoyalangan.",
      createAnOrganization: "Tashkilot yaratish",
      createAnAccountAndGet: "Akkaunt yarating va darhol boshlang",
      organization: "Tashkilot",
      organizationName: "Tashkilot nomi",
      eGBarakaSavdo: "Masalan: Baraka Savdo",
      organizationSlug: "Tashkilot slug",
      uniqueIdInTheSystem: "(tizimda noyob ID)",
      thisSlugIsTakenChoose2: "Bu slug band. Boshqa nom tanlang",
      thisSlugIsAvailable: "✓ Bu slug bo'sh",
      forSignIn: "Login uchun:",
      organizationType: "Tashkilot turi",
      adminAccount: "Admin akkaunt",
      yourName: "Ismingiz",
      firstLastName: "Ism Familiya",
      phone: "Telefon",
      forSignIn2: "(login uchun)",
      email: "Email",
      forPasswordRecovery: "(parol tiklash uchun)",
      password: "Parol",
      confirm: "Tasdiqlash",
      loading: "Yuklanmoqda...",
      alreadyHaveAnAccount: "Akkauntingiz bormi?",
      signIn: "Kirish",
    },
    callButton: {
      startingCall: "Qo'ng'iroq boshlanmoqda...",
      noExtensionIsAssignedTo: "Sizga ichki raqam biriktirilmagan. Admin bilan bog'laning.",
      pbx: "{title} (ATC)",
      viaPbx: "ATC orqali",
      fromPersonalPhone: "Shaxsiy telefondan",
    },
    callRecordingPlayer: {
      download: "Yozuvni yuklab olish",
      downloadFailed: "Yozuvni yuklab bo'lmadi",
      couldNotLoadTheCall: "Qo'ng'iroq yozuvini yuklab bo'lmadi",
      couldNotLoadTheRecording: "Yozuvni yuklab bo'lmadi",
      speed: "Tezlik",
    },
    categoryProductPicker: {
      selected: "{size} ta tanlandi",
      nothingSelected: "Hech narsa tanlanmagan",
      done: "Tayyor",
    },
    incomingCallModal: {
      incomingCall: "Kiruvchi qo'ng'iroq",
      outgoingCall: "Chiquvchi qo'ng'iroq",
      crmContact: "CRM kontakt",
      assignee: "Mas'ul:",
      openContact: "Kontaktni ochish",
      unknownNumber: "Noma'lum raqam",
      notFoundInCrm: "CRM'da topilmadi",
      extension: "Kengaytma:",
      close: "Yopish",
      contact: "Kontakt",
    },
    lockScreen: {
      opened: "Ochildi",
      wrongPassword: "Parol noto'g'ri",
      signOutOfTheAccount: "Hisobdan to'liq chiqilsinmi?",
      user: "Foydalanuvchi",
      passwordToUnlockTheScreen: "Ekranni ochish uchun parol",
      password: "Parol",
      unlock: "Ochish",
      signInWithAnotherAccount: "Boshqa hisob bilan kirish",
    },
    accountPage: {
      saved: "Saqlandi",
      somethingWentWrong: "Xato yuz berdi",
      extension: "Ichki raqam",
      notAssigned: "Biriktirilmagan",
      yourPbxExtensionSipuniIbrat: "ATC (Sipuni/ibrat.sip.uz) ichki raqamingiz — buni faqat admin Sozlamalar → Xodimlar bo'limidan biriktiradi/o'zgartiradi.",
      thisNumberIsAlsoUsed: "Bu raqam tizimga kirish (login) uchun ham ishlatiladi — buni faqat admin Sozlamalar → Xodimlar bo'limidan o'zgartiradi.",
      email: "Email",
      atLeast4Characters: "kamida 4 belgi",
    },
    callsPage: {
      error: "Xato",
      linkCall: "Qo'ng'iroqni bog'lash",
      number: "Raqam:",
      contact: "Kontakt",
      searchForAContact: "Kontakt qidiring...",
      remove: "Olib tashlash",
      deal: "Bitim",
      enterDealTitle: "Bitim nomini yozing...",
      cancel: "Bekor",
      save: "Saqlash",
      failedToLoad: "Yuklanmadi",
      selected: "{size} ta tanlandi",
      changeTheFilterOrSearch: "Filter yoki qidiruvni o'zgartiring",
      link: "Bog'lash",
      callBack: "Qayta qo'ng'iroq",
      delete: "O'chirish",
      previous: "Oldingi",
      next: "Keyingi",
    },
    contactAnalyticsPage: {
      text: "{count} ta · {date}",
      newContactsInPeriod: "Davr uchun yangi kontaktlar",
      totalContacts: "Jami kontaktlar",
      allTime: "Barcha vaqt uchun",
      newContactsPerDay: "Kunlik yangi kontaktlar ({from} — {to})",
      byChannelViaInbox: "Kanal bo'yicha (Xabarlar orqali)",
      noData: "Ma'lumot yo'q",
      byOperator: "Operator bo'yicha",
      noPhoneNumbers: "Telefon raqamlar yo'q",
    },
    contactFormPage: {
      select: "— Tanlang",
      notSaved: "Saqlanmagan",
      chooseFile: "Fayl tanlash",
      call: "qo'ng'iroq",
      outgoing: "Chiquvchi",
      incoming: "Kiruvchi",
      ext: " · Ext: {ext}",
      contactNotFound: "Kontakt topilmadi",
      nameIsRequired: "Ism kiritilishi shart",
      contactAdded: "Kontakt qo'shildi",
      saved: "Saqlandi",
      somethingWentWrong: "Xato yuz berdi",
      fileUploaded: "Fayl yuklandi",
      uploadFailed: "Yuklashda xato",
      deleteTheFile: "Faylni o'chirishni tasdiqlaysizmi?",
      fileDeleted: "Fayl o'chirildi",
      deleteFailed: "O'chirishda xato",
      blockRemoved: "Blok olib tashlandi",
      contactBlocked: "Kontakt bloklandi",
      contactDeleted: "Kontakt o'chirildi",
      phone: "Telefon",
      format998xxxxxxxxx: "Format: +998XXXXXXXXX",
      email: "Email",
      assignee: "Mas'ul",
      notAssigned: "Biriktirilmagan",
      loading: "Yuklanmoqda...",
      uploadFile: "+ Fayl yuklash",
      saveTheContactFirstTo: "Fayl yuklash uchun avval kontaktni saqlang",
      noFilesYet: "Hali fayl yo'q",
      download: "Yuklab olish",
      sections: "Bo'limlar",
      main: "Asosiy",
      phoneEmailResponsiblePerson: "Telefon · Email · Ma'sul shaxs",
      fields: "{length} ta maydon",
      sectionName: "Bo'lim nomi...",
      addNewSection: "Yangi bo'lim qo'shish",
      fields2: "Maydonlar",
      noFieldsYet: "Hali maydon yo'q",
      fieldName: "Maydon nomi...",
      options: "Variantlar",
      atLeast1: "(kamida 1 ta)",
      optionName: "Variant nomi...",
      save: "Saqlash",
      cancel: "Bekor",
      add: "Qo'shish",
      addField: "Maydon qo'shish",
      shiftEnterNewLine: "Shift+Enter — yangi qator",
    },
    contactsPage: {
      deleteContact: "Kontaktni o'chirish",
      thisActionCannotBeUndone: "Bu amalni ortga qaytarib bo'lmaydi.",
      contactsWillBeDeleted: "kontakt o'chiriladi.",
      text: "{count} ta",
      willBeDeleted: "kontakti o'chiriladi.",
      cancel: "Bekor",
      delete: "O'chirish",
      onlyCsvFilesAreAccepted: "Faqat CSV fayl qabul qilinadi",
      importError: "Import xatosi",
      csvImport: "CSV import",
      importComplete: "Import tugadi!",
      contactsAdded: "kontakt qo'shildi,",
      skippedExistingOrEmpty: "o'tkazib yuborildi (mavjud yoki bo'sh).",
      text2: "{created} ta",
      text3: "{skipped} ta",
      close: "Yopish",
      csvFileFormat: "CSV fayl formati:",
      theFirstRowMustContain: "Birinchi qator ustun nomlari bo'lishi shart.",
      dropTheCsvFileHere: "CSV faylni bu yerga tashlang",
      orClickToChoose: "yoki bosing va tanlang",
      rows: "{v} — {length} ta qator",
      clear: "Tozalash",
      more: "… yana",
      rows2: "ta qator",
      import: "Importlash (",
      text4: "ta)",
      failedToLoad: "Yuklanmadi",
      merged: "Birlashtrildi",
      error: "Xato",
      duplicateContacts: "Takroriy kontaktlar",
      noDuplicates: "Takroriy kontaktlar yo'q",
      allGood: "Hamma yaxshi!",
      duplicateNumbers: "{count} ta takroriy raqam",
      merge: "Birlashtirish",
      created: "Yaratildi: {toLocaleDateString}",
      willBeSaved: "Saqlanadi",
      failedToLoadContacts: "Kontaktlar yuklanmadi",
      convertAllContactPhoneNumbers: "Barcha kontaktlardagi telefon raqamlarni +998XXXXXXXXX formatiga o'tkazilsinmi?",
      numbersNormalized: "{updated} ta raqam normallantirildi",
      somethingWentWrong: "Xato yuz berdi",
      csvDownloaded: "CSV yuklab olindi",
    },
    dealDetailPage: {
      call: "qo'ng'iroq",
      outgoing: "Chiquvchi",
      incoming: "Kiruvchi",
      ext: " · Ext: {ext}",
      select: "— Tanlang",
      noOptions: "Variant yo'q",
      failedToLoad: "Yuklanmadi",
      titleIsRequired: "Sarlavha kiritilishi shart",
      saved: "Saqlandi",
      assignedToYou: "O'zingizga oldingiz",
      error: "Xato",
      deleted: "O'chirildi",
      archived: "Arxivlandi",
      restoredFromArchive: "Arxivdan qaytarildi",
      closedAsWon: "G'olib deb yopildi",
      closedAsLost: "Yo'qotilgan deb yopildi",
      reopened: "Qayta ochildi",
      fileUploaded: "Fayl yuklandi",
      uploadFailed: "Yuklashda xato",
      newRequest: "Yangi bitim",
      newDeal: "Yangi bitim",
      request: "Lid",
      won: "G'olib",
      lost: "Yo'qotilgan",
      reopen: "Qayta ochish",
      closeAsWon: "G'olib deb yopish",
      closeAsLost: "Yo'qotilgan deb yopish",
      restoreFromArchive: "Arxivdan qaytarish",
      archive: "Arxivlash",
      reasonOptional: "Sabab (ixtiyoriy)",
      whyWasItLost: " — nima uchun yo'qotildi?",
      noReasonSelected: "— Sabab tanlanmagan —",
      eGTheClientSigned: "Masalan: mijoz shartnoma imzoladi",
      eGThePriceDid: "Masalan: narx to'g'ri kelmadi",
      close: "Yopish",
      reasonComment: "Sabab (izoh) *",
      whyIsItBeingArchived: "Nima uchun arxivlanyapti?",
      clientName: "Mijoz ismi...",
      dealTitle: "Bitim nomi...",
      source: "Manba",
      notSelected: "— Tanlanmagan —",
      note: "Izoh",
      noNotes: "Izoh yo'q",
      notFound: "Topilmadi",
      loading: "Yuklanmoqda...",
      contact: "Kontakt",
      blocked: "Bloklangan",
      phone: "Telefon",
      email: "Email",
      reminder: "Eslatma",
      overdue: "Muddati o'tdi",
      openContact: "Kontaktni ochish",
      notSelected2: "— Tanlanmagan",
      takeIt: "O'zimga olish",
      created: "Yaratilgan",
      days: "kun davomida",
      call2: "Qo'ng'iroq",
      inOut: "Kir/Chiq",
      missedCalls: "O'tkazib yuborilgan qo'ng'iroqlar",
      activityOverTheLast14: "Oxirgi 14 kun faolligi",
      callHistory: "Qo'ng'iroqlar tarixi",
      noCallsYet: "Hali qo'ng'iroq yo'q",
      uploadFile: "+ Fayl yuklash",
      saveFirstToUploadFiles: "Fayl yuklash uchun avval saqlab oling",
      noFilesYet: "Hali fayl yo'q",
      download: "Yuklab olish",
      sections: "Bo'limlar",
      main: "Asosiy",
      stageAmountSourceContactAssignee: "Bosqich · Summa · Manba · Kontakt · Mas'ul",
      fields: "{length} ta maydon",
      sectionName: "Bo'lim nomi...",
      addNewSection: "Yangi bo'lim qo'shish",
      fields2: "Maydonlar",
      noFieldsYet: "Hali maydon yo'q",
      fieldName: "Maydon nomi...",
      options: "Variantlar",
      atLeast1: "(kamida 1 ta)",
      optionName: "Variant nomi...",
      save: "Saqlash",
      cancel: "Bekor",
      add: "Qo'shish",
      addField: "Maydon qo'shish",
      shiftEnterNewLine: "Shift+Enter — yangi qator",
    },
    forgotPasswordPage: {
      serverAndPhoneAreRequired: "Server va telefon kiritilishi shart",
      error: "Xato",
      check: "Tekshiring",
      ifSuchAUserExists: "Agar bunday foydalanuvchi mavjud bo'lsa, parolni tiklash havolasi emailga yuborildi. Havola 1 soat amal qiladi.",
      backToSignIn: "Kirishga qaytish",
      resetPassword: "Parolni tiklash",
      enterYourServerAndPhone: "Server va telefon raqamingizni kiriting — emailingizga tiklash havolasi yuboriladi.",
      server: "Kompaniya kodi",
      phone: "Telefon",
      sendLink: "Havola yuborish",
      sending: "Yuborilmoqda...",
    },
    funnelPage: {
      age: "{days} kun oldin yaratilgan",
      dealsLabel: "Bitimlar:",
      archive: "Arxivlash",
      request: "Lid",
      d: "{days} kun",
      takeIt: "O'zimga olish",
      reactivate: "Qayta faollashtirish",
      deal: "bitim",
      empty: "Bo'sh",
      selectEverythingInThisStage: "Shu bosqichdagilarni tanlash",
      quickAdd: "Tez qo'shish",
      request2: "Lidlar:",
      source: "Manba",
      notSelected: "— Tanlanmagan —",
      titleStageContactPhoneSource: "Sarlavha, Bosqich, Kontakt, Telefon, Manba, Qiymat, Status, Izoh",
      failedToLoad: "Yuklanishda xato",
      restoredFromArchive: "Arxivdan qaytarildi",
      error: "Xato",
      deleted: "O'chirildi",
      archive2: "Arxiv",
      theArchiveIsEmpty: "Arxiv bo'sh",
      openDeal: "Bitimni ochish",
      restore: "Qaytarish",
      closedAsWon: "G'olib deb yopildi",
      closedAsLost: "Yo'qotilgan deb yopildi",
      assignedToYou: "O'zingizga oldingiz",
      reactivated: "Qayta faollashtirildi",
      leadAdded: "Lid qo'shildi",
      selected: "{size} ta tanlandi",
      moveToStage: "Bosqichga o'tkazish...",
      toAnotherFunnel: "Boshqa varonkaga",
      assign: "Biriktirish...",
      unassign: "— Biriktirmaslik —",
      deletePermanently: "Rostdan o'chirilsinmi?",
      no: "Yo'q",
      yesDelete: "Ha, o'chirish",
      delete: "O'chirish",
      close: "Yopish",
      thisFunnelHasNoStages: "Bu varonkada bosqichlar yo'q",
      addStagesInSettingsFunnels: "Sozlamalar → Varonkalar dan bosqich qo'shing",
      won: "G'olib",
      lost: "Yo'qotilgan",
      chooseAnAssignee: "Mas'ul xodimni tanlang",
      dealsSelected: "{size} ta tanlangan bitim",
      chooseAnEmployee: "Xodimni tanlang...",
      cancel: "Bekor",
      confirm: "Tasdiqlash",
      closeAsWon: "G'olib deb yopish",
      closeAsLost: "Yo'qotilgan deb yopish",
      reasonOptional: "Sabab (ixtiyoriy)",
      whyWasItLost: " — nima uchun yo'qotildi?",
      noReasonSelected: "— Sabab tanlanmagan —",
      eGTheClientSigned: "Masalan: mijoz shartnoma imzoladi",
      eGThePriceDid: "Masalan: narx to'g'ri kelmadi",
      responsibleEmployee: "Mas'ul xodim",
      moveToAnotherFunnel: "Boshqa varonkaga o'tkazish",
      selected2: "tanlandi",
      leads: "{size} ta lid",
      willBeArchived: "arxivlanadi",
      leads2: "{length} ta lid",
      reasonComment: "Sabab (izoh) *",
      whyIsItBeingArchived: "Nima uchun arxivlanyapti?",
    },
    inboxAnalyticsPage: {
      previousPeriod: "{pct}% (o'tgan davr: {prevValue})",
      conversationsPerDay: "Kunlik suhbatlar",
      days: "{length} kun",
      text: "{count} ta · {date}",
      inbox: "Xabarlar",
      totalConversations: "Jami suhbatlar",
      unanswered: "Javob berilmagan",
      closed: "Yopilgan",
      avgResponseTime: "O'rt. javob vaqti",
      comparePeriods: "Davr solishtiruvchi",
      total: "Jami",
      resolved: "Hal qilish %",
      conversationsPerDay2: "Kunlik suhbatlar ({from} — {to})",
      byChannel: "Kanallar bo'yicha",
      noData: "Ma'lumot yo'q",
      agents: "Agentlar",
      labels: "Yorliqlar",
      noLabels: "Yorliq yo'q",
      reportByEmployee: "Xodimlar bo'yicha hisobot",
      downloadCsv: "CSV yuklab olish",
      employee: "Xodim",
      conversations: "Suhbatlar",
      closed2: "Yopish %",
      avgReply: "O'rt. javob",
      call: "Qo'ng'iroq",
    },
    inboxPage: {
      anonymous: "Anonim",
      comment: "Komment",
      loading: "Yuklanmoqda...",
      file: "Fayl",
      openFile: "Faylni ochish",
      post: "Post",
      instagramPost: "Instagram post",
      internalNote: "Ichki eslatma",
      replyToThisComment: "Shu kommentga javob berish",
      failedToLoad: "Yuklanishda xato",
      error: "Xato",
      chatClosed: "Chat yopildi",
      chatReopened: "Chat qayta ochildi",
      failedToLoadData: "Ma'lumot yuklanmadi",
      thisContactAlreadyExists: "Bu kontakt allaqachon mavjud",
      contactCreated: "Kontakt yaratildi",
      agentAssigned: "Agent belgilandi",
      agentRemoved: "Agent olib tashlandi",
      deleteThisChatAllMessages: "Bu chatni o'chirishni tasdiqlaysizmi? Barcha xabarlar ham o'chadi.",
      deleteFailed: "O'chirishda xato",
      inbox: "Xabarlar",
      search: "Qidirish...",
      conversations: "{convTotal} ta suhbat",
      previous: "← Oldingi",
      next: "Keyingi →",
      back: "Orqaga",
      searchMessages: "Xabar qidirish",
      changeAgent: "Agent o'zgartirish",
      chooseAnAgent: "Agent tanlang",
      remove: "Olib tashlash",
      labels: "Yorliqlar",
      availableLabels: "Mavjud yorliqlar",
      newLabel: "Yangi yorliq...",
      reopenChat: "Chatni qayta ochish",
      contactInfo: "Kontakt ma'lumotlari",
      commentsUnderThePostClick: "Post ostidagi kommentlar · javob bermoqchi bo'lgan kommentda",
      pressTheButton: "tugmasini bosing",
      searchInMessages: "Xabarlar ichida qidirish...",
      results: "{length} ta natija",
      replyToTheSelectedComment: "Tanlangan kommentga javob",
      replyToTheLatestComment: "Oxirgi kommentga javob",
      cancel: "Bekor qilish",
      addAStickerPackIn: "Sozlamalarda sticker pack qo'shing",
      sticker: "Sticker",
      sendFile: "Fayl yuborish",
      status: "Status",
      call: "Qo'ng'iroq qilish",
      phone: "Telefon",
      email: "Email",
      noPacks: "Pack yo'q",
      noStickersFound: "Sticker topilmadi",
      selectAConversation: "Suhbat tanlang",
      openAConversationFromThe: "Chap tomondagi ro'yxatdan suhbatni oching",
    },
    resetPasswordPage: {
      passwordMustBeAtLeast: "Parol kamida 6 ta belgi bo'lishi kerak",
      passwordsDoNotMatch: "Parollar mos kelmadi",
      passwordChangedYouCanSign: "Parol o'zgartirildi. Endi kiring.",
      error: "Xato",
      newPassword: "Yangi parol",
      theLinkIsInvalidPlease: "Havola yaroqsiz. Iltimos, parolni tiklashni qaytadan boshlang.",
      tryAgain: "Qaytadan urinish",
      enterYourNewPassword: "Yangi parolingizni kiriting.",
      confirmPassword: "Parolni tasdiqlang",
      changePassword: "Parolni o'zgartirish",
      saving: "Saqlanmoqda...",
    },
    reviewsPage: {
      uploadFailed: "Yuklashda xato",
      failedToLoadReviews: "Sharhlarni yuklashda xato",
      deleteThisPage: "Bu sahifani o'chirasizmi?",
      error: "Xato",
      newReviewsCollected: "{added} ta yangi otziv yig'ildi",
      noNewReviews: "Yangi otziv yo'q",
      collectionFailed: "Yig'ishda xato",
      reviews: "Sharhlar",
      collectCustomerReviewsViaQr: "QR orqali mijozlardan otziv yig'ing",
      newPage: "Yangi sahifa",
      scans: "Skanlar",
      reviewClicks: "Otziv kliki",
      conversion: "Konversiya",
      newComplaints: "Yangi shikoyat",
      googleReviews: "Google otzivlar",
      edit: "Tahrir",
      delete: "O'chirish",
      totalReviews: "Jami: {collectedTotal} ta otziv",
      collectNow: "Hoziroq yig'ish",
      noMapReviewsCollectedYet: "Hozircha xaritalardan otziv yig'ilmagan. Sahifada Google/Yandex bog'langan bo'lsa, otzivlar avtomatik (har bir necha soatda) yig'iladi.",
      anonymous: "Anonim",
      loadMore: "Yana yuklash ({length}/{collectedTotal})",
      noInternalFeedbackYet: "Hozircha ichki feedback yo'q",
      contact: "Kontakt",
      complaint: "Shikoyat",
      reviewed: "Ko'rib chiqildi",
      saved: "Saqlandi",
      saveFailed: "Saqlashda xato",
      testMessageSent: "Test xabari yuborildi ✅",
      testWasNotSent: "Test yuborilmadi",
      telegramNotifications: "Telegram bildirishnoma",
      newGoogleYandexReviewsAre: "Yangi Google/Yandex otzivlari kelganda Telegram guruh/kanalingizga avtomatik yuboriladi.",
      notificationsEnabled: "Bildirishnoma yoqilgan",
      botToken: "Bot token",
      savedEnterANewOne: "•••••• (saqlangan — o'zgartirish uchun yangisini kiriting)",
      createABotInBotfather: "@BotFather'dan bot yarating va tokenini kiriting.",
      chatId: "Chat ID",
      "1001234567890OrChannelName": "-1001234567890 yoki @kanal_nomi",
      addTheBotToThe: "Botni guruhga qo'shing. Guruh chat_id'sini @getidsbot orqali biling.",
      saving: "Saqlanmoqda...",
      save: "Saqlash",
      test: "Test",
      noPagesYet: "Hali sahifa yo'q",
      createYourFirstReviewPage: "Birinchi otziv sahifangizni yarating",
      failedToDownloadQr: "QR yuklab olishda xato",
      downloadQr: "QR yuklab olish",
      printItAndPlaceIt: "Chop etib stolga qo'ying",
      googlePlaceLinkedTheReview: "Google joyi bog'landi — otziv havolasi avtomatik to'ldirildi",
      linkingFailed: "Bog'lashda xato",
      updated: "Yangilandi",
      updateFailed: "Yangilashda xato",
      unlinkGoogle: "Google bog'lanishini uzasizmi?",
      unlinked: "Uzildi",
      googleReviews2: "Google otzivlar — {name}",
      findYourBusinessOnGoogle: "Biznesingizni Google Maps'da toping va bog'lang — reyting va otzivlar shu yerda ko'rinadi.",
      eGCaffeBahorChilanzar: "Masalan: Caffe Bahor, Chilonzor Toshkent",
      nothingFoundRefineTheName: "Hech narsa topilmadi — nomni aniqroq yozing",
      reviews2: "{toFixed} · {total} otziv",
      onTheMap: "Xaritada",
      reviews3: "ta otziv",
      updated2: "Yangilangan: {syncedLabel}",
      inMin: "{cooldownMin} daqiqadan so'ng",
      refresh: "Yangilash",
      unlink: "Uzish",
      reviewTextNotFound: "Sharhlar matni topilmadi",
      user: "Foydalanuvchi",
      googlePlacesApiReturnsOnly: "Google Places API faqat oxirgi ~5 otzivni qaytaradi.",
      googleApiKeyIsNot: "Google API kaliti sozlanmagan",
      searchError: "Qidiruvda xato",
      yandexApiKeyIsNot: "Yandex API kaliti sozlanmagan",
      "2gisConnectedReviewsCollected": "2GIS bog'landi — otzivlar yig'ildi",
      "2gisConnectionError": "2GIS bog'lashda xato",
      "2gisDisconnected": "2GIS uzildi",
      enterAName: "Nom kiriting",
      editing: "Tahrirlash",
      newReviewPage: "Yangi otziv sahifasi",
      nameBranch: "Nom (filial)",
      chilanzarBranch: "Chilonzor filiali",
      titleVisibleToTheCustomer: "Sarlavha (mijoz ko'radi)",
      reviews4: "{toFixed}★ · {total} otziv",
      change: "O'zgartirish",
      googleReviewLinkFilledIn: "Google otziv havolasi avtomatik to'ldirildi",
      linkAGoogleMapsPlace: "Google Maps joyini bog'lash (URL avtomatik to'ladi)",
      enterTheBusinessName: "Biznes nomini kiriting...",
      notFoundRefineYourQuery: "Topilmadi — aniqroq yozing",
      yandexReviewLinkFilledIn: "Yandex otziv havolasi avtomatik to'ldirildi",
      linkAYandexMapsPlace: "Yandex Maps joyini bog'lash (URL avtomatik to'ladi)",
      "2gisBranch": "2GIS filiali",
      review: "otziv",
      toLink2gisSaveThe: "2GIS bog'lash uchun avval sahifani saqlang, keyin qayta oching.",
      "2gisLink2gisUzTashkent": "2GIS havolasi: 2gis.uz/tashkent/firm/70000...",
      link: "Bog'lash",
      platformsAndLinks: "Platformalar va havolalar",
      filledInAutomaticallyWhenA: "Google joyi bog'lansa avtomatik to'ladi",
      reviewLinkUrl: "otziv havolasi (URL)",
      smartRoutingGating: "Aqlli yo'naltirish (gating)",
      highRatingMapLowRating: "Yuqori baho → xaritaga; past baho → ichki feedback",
      publishingThreshold: "Ommaga yuborish chegarasi:",
      "4AndAbove": "4★ va yuqori",
      "5Only": "faqat 5★",
      "3AndAbove": "3★ va yuqori",
      googleProhibitsReviewGatingTurn: "⚠️ Google \"review gating\"ni taqiqlaydi — kerak bo'lmasa o'chiring.",
      cancel: "Bekor",
    },
    settingsPage: {
      main: "Asosiy",
      contactDetails: "Aloqa ma'lumotlari",
      appearance: "Ko'rinish",
      baseCurrency: "Asosiy valyuta",
      allDealsAndLeadsAre: "Barcha bitim va lidlar shu valyutada ko'rsatiladi.",
      directorSFullName: "Direktor ism familiyasi",
      eGAliyevJasurAkhmadovich: "Masalan: Aliyev Jasur Ahmadovich",
      officeNumber: "Office raqami",
      address: "Manzil",
      eGTashkentChilanzarDistrict: "Masalan: Toshkent sh., Chilonzor t., 12-uy",
      website: "Web sayt",
      usernameOrFullLink: "@username yoki to'liq link",
      usernameOr998: "@username yoki +998...",
      funnelNameIsRequired: "Varonka nomi kiritilishi shart",
      saved: "Saqlandi",
      funnelCreated: "Varonka yaratildi",
      error: "Xato",
      deleted: "O'chirildi",
      funnels: "Varonkalar",
      configureDealAndLeadStages: "Bitim va lid bosqichlarini sozlang",
      newFunnel: "Yangi varonka",
      noFunnelsYet: "Hali varonka yo'q",
      createANewFunnelAnd: "Yangi varonka yarating va ichiga bosqichlar qo'shing",
      noStages: "Bosqichlar yo'q",
      editFunnel: "Varonkani tahrirlash",
      funnelName: "Varonka nomi",
      eGMainSalesB2b: "Masalan: Asosiy savdo, B2B, Premium...",
      stages: "Bosqichlar (etaplar)",
      add: "Qo'shish",
      color: "Rang",
      aDealReachingThisStage: "Bu bosqichga tushsa bitim avtomatik G'olib (savdo) deb belgilanadi",
      won: "G'olib",
      aDealReachingThisStage2: "Bu bosqichga tushsa bitim avtomatik Yo'qotilgan deb belgilanadi",
      lost: "Yo'qotilgan",
      choosingAnAssigneeIsRequired: "Bu bosqichga o'tkazishda mas'ul xodim tanlash majburiy bo'ladi (masalan qabuldan menejerga topshirish)",
      assigneeRequired: "Mas'ul tanlash majburiy",
      staysInThisFunnel: "Shu voronkada qoladi",
      moveTo: "{name}ga o'tkazilsin",
      chooseAStage: "Bosqich tanlang",
      whichRolesCanSeeIt: "Qaysi rollarga ko'rinsin",
      ifNoneIsSelectedVisible: "Hech qaysisi tanlanmasa — hammaga ko'rinadi (standart).",
      noCustomRolesCreated: "Maxsus rol yaratilmagan",
      cancel: "Bekor",
      save: "Saqlash",
      create: "Yaratish",
      failedToLoad: "Yuklanishda xato",
      taskStages: "Vazifalar bosqichlari",
      configureTheKanbanColumnsTasks: "Kanban ustunlarini sozlang. \"Bajarilgan\" belgisi qo'yilgan bosqichdagi vazifalar yakunlangan hisoblanadi.",
      done: "Bajarilgan:",
      notCompleted: "Yakunlanmagan:",
      doneStage: "Bajarilgan bosqich",
      done2: "Bajarilgan",
      addStage: "Bosqich qo'shish",
      salesSources: "Savdolar manbalari",
      sourcesThatCanBeChosen: "Savdo qo'shishda tanlash mumkin bo'lgan manbalar",
      addSource: "Manba qo'shish",
      addReason: "Sabab qo'shish",
      closingReasons: "Yopish sabablari",
      whenADealIsClosed: "Bitim \"G'olib\" yoki \"Yo'qotilgan\" deb yopilganda xodim shu ro'yxatdan sabab tanlaydi — erkin matn o'rniga, statistikada bir xil qiymatlar chiqishi uchun.",
      whenWon: "G'olib bo'lganda",
      whenLost: "Yo'qotilganda",
      formNameIsRequired: "Forma nomi kiritilishi shart",
      selectAFunnel: "Voronka tanlanishi shart",
      selectAStage: "Bosqich tanlanishi shart",
      formUpdated: "Forma yangilandi",
      formCreated: "Forma yaratildi",
      somethingWentWrong: "Xato yuz berdi",
      editForm: "Formani tahrirlash",
      newForm: "Yangi forma",
      formName: "Forma nomi",
      eGWebsiteContactForm: "Masalan: Sayt aloqa formasi",
      funnel: "Voronka",
      stage: "Bosqich",
      titleOnTheFormPage: "Sarlavha (forma sahifasida)",
      additionalDescription: "Qo'shimcha izoh",
      optional: "Ixtiyoriy...",
      formColor: "Forma rangi",
      organizationBrandColor: "Tashkilot brend rangi",
      customColor: "Maxsus rang",
      everyFormAlways: "Har bir formada",
      and: "va",
      fieldsRequired: "maydonlari doim bo'ladi (majburiy).",
      name: "Ism",
      phone: "Telefon",
      extraQuestions: "Qo'shimcha savollar",
      required: "Majburiy",
      noExtraQuestionsYet: "Hali qo'shimcha savol yo'q",
      questionText: "Savol matni...",
      options: "Variantlar",
      atLeast1: "(kamida 1 ta)",
      optionName: "Variant nomi...",
      addQuestion: "Savol qo'shish",
      uploadFailed: "Yuklashda xato",
      linkCopied: "Havola nusxalandi",
      couldNotCopy: "Nusxalab bo'lmadi",
      formDeleted: "Forma o'chirildi",
      leadForms: "Lid formalar",
      placeOnYourWebsiteOr: "Saytga/ijtimoiy tarmoqlarga joylashtiring — to'ldirilgan arizalar tanlangan voronkaga tushadi.",
      firstCreateAFunnelIn: "Avval Varonkalar bo'limida voronka yarating.",
      inactive: "Nofaol",
      requests: "ta ariza",
      delete: "O'chirish",
      enable: "Yoqish",
      noFormsYet: "Hali forma yo'q",
      deleteForm: "Formani o'chirish",
      willBeDeletedTheLink: "formasi o'chiriladi. Havola ishlamay qoladi.",
      moduleVisibility: "Modullar ko'rinishi",
      whichModulesToShowOr: "Yuqori panel va menyuda qaysi modullar ko'rinsin yoki ko'rinmasin — bu barcha foydalanuvchilarga tegishli.",
      hidden: "Yashirin",
      visible: "Ko'rinadi",
      goals: "Maqsadlar (Цели)",
      setSalesGoalsOverallAnd: "Jami va xodimlar bo'yicha savdo maqsadlarini belgilang",
      overallGoal: "Jami maqsad",
      amountUzs: "Summa (UZS)",
      numberOfSales: "Savdolar soni",
      byEmployee: "Xodimlar bo'yicha",
      amountGoal: "Summa maqsadi",
      countGoal: "Soni maqsadi",
      pushNotificationsEnabled: "Push bildirishnomalar yoqildi!",
      permissionDeniedOrTheBrowser: "Ruxsat berilmadi yoki brauzer qo'llab-quvvatlamaydi",
      anErrorOccurred: "Xatolik yuz berdi",
      pushNotificationsDisabled: "Push bildirishnomalar o'chirildi",
      instagramConnectedSuccessfully: "Instagram muvaffaqiyatli ulandi!",
      connectionError: "Ulanishda xato yuz berdi",
      facebookConnectedSuccessfully: "Facebook muvaffaqiyatli ulandi!",
      facebookConnectionError: "Facebook ulanishda xato",
      failedToStartOauth: "OAuth boshlanishda xato",
      disconnectInstagram: "Instagram'ni uzib qo'yishni tasdiqlaysizmi?",
      instagramDisconnected: "Instagram uzildi",
      facebookDisconnected: "Facebook uzildi",
      enterThePhoneNumberId: "Phone Number ID va Access Token kiriting",
      whatsappConnected: "WhatsApp ulandi!",
      connectionError2: "Ulanishda xato",
      disconnectWhatsapp: "WhatsApp'ni uzib qo'yishni tasdiqlaysizmi?",
      whatsappDisconnected: "WhatsApp uzildi",
      thisPackHasAlreadyBeen: "Bu pack allaqachon qo'shilgan",
      stickerPacksSaved: "Sticker packlar saqlandi",
      botTokenIsRequired: "Bot token kiritilishi shart",
      connected: "@{botUsername} ulandi",
      connectionCancelled: "Ulanish bekor qilindi",
      disconnectTheBot: "Botni uzib qo'yishni tasdiqlaysizmi?",
      botDisconnected: "Bot uzildi",
      enterAPhoneNumber: "Telefon raqam kiriting",
      theCodeWasSentTo: "Kod Telegram ilovangizga yuborildi",
      couldNotSendTheCode: "Kod yuborib bo'lmadi",
      enterTheCode: "Kodni kiriting",
      enterThePassword: "Parolni kiriting",
      telegramAccountConnected: "Telegram akkaunt ulandi",
      signInFailed: "Kirish amalga oshmadi",
      disconnectTheAccountConversationsWill: "{label} akkauntini uzib qo'yasizmi? Suhbatlar yopiladi.",
      accountDisconnected: "Akkaunt uzildi",
      emailSettingsSaved: "Email sozlamalari saqlandi",
      testFailed: "Test muvaffaqiyatsiz",
      socialNetworks: "Ijtimoiy tarmoqlar",
      email: "Email",
      notifications: "Bildirishnomalar",
      integrations: "Integratsiyalar",
      connectExternalChannelsToThe: "Tashqi kanallarni CRM ga ulang",
      telegramBot: "Telegram Bot",
      superchatAllMessagesArriveIn: "Superchat — barcha xabarlar Xabarlar bo'limiga keladi",
      connected2: "Ulangan",
      active: "faol",
      notConfigured: "sozlanmagan",
      theBotWorksViaWebhook: "Bot webhook orqali ishlayapti. Foydalanuvchilar botga yozsa, xabarlar Xabarlar sahifasiga keladi.",
      disconnect: "Uzib qo'yish",
      botToken: "Bot Token",
      createANewBotAnd: "dan yangi bot yaratib, tokenini kiriting",
      connect: "Ulash",
      telegramAccounts: "Telegram akkauntlar",
      personalProfileTheCustomerWrites: "Shaxsiy profil — mijoz bot emas, jonli odamga yozadi",
      text: "{length} ta",
      anEmployeeSPersonalTelegram: "Xodimning shaxsiy Telegram akkaunti ulanadi — unga kelgan yozishmalar Xabarlar bo'limida ko'rinadi va CRM'dan javob yozilganda mijoz o'sha profildan xabar oladi.",
      addAccount: "Akkaunt qo'shish",
      automatingAPersonalAccountViolates: "Shaxsiy akkauntni avtomatlashtirish Telegram qoidalari bo'yicha xavf tug'diradi — spam yuborilsa akkaunt bloklanishi mumkin.",
      connectATelegramAccount: "Telegram akkaunt ulash",
      phoneNumber: "Telefon raqam",
      telegramWillSendAConfirmation: "Telegram shu raqamga tasdiqlash kodi yuboradi (kod ilovaning o'zida keladi).",
      sendCode: "Kod yuborish",
      verificationCode: "Tasdiqlash kodi",
      codeSentTo: "{phone} raqamiga yuborilgan kod",
      confirm: "Tasdiqlash",
      "2faPassword": "2FA parol",
      cloudPassword: "Cloud parol",
      twoStepVerificationIsEnabled: "Akkauntda ikki bosqichli tasdiqlash yoqilgan",
      signIn: "Kirish",
      stickerPacks: "Sticker Packlar",
      stickerSetsForInboxChat: "Xabarlar chati uchun sticker to'plamlari",
      add2: "Qo'sh",
      view: "ko'rish",
      noStickerPacksAddedYet: "Hali sticker pack qo'shilmagan",
      instagramDm: "Instagram DM",
      connectDirectMessagesToInbox: "Direct xabarlarni Xabarlar bo'limiga ulang",
      instagramBusinessAccountConnected: "Instagram Business akkaunt ulangan",
      instagramDmMessagesArriveOn: "Instagram DM xabarlari avtomatik ravishda Xabarlar sahifasiga kelib tushadi.",
      connectYourInstagramBusinessOr: "Instagram Business yoki Creator akkauntingizni ulang. Facebook sahifangiz orqali OAuth orqali avtorizatsiya qilinadi.",
      connectViaFacebook: "Facebook orqali ulash",
      metaDeveloperAppIdAnd: "Meta Developer App ID va Secret .env da sozlangan bo'lishi kerak",
      emailImapSmtp: "Email (IMAP/SMTP)",
      receiveAndReplyToEmail: "Xabarlar bo'limiga email xabarlarini qabul qiling va javob bering",
      imapIncomingMessages: "IMAP — kiruvchi xabarlar",
      passwordAppPassword: "Parol / App password",
      useTlsSslPort993: "TLS/SSL ishlatish (port 993)",
      smtpOutgoingMessages: "SMTP — chiquvchi xabarlar",
      senderNameEmailFrom: "Jo'natuvchi ismi/email (From)",
      useSslPort465: "SSL ishlatish (port 465)",
      imap: "IMAP:",
      success: "Muvaffaqiyatli",
      smtp: "SMTP:",
      test: "Test",
      forGmailEnableAppPasswords: "Gmail uchun \"App passwords\" yoqing. IMAP ilovasi yangi xabarlarni avtomatik oladi va Xabarlar bo'limiga qo'shadi.",
      pushNotifications: "Push Bildirishnomalar",
      aNotificationIsSentTo: "Yangi xabar kelganda qurilmangizga bildirishnoma yuboriladi",
      yourBrowserDoesNotSupport: "Brauzeringiz push bildirishnomalarni qo'llab-quvvatlamaydi",
      browserPermissionWasDeniedAllow: "Brauzer ruxsati rad etilgan. Brauzer sozlamalaridan bildirishnomaga ruxsat bering.",
      notificationsEnabled: "✓ Bildirishnomalar yoqilgan",
      notificationsDisabled: "Bildirishnomalar o'chirilgan",
      facebookMessenger: "Facebook Messenger",
      connectPageMessagesToInbox: "Page xabarlarni Xabarlar bo'limiga ulang",
      facebookPageConnected: "Facebook Page ulangan",
      reallyDisconnect: "Rostdan uzasizmi?",
      cancel2: "Bekor qilish",
      yesDisconnect: "Ha, uzish",
      targetLeadAdsLeads: "Target (Lead Ads) lidlari",
      leadsFromInstagramFacebookAds: "Instagram/Facebook reklamasidan (Lead Ads formasi orqali) kelgan lidlar shu voronka+bosqichga avtomatik tushadi.",
      noFunnelSelected: "— Voronka tanlanmagan —",
      noStageSelected: "— Bosqich tanlanmagan —",
      untilAFunnelIsSelected: "Voronka tanlanmaguncha target lidlar CRM'ga tushmaydi.",
      connectYourFacebookBusinessPage: "Facebook biznes sahifangizni ulang. Sahifaga kelgan Messenger xabarlari Xabarlar bo'limiga tushadi.",
      whatsappBusiness: "WhatsApp Business",
      connectViaCloudApi: "Cloud API orqali ulang",
      whatsappCloudApiConnected: "WhatsApp Cloud API ulangan",
      enterTheMetaCloudApi: "Meta Cloud API ma'lumotlarini kiriting (Meta dashboard → WhatsApp → API Setup).",
      whatsappBusinessAccountIdOptional: "WhatsApp Business Account ID (ixtiyoriy)",
      phoneNumberEG998: "Telefon raqami (mas. +998...)",
      accessTokenPermanent: "Access Token (permanent)",
      orders: "Zakazlar",
      salesPurchases: "Savdo & Xarid",
      cashier: "Kassir",
      other: "Boshqa",
      employeeReportPhotoVideoLocation: "Xodim hisoboti (rasm/video/lokatsiya)",
      employeeCreatesASupplyRequest: "Xodim snabjeniyaga zapros yaratsin",
      enterStartDate: "Boshlanish sanasini kiritish",
      createEstimatesInJobOrders: "Job orderlarda smeta yaratish",
      showEstimatesToEmployees: "Xodimlarga smeta ko'rinsin",
      showPricesToEmployees: "Xodimlarga narxlar ko'rinsin",
      colourWarningAsTheDeadline: "Muddat yaqinlashganda rang ogohlantirishi",
      colourRules: "Rang qoidalari",
      ifTheDeadlineIsToday: "Muddat bugun uchib o'tsa — har doim qizil. Quyida esa: X kun qolganda qanday rang.",
      addRule: "+ Qoida qo'shish",
      noRulesYetClickAdd: "Hozircha qoida yo'q. \"+ Qoida qo'shish\" ni bosing.",
      daysLeft: "{daysLeft} kun qoldi",
      days: "Kun:",
      background: "Fon:",
      text2: "Matn:",
      overdue: "Muddati o'tdi",
      alwaysRedCannotBeChanged: "Har doim qizil — o'zgartirish mumkin emas",
      tvModeButton: "TV rejimi tugmasi",
      freezePauseOption: "Muzlatish (pauza) imkoniyati",
      accountingTriggers: "Hisobga olish triggerlari",
      whenMovingToTheStatus: "Quyida tanlangan statusga o'tilganda tegishli amal avtomatik bajariladi. Bo'sh qoldirilsa — eski «Tasdiqlangan» tugma orqali boshqariladi.",
      stockTrigger: "Qoldiq triggeri",
      inWhichStatusToDeduct: "— qaysi statusda tovar qoldig'idan ayirilsin",
      notSetLegacy: "— Belgilanmagan (eski usul) —",
      debtTrigger: "Qarz triggeri",
      inWhichStatusToRecord: "— qaysi statusda kontragent qarzdorligi shakllansin",
      noFolders: "— Papkalar yo'q —",
      noneSelectedAllFoldersAre: "Hech biri tanlanmagan — barcha papkalar ko'rinadi",
      hideWarehouseSelectionInThe: "Formada ombor tanlovini yashirish",
      whichModulesAndSubmodulesTo: "Sidebardan qaysi modullar va sub-modullar ko'rinsin yoki ko'rinmasin",
      extensionPbx: "Ichki raqam (ATC)",
      eG209: "Masalan: 209",
      pbxExtensionSipuniIbratSip: "ATC (Sipuni/ibrat.sip.uz) ichki raqami — xodim ATC orqali qo'ng'iroq qilishda ishlatiladi.",
      nameIsRequired: "Nom kiritilishi shart",
      error2: "Xatolik",
      confirmDeletion: "O'chirishni tasdiqlaysizmi?",
      failedToLoad2: "Yuklanmadi",
      titleAndTextAreRequired: "Sarlavha va matn kiritilishi shart",
      updated: "Yangilandi",
      added: "Qo'shildi",
      quickReplies: "Tezkor javoblar (Quick Replies)",
      whenTypingInAChat: "Chat yozganda",
      pressAndChooseAQuick: "bosib tezkor javoblarni tanlang",
      editing: "Tahrirlash",
      addNew: "Yangi qo'shish",
      title: "Sarlavha *",
      eGHello: "masalan: salom",
      shortcut: "Shortcut",
      text3: "Matn *",
      replyText: "Javob matni...",
      noQuickReplies: "Tezkor javob yo'q",
    },
    tasksPage: {
      error: "Xato",
    },
    userProfilePage: {
      userNotFound: "Foydalanuvchi topilmadi",
      nameIsRequired: "Ism kiritilishi shart",
      phoneNumberIsRequired: "Telefon raqam kiritilishi shart",
      saved: "Saqlandi",
      error: "Xato",
      imageWasNotUploaded: "Rasm yuklanmadi",
      filesUploaded: "{length} ta fayl yuklandi",
      uploadFailed: "Yuklashda xato",
      passwordMustBeAtLeast: "Parol kamida 4 belgi",
      passwordChanged: "Parol o'zgartirildi",
      userProfile: "Foydalanuvchi profili",
      user: "Foydalanuvchi",
      password: "Parol",
      save: "Saqlash",
      you: "Siz",
      active: "Faol",
      inactive: "Nofaol",
      basicInformation: "Asosiy ma'lumotlar",
      name: "Ism *",
      phoneNumber: "Telefon raqam *",
      signInIsDoneWith: "Tizimga kirish (login) shu raqam bilan amalga oshiriladi.",
      extensionPbx: "Ichki raqam (ATC)",
      eG209: "Masalan: 209",
      eMail: "E-mail",
      dateOfBirth: "Tug'ilgan kun",
      ddMmYyyy: "KK/OO/YYYY",
      homeAddress: "Yashash joyi manzili",
      cityStreetHouse: "Shahar, ko'cha, uy...",
      additionalPhoneNumbers: "Qo'shimcha telefon raqamlar",
      add: "Qo'shish",
      noAdditionalNumbers: "Qo'shimcha raqam yo'q",
      homeWork: "Uy / Ish",
      positionAndPermissions: "Lavozim va ruxsatlar",
      position: "Lavozim",
      organizationOwner: "Tashkilot egasi",
      administrator: "Administrator",
      employee: "Xodim",
      department: "Bo'lim",
      noDepartment: "Bo'limsiz",
      customRole: "Custom rol",
      noRoleDefault: "Rol yo'q (standart)",
      passportAndDocuments: "Passport va hujjatlar",
      uploadFile: "Fayl yuklash",
      imagesAndPdfFilesAre: "Rasm yoki PDF formatdagi fayllar qabul qilinadi. Maks. 15 MB.",
      noDocumentsUploaded: "Hujjatlar yuklanmagan",
      passportScanPhotoProofOf: "Passport rasm/skanni, yashash joyi hujjati va boshqalar",
      changePassword: "Parol o'zgartirish",
      newPassword: "Yangi parol",
      atLeast4Characters: "Kamida 4 belgi",
      cancel: "Bekor",
    },
  },

  shared: {
    fieldTypes: {
      text: "Matn",
      textarea: "Katta matn",
      number: "Son",
      phone: "Telefon",
      email: "Email",
      url: "URL",
      date: "Sana",
      boolean: "Ha / Yo'q",
      dropdown: "Dropdown (1 ta)",
      multiselect: "Dropdown (ko'p)",
      file: "Fayl",
    },
    callStatus: {
      ringing: "Jiringlagan",
      active: "Faol",
      completed: "Gaplashildi",
      missed: "O'tkazib yuborilgan",
      cancelled: "Bekor qilindi",
    },
    dateFilters: {
      all: "Hammasi",
      today: "Bugun",
      week: "Bu hafta",
      month: "Bu oy",
    },
    profileTabs: {
      info: "Ma'lumotlar",
      docs: "Hujjatlar",
    },
    fileN: "Fayl {n}",
    stageN: "Bosqich {n}",
    sourceN: "Manba {n}",
    reasonN: "Sabab {n}",
  
    created: "Yaratildi",
  
    user: "Foydalanuvchi",
  
    dealTabs: { main: "Asosiy", 
    stats: "Statistika",
  
    files: "Fayllar",
  
    settings: "Sozlama",
  },
  
    reviewTabs: { pages: "Sahifalar", 
    collected: "Xarita otzivlari",
  
    feedback: "Ichki feedback ({n})",
  },
  
    noLinkedPages: "Google/Yandex bog'langan sahifa yo'q",
  
    googleKeyMissing: "Google API kaliti hali sozlanmagan (GOOGLE_PLACES_API_KEY)",
  
    searchError: "Qidiruvda xato",
  
    save2gisFirst: "Avval sahifani saqlang, keyin 2GIS bog'lang",
  
    hoursN: "{n} soat",
  
    loadFailed: "Yuklanmadi",
  
    resolvedN: "Hal qilish: {n}%",
  
    firstReply: "Birinchi javob",
  
    genericError: "Xato yuz berdi",
  
    error: "Xato",
  
    justNow: "Hozir",
  
    minShort: "{n}d",
  
    regFeatures: { f1: "Sklad va mahsulotlar hisobi", 
    f2: "Sotuv va xarid jarayonlari",
  
    f3: "Mijozlar va ta'minotchilar",
  
    f4: "Moliyaviy hisobotlar",
  },
  
    contactCreated: "Kontakt yaratildi",
  
    fileUploadFailed: "Fayl yuklanmadi: {name}",
  
    yes: "Ha",
  
    no: "Yo'q",
  
    fileLabel: "📎 Fayl",
  
    callAction: "Qo'ng'iroq qilish",
  
    roles: { owner: "Egasi", 
    admin: "Admin",
  
    user: "Foydalanuvchi",
  },
  
    sumSymbol: "so'm",
  
    hourShort: "{n}s",
  
    dayShort: "{n}k",
  },

  assignees: {
    none: "Tayinlanmagan",
    hint: "Bir nechtasini tanlash mumkin. Birinchisi — asosiy",
    clear: "Tozalash",
    primary: "asosiy",
  },

  contactHistory: {

    fromDeal: "Bitim",

    dealCreated: "«{deal}» bitimi yaratildi",

    dealWon: "«{deal}» bitimi yutildi",

    dealLost: "«{deal}» bitimi yo'qotildi",
    nobody: "hech kim",
    assigned: "{who}: mas'ullar {from} → {to}",
    assignedViaDeal: "{who}: «{deal}» bitimi bo'yicha mas'ullar: {from} → {to}",
    dealAssigned: "Mas'ullar: {from} → {to}",
    merged: "{who} kontaktlarni birlashtirdi: {names}",
  },

  merge: {
    title: "Kontaktlarni birlashtirish",
    subtitle: "Nima ko'chirilishini tekshiring. Tasdiqlamaguningizcha hech narsa o'zgarmaydi.",
    mainContact: "Asosiy kontakt (qoladi)",
    removedContacts: "Birlashtiriladi va o'chiriladi",
    deals: "Bitimlar",
    tasks: "Vazifalar",
    calls: "Qo'ng'iroqlar",
    chats: "Yozishmalar",
    history: "Tarix",
    files: "Fayllar",
    dealsHint: "Belgilangan bitimlar asosiy kontaktga o'tadi. Belgilanmaganlardan kontakt olib tashlanadi (bitimlarning o'zi o'chirilmaydi).",
    noDeals: "Birlashtirilayotgan kontaktlarda bitimlar yo'q",
    possibleDup: "takror bo'lishi mumkin",
    selectAll: "Hammasini tanlash",
    clearAll: "Hammasini bekor qilish",
    fromContact: "{name} kontaktidan",
    alsoMove: "Yana ko'chirish",
    fillEmpty: "Asosiy kontaktning bo'sh maydonlarini birlashtirilayotganlardagi ma'lumot bilan to'ldirish",
    conflicts: "Ma'lumotlar farq qiladi (asosiy kontakt qiymatlari qoladi)",
    field: {
      name: "Ism",
      email: "Email",
    },
    owners: "Mas'ullar",
    ownersKeep: "Asosiy kontakt mas'ullarini qoldirish",
    ownersUnion: "Barcha mas'ullarni birlashtirish",
    status: {
      active: "Jarayonda",
      won: "Yutilgan",
      lost: "Yo'qotilgan",
    },
    summary: "Ko'chiriladigan bitimlar: {n}",
    confirm: "Birlashtirish",
    cancel: "Bekor qilish",
    success: "Kontaktlar birlashtirildi",
    error: "Birlashtirib bo'lmadi",
    loadError: "Ko'rib chiqishni yuklab bo'lmadi",
  },

  quickTask: {

    typeLabel: "Vazifa turi",
    tab: "Vazifa",
    type: {
      call: "Bog'lanish",
      meeting: "Uchrashuv",
      other: "Boshqa",
    },
    on: "sana",
    for: "mas'ul",
    today: "Bugun",
    tomorrow: "Ertaga",
    week: "Bir haftadan keyin",
    placeholder: "Nima qilish kerak…",
    place: "Qo'yish",
    cancel: "Bekor qilish",
    created: "Vazifa qo'yildi",
    badDate: "Sana va vaqtni kiriting",
  },

  callAI: {
    badge: {
      analyze: "AI tahlil",
      queued: "Navbatda",
      processing: "Tahlil qilinmoqda…",
      failed: "Tahlil xatosi",
      problem: "Muammoli qo'ng'iroq",
      tooShort: "Juda qisqa",
    },
    modal: {
      title: "Qo'ng'iroqning AI tahlili",
      notAnalyzed: "Qo'ng'iroq hali tahlil qilinmagan",
      notAnalyzedHint: "Tahlilni ishga tushiring: tizim yozuvni matnga aylantiradi va chek-list bo'yicha hisobot tayyorlaydi.",
      analyze: "Tahlil qilish",
      starting: "Ishga tushirilmoqda…",
      disabled: "Qo'ng'iroqlarning AI tahlili o'chirilgan. Uni yoqing: Sozlamalar → Integratsiyalar → Qo'ng'iroqlarning AI tahlili.",
      noEngine: "Serverda matnga aylantirish yoki tahlil ulanmagan — ular sozlanguncha qo'ng'iroq kutadi.",
      tabReport: "Hisobot",
      tabTranscript: "Matn",
      retry: "Qayta urinish",
      reanalyze: "Qayta hisoblash",
      delete: "O'chirish",
      deleteConfirm: "Matn, baholar va yozuv nusxasi o'chirilsinmi?",
      close: "Yopish",
      summary: "Xulosa",
      intent: "Mijoz nima xohladi",
      outcome: "Natija",
      checklist: "Chek-list bo'yicha baho",
      redFlags: "Buzilishlar va xatarlar",
      noRedFlags: "Buzilishlar topilmadi",
      actions: "Qo'ng'iroqdan keyin nima qilish kerak",
      coaching: "Operatorga tavsiyalar",
      metrics: "Suhbat ko'rsatkichlari",
      topics: "Mavzular",
      noTranscript: "Matn hali mavjud emas",
      rolesInferred: "Operator va mijoz rollari ma'no bo'yicha aniqlangan",
      tooShortNote: "Suhbat baholash uchun juda qisqa: faqat ko'rsatkichlar hisoblandi.",
      error: "Xato",
      agent: "Operator",
      client: "Mijoz",
      unknown: "Noma'lum",
      audioError: "Yozuvni yuklab bo'lmadi",
      score: "Baho",
      clientSentiment: "Mijoz ohangi",
      agentSentiment: "Operator ohangi",
      notApplicable: "qo'llanilmaydi",
      createTask: "Vazifa yaratish",
    },
    status: {
      queued: "Navbatda",
      downloading: "Yozuv yuklanmoqda…",
      downloaded: "Yozuv saqlandi, matnga aylantirish kutilmoqda",
      transcribing: "Matnga aylantirilmoqda…",
      transcribed: "Matn tayyor, tahlil kutilmoqda",
      analyzing: "Tahlil qilinmoqda…",
      done: "Tayyor",
      failed: "Xato",
      skipped: "O'tkazib yuborildi",
    },
    sentiment: {
      positive: "Ijobiy",
      neutral: "Neytral",
      negative: "Salbiy",
    },
    outcome: {
      sale: "Sotuv",
      agreed_next_step: "Keyingi qadam kelishildi",
      callback_requested: "Qayta qo'ng'iroq so'radi",
      info_given: "Ma'lumot berildi",
      no_interest: "Qiziqmadi",
      complaint: "Shikoyat",
      other: "Boshqa",
    },
    flag: {
      rude: "Qo'pollik",
      no_next_step: "Keyingi qadam yo'q",
      false_promise: "Bajarib bo'lmaydigan va'da",
      complaint: "Mijoz shikoyati",
      competitor: "Raqobatchi tilga olindi",
      price_unhandled: "Narx e'tirozi bartaraf etilmadi",
      data_leak: "Ortiqcha ma'lumot",
      other: "Boshqa",
    },
    severity: {
      low: "Past",
      medium: "O'rta",
      high: "Yuqori",
    },
    item: {
      greeting: "Salomlashish va tanishtirish",
      needs: "Ehtiyojni aniqlash",
      presentation: "Mahsulot/xizmat haqida ma'lumot",
      objections: "E'tirozlar bilan ishlash",
      next_step: "Keyingi qadam bo'yicha kelishuv",
      politeness: "Xushmuomalalik va ohang",
      closing: "Suhbatni yakunlash",
    },
    metric: {
      agentTalkPct: "Operator nutqi ulushi",
      silencePct: "Sukunat",
      interruptions: "So'zni bo'lishlar",
      avgResponseGapSec: "Gaplar orasidagi pauza, s",
      agentWpm: "Daqiqada so'z (operator)",
      longestAgentMonologueSec: "Operatorning eng uzun monologi, s",
      durationSec: "Davomiyligi, s",
      words: "Jami so'z",
    },
    lang: {
      auto: "Avto",
      uz: "O'zbek",
      ru: "Rus",
      tg: "Tojik",
      en: "Ingliz",
    },
    analytics: {
      analyzed: "Tahlil qilingan qo'ng'iroqlar",
      avgScore: "O'rtacha baho",
      problem: "Muammoli qo'ng'iroqlar",
      talkMinutes: "Suhbat daqiqalari",
      cost: "Xarajat, $",
      pending: "Ishlanmoqda: {n}",
      failedN: "Xatolar: {n}",
      tooShortN: "Juda qisqa: {n}",
      byAgent: "Xodimlar",
      thAgent: "Xodim",
      thCalls: "Qo'ng'iroqlar",
      thScore: "Baho",
      thProblem: "Muammoli",
      thFlags: "Buzilishlar",
      thTalk: "Nutq ulushi",
      checklist: "Chek-list bandlari bo'yicha baho",
      outcomes: "Qo'ng'iroq natijalari",
      sentiment: "Mijozlar kayfiyati",
      trend: "Baho dinamikasi",
      topFlags: "Tez-tez uchraydigan buzilishlar",
      topTopics: "Suhbat mavzulari",
      worst: "Past baholangan qo'ng'iroqlar",
      empty: "Davr uchun tahlil qilingan qo'ng'iroqlar yo'q",
      disabledTitle: "Qo'ng'iroqlarning AI tahlili o'chirilgan",
      disabledText: "Sozlamalarda yoqing — tizim yangi suhbatlarni matnga aylantirib, baholay boshlaydi.",
      goSettings: "Sozlamalarni ochish",
      allAgents: "Barcha xodimlar",
      noAgent: "Aniqlanmagan",
      open: "Ochish",
      allDirections: "Barcha qo'ng'iroqlar",
      incoming: "Kiruvchi",
      outgoing: "Chiquvchi",
      truncated: "Davrning dastlabki 5000 ta qo'ng'irog'i ko'rsatilgan",
    },
    settings: {
      title: "Qo'ng'iroqlarning AI tahlili",
      subtitle: "Tizim mijozlar bilan suhbat yozuvlarini matnga aylantiradi va hisobot tayyorlaydi: xulosa, chek-list bo'yicha baho, buzilishlar va tavsiyalar.",
      enable: "AI tahlilni yoqish",
      enableHint: "Faqat yangi qo'ng'iroqlar tahlil qilinadi — yoqilgandan keyingilari. Eski yozuvlar qayta ishlanmaydi.",
      auto: "Avtomatik tahlil qilish",
      autoHint: "O'chirilgan bo'lsa, tahlil qo'ng'iroqdagi tugma orqali qo'lda ishga tushiriladi.",
      minTalk: "Suhbatning minimal davomiyligi, daq",
      minTalkHint: "Suhbat vaqti javob berilgan paytdan hisoblanadi (gudoklar hisobga olinmaydi). Kimgadir 2 daqiqa yetadi, kimgadir 15 ham kam. 0 — cheklovsiz.",
      maxTalk: "Maksimal davomiylik, daq",
      maxTalkHint: "Pul tejash uchun juda uzun suhbatlarni tahlil qilmaslik mumkin. 0 — cheklovsiz.",
      directions: "Qaysi qo'ng'iroqlar tahlil qilinsin",
      in: "Kiruvchi",
      out: "Chiquvchi",
      language: "Suhbat tili",
      languageHint: "«Avto» o'zbek, rus va tojik tillari aralashmasi uchun mos.",
      vocabulary: "Tashkilot lug‘ati",
      vocabularyHint: "Brendlar, modellar, nomlar va xodimlar ismlari vergul bilan. Tahlilda AI noto‘g‘ri tanilgan so‘zlarni (masalan, «lifis» → LI 9) tuzatib, hisobotda to‘g‘ri yozadi.",
      vocabularyPlaceholder: "Li Auto, LI 7, LI 9, Li Avto Buxoro, rassrochka, Rosa",
      reportLanguage: "Hisobot tili",
      retention: "Yozuvlarni saqlash, kun",
      retentionHint: "Muddat tugagach audio nusxa o'chiriladi, matn va baholar qoladi. 0 — doimiy saqlash.",
      managerOnly: "Hisobotlarni faqat rahbarlar ko'radi",
      managerOnlyHint: "Xodim faqat o'z qo'ng'iroqlari tahlilini ko'radi.",
      checklist: "Baholash chek-listi",
      checklistHint: "Tizim har bir suhbatni shu bandlar bo'yicha baholaydi. Vazn — bandning yakuniy bahodagi ahamiyati.",
      usingDefault: "Standart chek-list ishlatilmoqda",
      customize: "O'zimnikini sozlash",
      resetDefault: "Standartga qaytarish",
      addItem: "Band qo'shish",
      itemTitle: "Nomi",
      itemDescription: "Nima bajarilgan hisoblanadi",
      itemWeight: "Vazn",
      save: "Saqlash",
      saved: "Sozlamalar saqlandi",
      saveError: "Saqlab bo'lmadi",
      engine: "Ulanish",
      engineStt: "Nutqni matnga aylantirish",
      engineLlm: "Matn tahlili",
      engineOn: "ulangan",
      engineOff: "ulanmagan",
      onlyAdmin: "Sozlamalarni faqat egasi yoki administrator o'zgartira oladi.",
      consentTitle: "Muhim: mijozlarni ogohlantiring",
      consentText: "Mijozlarga suhbatlar yozib borilishi va avtomatik tahlil qilinishi mumkinligini ma'lum qiling (masalan, ATS ovozli salomlashuvida). Bu shaxsiy ma'lumotlar to'g'risidagi qonun talabi.",
      consentCheck: "Mijozlar suhbat yozib borilishi va avtomatik tahlil qilinishidan xabardor qilinganini tasdiqlayman",
      consentRequired: "Tahlilni yoqish uchun mijozlar xabardor qilinganini tasdiqlang",
      consentAt: "{date} da tasdiqlangan",
      maskPii: "Shaxsiy ma'lumotlarni tashqi modeldan yashirish",
      maskPiiHint: "Telefon raqamlari, karta raqamlari, pasport va e-mail tahlilga yuborishdan oldin belgilarga almashtiriladi. Bazangizdagi matn o'zgarishsiz qoladi.",
      eraseTitle: "Mijoz ma'lumotlarini o'chirish",
      eraseHint: "Mijoz so'roviga ko'ra uning raqamiga bog'liq barcha matnlar, baholar va yozuv nusxalarini o'chirish mumkin. Qo'ng'iroqlarning o'zi jurnalda qoladi.",
      erasePhone: "Mijoz telefon raqami",
      eraseBtn: "Ma'lumotlarni o'chirish",
      eraseConfirm: "{phone} raqami bo'yicha barcha AI tahlil ma'lumotlari o'chirilsinmi? Bu amalni qaytarib bo'lmaydi.",
      erased: "O'chirilgan tahlillar: {n}",
      eraseBadPhone: "Telefon raqamini kiriting",
      minutesShort: "daq",
      unlimited: "cheklovsiz",
      queue: "Navbat",
    },
  },

  leadMap: {
    autoCreate: "Har bir yangi savol uchun maydonni avtomatik yaratish",
    autoCreateHint: "Yangi savolli lid kelganda CRM unga bitim maydonini («Ariza (lid formasi)» bo'limida) o'zi yaratadi va javobni shu yerga yozadi. Qo'lda moslashtirish shart emas.",
    autoOn: "Maydonlarni avtomatik yaratish yoqildi",
    autoOff: "Maydonlarni avtomatik yaratish o'chirildi",
    title: "Lid maydonlari",
    subtitle: "Facebook/Instagram formalari va API orqali kelgan lidlarning javoblari bitim kartochkasida qanday joylashishi. Moslashtirilmagan hamma narsa avvalgidek izohga tushadi.",
    hintStandard: "Formaning standart savollaridagi ism, telefon va e-mail kontaktga avtomatik tushadi. Bu yerda qolgan savollar va reklama ma'lumotlari sozlanadi.",
    question: "Forma savoli",
    sample: "Javob namunasi",
    count: "Lidlar",
    target: "Qayerga saqlash",
    toNote: "Izohga (standart)",
    createField: "«{name}» maydonini yaratish",
    dealFields: "Bitim maydoni",
    contact: "Kontakt",
    contactName: "Kontakt ismi",
    contactPhone: "Kontakt telefoni",
    contactEmail: "Kontakt e-maili",
    ignore: "Saqlamaslik",
    importMeta: "Savollarni Meta formasidan yuklash",
    imported: "Qo'shilgan savollar: {n}",
    importFail: "Savollarni Meta'dan yuklab bo'lmadi",
    empty: "Savollar birinchi lid kelgandan keyin shu yerda paydo bo'ladi. Yoki yuqoridagi tugma bilan Meta formasidan yuklang.",
    emptyNoFb: "Savollar Facebook/Instagram yoki API orqali birinchi lid kelgandan keyin paydo bo'ladi.",
    saved: "Saqlandi",
    fieldCreated: "Maydon yaratildi: {name}",
    loadError: "Sozlamalarni yuklab bo'lmadi",
  },

  apiKeys: {
    title: "API kalitlar",
    subtitle: "Tashqi tizimlardan lidlarni qabul qilish: CRM Line, Zapier, Make, sayt formalari. Har bir kalit lidlarni tanlangan voronka va bosqichga joylaydi.",
    create: "Kalit yaratish",
    createTitle: "Yangi API kalit",
    editTitle: "Kalitni o'zgartirish",
    name: "Nomi",
    namePh: "Masalan: CRM Line (li-buxoro)",
    funnel: "Voronka",
    stage: "Bosqich",
    source: "Manba",
    sourceHint: "Bitimdagi manba yozuvi. So'rovning o'zida o'zgartirish mumkin.",
    save: "Saqlash",
    cancel: "Bekor qilish",
    nameRequired: "Nomni kiriting",
    error: "Amalni bajarib bo'lmadi",
    saved: "Saqlandi",
    empty: "Hozircha kalitlar yo'q",
    destination: "Lidlar tushadi",
    lastUsed: "Oxirgi so'rov",
    neverUsed: "Hali ishlatilmagan",
    leadsCount: "lidlar: {n}",
    edit: "O'zgartirish",
    revoke: "Kalitni bekor qilish",
    revokeConfirm: "«{name}» kaliti bekor qilinsinmi? U darhol ishlamay qoladi, buni qaytarib bo'lmaydi.",
    revoked: "Kalit bekor qilindi",
    createdTitle: "«{name}» kaliti yaratildi",
    shownOnce: "Kalitni hozir nusxalang: u faqat bir marta ko'rsatiladi. Yo'qotsangiz, uni bekor qilib yangisini yarating.",
    copy: "Nusxalash",
    copied: "Nusxalandi",
    done: "Tayyor",
    docsTitle: "Lidlarni qanday yuborish",
    endpoint: "Manzil",
    example: "So'rov namunasi",
    docAuth: "Kalit Authorization: Bearer … sarlavhasida (yoki X-API-Key) yuboriladi.",
    docRequired: "Majburiy: telefon yoki email. Ism majburiy emas.",
    docExternal: "external_id (masalan, Meta lid id) takrorlanishdan saqlaydi: qayta yuborilsa ikkinchi bitim yaratilmaydi.",
    docOptional: "Ixtiyoriy: source, funnel_id, stage_id, notes, answers {maydon: qiymat}, campaign, ad_name, form_name, page_name, platform.",
    docLimit: "Cheklov: bir kalitga daqiqasiga 120 ta so'rov.",
  },

  callPanel: {
    initiatedSoftphone: "MicroSIP ochilmoqda va raqam terilmoqda…",
    noStartSoftphone: "Qo'ng'iroq boshlanmadi. MicroSIP ishga tushganini, {ext} raqamiga ulanganini va tel: havolalari uchun dastur etib tanlanganini tekshiring.",
    initiated: "Buyruq ATSga yuborildi…",
    ringing: "MicroSIPda ATS qo'ng'irog'iga javob bering (ichki {ext}) — shundan keyin ATS mijozni terib beradi",
    ringingDirect: "Mijozga qo'ng'iroq qilinmoqda…",
    active: "Suhbat ketmoqda",
    completed: "Qo'ng'iroq tugadi",
    missed: "Ulanmadi",
    noStart: "ATS hali qo'ng'iroqni boshlamadi. MicroSIP ishga tushganini va {ext} raqamiga ulanganini tekshiring.",
    retry: "Yana qo'ng'iroq qilish",
    openCard: "Kartani ochish",
    close: "Yopish",
    noExt: "Sizga ATS ichki raqami biriktirilmagan. Administratorga murojaat qiling (Sozlamalar → Xodimlar).",
    viaPbx: "ATS orqali (ichki {ext})",
    viaPbxNoExt: "ATS orqali — ichki raqam yo'q",
    menuHint: "MicroSIP jiringlaydi — javob bering, ATS mijozni terib beradi",
    startFailed: "Buyruqni ATSga yuborib bo'lmadi",
    duration: "Davomiyligi {d}",
    reason: {
      no_answer: "Mijoz javob bermadi",
      busy: "Band",
      cancelled: "Javobgacha bekor qilindi",
      failed: "Liniya xatosi",
      unknown: "Sabab noma'lum",
    },
    stats: {
      title: "Chiquvchi qo'ng'iroqlar natijasi",
      connected: "Ulandi",
      fromCrm: "CRM tugmasidan: {n}, ulandi {c}",
      empty: "Davr uchun chiquvchi qo'ng'iroqlar yo'q",
    },
  },

  ownerBot: {
    title: "Rahbar uchun Telegram bot",
    subtitle: "Faqat biznes rahbari uchun shaxsiy hisobotlar va tezkor xabarlar.",
    notConfigured: "Bot serverda hali sozlanmagan. Miko xizmatiga murojaat qiling.",
    noPhone: "Rahbar raqami ko'rsatilmagan. Uni Miko administratori kiritadi: qo'llab-quvvatlashga murojaat qiling.",
    phone: "Rahbar raqami",
    phoneHint: "Faqat shu raqam egasi Telegram orqali ulana oladi.",
    connect: "Telegramni ulash",
    connecting: "Havola yaratilmoqda…",
    linkReady: "Ulanish havolasi (15 daqiqa amal qiladi, bir martalik)",
    open: "Telegramda ochish",
    copy: "Nusxalash",
    copied: "Nusxalandi",
    linkSteps: "Havolani rahbarning telefonida oching, «Start» ni bosing va botdagi tugma orqali raqamingizni yuboring.",
    devices: "Ulangan qurilmalar",
    noDevices: "Hozircha hech kim ulanmagan.",
    linkedAt: "ulangan",
    sendReport: "Hozirgi hisobot",
    reportSent: "Hisobot yuborildi",
    disconnect: "O'chirish",
    disconnectConfirm: "Bu qurilmani botdan o'chirasizmi?",
    times: "Hisobot vaqti",
    evening: "Bugungi kechki hisobot",
    morning: "Kechagi ertalabki hisobot",
    quiet: "Tezkor xabarlar yuborilmaydi",
    quietFrom: "dan",
    quietTo: "gacha",
    save: "Saqlash",
    saved: "Saqlandi",
    attempts: "Ulanish urinishlari",
    rejected: "Rad etildi: raqam mos kelmadi",
    linked: "Ulandi",
    whatTitle: "Bot nimalarni yuboradi",
    what1: "Har kuni kechqurun va ertalab: murojaatlar, qo'ng'iroqlar (o'tkazib yuborilganlari ham), yutilgan va yo'qotilgan bitimlar, vazifalar (bajarilgan va muddati o'tgan).",
    what2: "Dasturda kim nima va qachon qilgani: muhim o'zgarishlar (o'chirishlar, sozlamalar, xodimlar, integratsiyalar).",
    what3: "Darhol: o'tkazib yuborilgan kiruvchi qo'ng'iroq, yutilgan bitim, muhim o'zgarish.",
    what4: "Botdagi buyruqlar: «Bugun», «Kecha», «Sozlamalar».",
  },
  notifCenter: {
    title: "Bildirishnomalar",
    empty: "Hozircha yangilik yo‘q",
    message: "Yangi xabar",
    lead: "Yangi lid",
    call: "O‘tkazib yuborilgan qo‘ng‘iroq",
    media: "Fayl",
    missedCallText: "Mijozga qayta qo‘ng‘iroq qiling",
    now: "hozir",
    min: "daq",
    hour: "soat",
    clear: "Tozalash",
    soundOn: "Ovozni yoqish",
    soundOff: "Ovozni o‘chirish",
    unreadInbox: "Xabarlarda o‘qilmagan",
  },
  topbar: {
    hotkeysHint: "bo‘limlarga o‘tish, N — yangi bitim",
    cmdGo: "O‘tish", cmdFunnel: "Voronka", cmdTheme: "Mavzuni almashtirish", cmdGroup: "Buyruqlar", recent: "So‘nggilar",
    appearance: "Ko‘rinish", themeLight: "Yorug‘", themeDark: "Tungi", themeAuto: "Avto",
    liteMode: "Soddalashtirilgan ko‘rinish", liteHint: "Xiralashtirish va animatsiyasiz: sust qurilmalarda tezroq",
    searchNavigate: "tanlash",
    searchOpen: "ochish",
    search: "Qidiruv",
    searchPlaceholder: "Mijoz, bitim yoki buyruq…",
    searchContacts: "Kontaktlar",
    searchDeals: "Bitimlar",
    searchEmpty: "Hech narsa topilmadi",
    searchHint: "Kamida 2 ta belgi kiriting",
    create: "Yaratish",
    createDeal: "Yangi bitim",
    createContact: "Yangi kontakt",
    funnels: "Voronkalar",
    close: "Yopish",
    accountSettings: "Akkaunt sozlamalari",
    settings: "Sozlamalar",
    refresh: "Yangilash",
    lockScreen: "Ekranni qulflash",
    fullscreen: "To'liq ekran",
    exitFullscreen: "To'liq ekrandan chiqish",
    roles: {
      owner: "Egasi",
      admin: "Admin",
      manager: "Menejer",
      cashier: "Kassir",
      warehouse: "Omborchi",
      viewer: "Ko'ruvchi",
    },
    hidePanel: "Yuqori panelni yashirish",
    showPanel: "Yuqori panelni ochish",
    language: "Til",
  },
  assets: {
    pageTitle: "Korxona aktivlari", pageSubtitle: "Jihoz, mebel va boshqa moddiy boyliklar",
    addBtn: "Aktiv qo'shish", searchPlaceholder: "Nomi yoki inventar ID...",
    statTotal: "Jami aktivlar", statUnit: "ta", statCost: "Dastlabki narx",
    statAccDep: "Amortizatsiya", statBookValue: "Qoldiq narx", currency: "so'm",
    catAll: "Barcha kategoriyalar",
    cat_furniture: "Mebel", cat_electronics: "Elektr jihozlari",
    cat_computer: "Kompyuter va texnika", cat_vehicle: "Transport",
    cat_equipment: "Ishlab chiqarish jihozlari", cat_office: "Ofis jihozlari", cat_other: "Boshqa",
    statusAll: "Barcha holatlar", statusActive: "Faol", statusDisposed: "Hisobdan chiqarilgan",
    status_active: "Faol", status_disposed: "Hisobdan chiqarilgan",
    thInventoryId: "Inv. ID", thName: "Nomi", thCategory: "Kategoriya",
    thCost: "Dastlabki narx", thAccDep: "Amortizatsiya", thBookValue: "Qoldiq narx",
    thStatus: "Holat", thActions: "Amallar",
    noItems: "Aktivlar yo'q",
    deleteConfirm: "Aktivni o'chirmoqchimisiz?",
    deleteHint: "Barcha amortizatsiya yozuvlari ham o'chib ketadi.",
    deleteBtn: "O'chirish", cancel: "Bekor qilish", deleted: "Aktiv o'chirildi",
    saved: "Saqlandi", created: "Aktiv qo'shildi",
    formTitleNew: "Yangi aktiv", formTitleEdit: "Aktivni tahrirlash",
    saveBtn: "Saqlash", backBtn: "Orqaga",
    sectionMain: "Asosiy ma'lumotlar", sectionFinance: "Moliyaviy ma'lumotlar",
    sectionDepreciation: "Amortizatsiya", sectionHistory: "Amortizatsiya tarixi",
    nameLabel: "Nomi", namePlaceholder: "Masalan: HP EliteBook 840",
    categoryLabel: "Kategoriya", statusLabel: "Holat",
    descriptionLabel: "Tavsif", descriptionPlaceholder: "Qo'shimcha ma'lumot...",
    locationLabel: "Joylashuv / Bo'lim", locationPlaceholder: "Masalan: Moliya bo'limi",
    responsibleLabel: "Mas'ul shaxs", responsiblePlaceholder: "F.I.O.",
    purchaseDateLabel: "Sotib olingan sana", purchaseCostLabel: "Dastlabki narx (so'm)",
    disposalDateLabel: "Hisobdan chiqarish sanasi",
    disposalNoteLabel: "Sababi", disposalNotePlaceholder: "Eskirdi, sotildi...",
    depMethodLabel: "Amortizatsiya usuli",
    depMethodNone: "Amortizatsiyasiz", depMethodStraightLine: "Chiziqli usul",
    usefulLifeLabel: "Foydali xizmat muddati (oy)",
    monthlyDepLabel: "Oylik amortizatsiya", annualDepLabel: "Yillik amortizatsiya",
    accDepLabel: "Hisoblangan amortizatsiya", bookValueLabel: "Qoldiq (balans) narxi",
    noteLabel: "Izoh", notePlaceholder: "Eslatma...",
    addDepBtn: "Amortizatsiya yozish",
    depModalTitle: "Amortizatsiya yozish",
    depDateLabel: "Sana", depAmountLabel: "Summa",
    depNoteLabel: "Izoh", depNotePlaceholder: "Masalan: 2026-iyun amortizatsiyasi",
    depSaveBtn: "Yozish", depAdded: "Amortizatsiya yozildi", depDeleted: "Yozuv o'chirildi",
    suggestedDep: "Tavsiya etilgan summa",
    depAmountRequired: "Summa kiritilishi shart",
    noDepHistory: "Amortizatsiya yozuvlari yo'q",
    nameRequired: "Nomi kiritilishi shart", categoryRequired: "Kategoriya tanlanishi shart",
    thDepDate: "Sana", thDepAmount: "Summa", thDepNote: "Izoh",
    catNone: "Kategoriyasiz", catEmpty: "Kategoriyalar yo'q — Sozlamalarda qo'shing",
    statusNone: "Holatsiz", statusEmpty: "Holatlar yo'q — Sozlamalarda qo'shing",
    statusAllFilter: "Barcha holatlar",
    depMethodStraightLineHint: "Doimiy oylik chegirma",
    monthsSuffix: "oy",
  },
  settingsAssets: {
    tabLabel: "Aktivlar",
    title: "Aktivlar sozlamalari",
    catTitle: "Kategoriyalar",
    catSubtitle: "Aktivlarni guruhlash uchun kategoriyalar",
    statusTitle: "Holatlar",
    statusSubtitle: "Har bir aktivning joriy holatini belgilash uchun",
    addCatBtn: "Kategoriya qo'shish",
    addStatusBtn: "Holat qo'shish",
    namePlaceholder: "Nomi...",
    colorLabel: "Rang",
    saveBtn: "Saqlash",
    cancelBtn: "Bekor qilish",
    noCats: "Kategoriyalar yo'q",
    noStatuses: "Holatlar yo'q",
    deleted: "O'chirildi",
    saved: "Saqlandi",
    created: "Qo'shildi",
    dupError: "Bu nom allaqachon mavjud",
  },

  // ── CRM-specific pages ─────────────────────────────────────────────────────

  crmDashboard: {
    greeting: "Xush kelibsiz, {name}!",
    loadError: "Ma'lumotlar yuklanmadi",
    reload: "Qayta yuklash",
    kpiCalls: "Bugungi qo'ng'iroqlar",
    kpiContacts: "Yangi kontaktlar",
    kpiDeals: "Ochiq bitimlar",
    kpiUnanswered: "Javob kutilmoqda",
    kpiSubToday: "bugun",
    kpiSubTodayAdded: "bugun qo'shilgan",
    kpiSubTotal: "jami",
    kpiSubUnanswered: "javob berilmagan",
    missedTitle: "O'tkazib yuborilgan qo'ng'iroqlar",
    missedEmpty: "O'tkazib yuborilgan qo'ng'iroqlar yo'q",
    allCalls: "Barcha qo'ng'iroqlar →",
    allTasks: "Barcha vazifalar →",
    overdueTitle: "Muddati o'tgan vazifalar",
    dueDate: "Muddat:",
    activityTitle: "So'nggi faoliyat",
    activityEmpty: "Faoliyat yo'q",
    funnelTitle: "Funnel statistikasi",
    funnelEmpty: "Funnel yo'q",
    noDeal: "Bitim yo'q",
    quickLinks: "Tez havolalar",
    addContact: "Kontakt qo'shish",
    callHistory: "Qo'ng'iroqlar tarixi",
    incoming: "Kiruvchi",
    outgoing: "Chiquvchi",
  },

  tasks: {
    title: "Vazifalar",
    newTask: "Yangi vazifa",
    editTask: "Vazifani tahrirlash",
    viewTask: "Vazifani ko'rish",
    close: "Yopish",
    noStagesTitle: "Vazifalar bo'limi",
    noStages: "Hali bosqichlar sozlanmagan. Sozlamalar → Vazifalar bo'limida bosqichlar qo'shing.",
    search: "Qidirish...",
    filter: "Filter",
    clearFilters: "Tozalash",
    allPriorities: "Barchasi",
    allAssignees: "Barcha xodimlar",
    assignedToMe: "Menga biriktirilgan",
    createdByMe: "Men yaratganim",
    overdue: "muddati o'tgan",
    totalNote: "Jami {total} ta — birinchi {shown} ta ko'rsatilmoqda",
    deleteConfirm: "O'chirishni tasdiqlaysizmi?",
    prioLow: "Past",
    prioMedium: "O'rta",
    prioHigh: "Yuqori",
    modalTitle: "Sarlavha *",
    titlePlaceholder: "Nima qilish kerak...",
    titleRequired: "Sarlavha kiritilishi shart",
    description: "Tavsif / izoh",
    descPlaceholder: "Batafsil tavsif...",
    priority: "Muhimlik",
    stage: "Bosqich",
    assignee: "Ma'sul",
    additionalAssignees: "Qo'shimcha mas'ullar",
    unassigned: "Tanlanmagan",
    dueDate: "Muddat",
    contact: "Kontakt",
    contactSearch: "Kontakt qidiring...",
    contactNotFound: "Kontakt topilmadi",
    contactCreate: "«{q}» kontaktini yaratish",
    contactNew: "Yangi kontakt",
    contactName: "Ism",
    contactPhone: "Telefon",
    contactSave: "Yaratish",
    contactCreated: "Kontakt yaratildi va biriktirildi",
    contactExisting: "Bu telefon raqam allaqachon mavjud: {name}. Biriktirildi",
    contactCreateError: "Kontaktni yaratib bo‘lmadi",
    linked: "Bog'langan",
    files: "Fayllar",
    uploadFile: "+ Fayl yuklash",
    uploading: "Yuklanmoqda...",
    tags: "Teglar",
    tagsPlaceholder: "Teg qo'shish, Enter bosing...",
    createdByPrefix: "Qo'shdi:",
    historyTitle: "O'zgarishlar tarixi",
    histUnknownUser: "Noma'lum",
    histCreated: "vazifani yaratdi",
    histStageChanged: "bosqichni o'zgartirdi",
    histAssigned: "mas'ul biriktirdi",
    histUnassigned: "mas'ulni bekor qildi",
    histArchived: "arxivladi",
    histUnarchived: "arxivdan chiqardi",
    histCompleted: "bajarildi deb belgiladi",
    archive: "Arxiv", archived: "Vazifa arxivlandi", archiveEmpty: "Arxivda vazifa yo'q",
    restore: "Arxivdan chiqarish", restored: "Vazifa arxivdan chiqarildi",
    assignedToPrefix: "Biriktirilgan:",
    cancel: "Bekor",
    save: "Saqlash",
    create: "Yaratish",
    saved: "Saqlandi",
    created: "Yaratildi",
    deleted: "O'chirildi",
    loadError: "Yuklanishda xato",
    error: "Xato",
    viewKanban: "Kanban",
    viewDue: "Muddat",
    viewCalendar: "Kalendar",
    viewDay: "Kun",
    viewWeek: "Hafta",
    viewMonth: "Oy",
    noDateBucket: "Sanasiz",
    colOverdue: "Muddati o'tgan",
    colToday: "Bugungi",
    colTomorrow: "Ertangi",
    colThisWeek: "Bu hafta",
    colNextWeek: "Keyingi hafta",
    completeTitle: "Vazifani yakunlash",
    outcomeNotePlaceholder: "Natija: nima gaplashildi, kelishuv...",
    logToDeal: "Bitim tarixiga yozish",
    createFollowUp: "Keyingi vazifa yaratish",
    followUpTitle: "Keyingi vazifa sarlavhasi",
    followUpDue: "Keyingi vazifa muddati",
    followUpAssignee: "Mas'ul (ixtiyoriy)",
    completeConfirm: "Yakunlash",
    completeSuccess: "Vazifa yakunlandi",
    markDone: "Bajardim",
    noDoneStage: "\"Bajarildi\" bosqichi sozlanmagan",
    doneBadge: "Bajarildi",
    archiveAction: "Arxivlash",
    callTitle: "Qo'ng'iroq qilish",
    noDealAccess: "Bu lidni ko'rish huquqi yo'q",
    authorTitle: "Muallif: {name}",
    assigneeTitle: "Mas'ul: {name}",
    viewAction: "Ochish",
    editAction: "Tahrirlash",
    deleteAction: "O'chirish",
  
    scopeMine: "Meniki",
  },

  calls: {
    fPeriod: "Davr",
    fStatus: "Holat",
    fDirection: "Yo'nalish",
    resetFilters: "Filtrlarni tozalash",
    title: "Qo'ng'iroqlar",
    all: "Barchasi",
    incoming: "Kiruvchi",
    outgoing: "Chiquvchi",
    missed: "O'tkazib yuborilgan",
    completed: "Bajarilgan",
    ringing: "Jiringlayapti",
    busy: "Band",
    search: "Telefon yoki kontakt...",
    dateFrom: "Dan",
    dateTo: "Gacha",
    noResults: "Qo'ng'iroqlar topilmadi",
    emptyHint: "Birinchi qo'ng'iroqlar bu yerda ko'rinadi",
    deleteSelected: "Tanlanganlarni o'chirish",
    selectAll: "Hammasini tanlash",
    deselectAll: "Hammasini bekor qilish",
    deleteConfirm: "Tanlangan {n} ta qo'ng'iroq o'chirilsinmi?",
    deleted: "O'chirildi",
    loadError: "Yuklanishda xato",
    thDate: "Sana / vaqt",
    thDirection: "Yo'nalish",
    thPhone: "Telefon",
    thContact: "Kontakt",
    thDuration: "Davomiyligi",
    thStatus: "Holat",
    thRecord: "Yozuv",
    thExt: "Telefon raqam",
    statsTotal: "Jami",
    statsMissed: "O'tkazilgan",
    statsDuration: "Umumiy vaqt",
    linkContact: "Bog'lash",
    linked: "Bog'langan",
    viewContact: "Kontaktga o'tish",
    analytics: "Analitika",
    noContact: "Kontaktsiz",
    unknown: "Noma'lum",
  
    colExt: "Ichki raqam",
  
    secShort: "{n}s",
  },

  contacts: {
    thAssignee: "Mas'ul",
    colAssignee: "Mas'ul",
    colCreated: "Qo'shilgan sana",
    sortBy: "Saralash",
    title: "Kontaktlar",
    reminderOverdue: "Eslatma muddati o'tdi",
    newContact: "Yangi kontakt",
    search: "Ism, telefon, email...",
    noContacts: "Kontaktlar topilmadi",
    emptyHint: "Birinchi kontaktingizni qo'shing",
    import: "Import",
    export: "Eksport",
    columns: "Ustunlar",
    deleteSelected: "O'chirish ({n})",
    deleteConfirm: "Tanlangan {n} ta kontakt o'chirilsinmi?",
    deleted: "O'chirildi",
    loadError: "Yuklanishda xato",
    importTitle: "CSV import",
    importHint: "CSV fayl yuklang. Birinchi qator — ustun nomlari.",
    importBtn: "Yuklash",
    importPreview: "Ko'rinish",
    importSave: "Saqlash",
    importCancel: "Bekor",
    importSuccess: "{n} ta kontakt qo'shildi",
    importError: "Import xatosi",
    exportSuccess: "Eksport boshlandi",
    selectFile: "CSV faylni tanlang",
    mapping: "Ustunlarni bog'lash",
    analytics: "Analitika",
    thName: "Ism",
    thPhone: "Telefon",
    thEmail: "Email",
    thSource: "Manba",
    thCreated: "Sana",
    thActions: "Amallar",
    filterSource: "Manba bo'yicha",
    allSources: "Barcha manbalar",
    yes: "Ha",
    no: "Yo'q",
    fileAttached: "📎 Fayl",
    columnsTitle: "Ustunlarni tanlash",
    blocked: "Bloklangan",
    noResults: "Qidiruv natijasi topilmadi",
    addFirst: "Birinchi kontaktni qo'shing",
    add: "Qo'shish",
    duplicates: "Takroriylar",
    duplicatesTitle: "Takroriy raqamlarni aniqlash",
    normalizeAll: "Raqamlarni +998 formatga keltirish",
    normalizeTitle: "Barcha raqamlarni +998 formatga o'tkazish",
    selectedN: "Tanlandi: {n}",
    colContact: "Kontakt",
    colPhone: "Telefon",
    colEmail: "Email",
    extraFields: "Qo'shimcha maydonlar",
    exportError: "Eksport xatosi",
    searchPlaceholder: "Ism, telefon, email...",
  },

  contactForm: {
    phoneInvalid: "Raqamni tekshiring: masalan, +998 90 123 45 67",
    phoneHint: "Masalan: +998 90 123 45 67",
    newTitle: "Yangi kontakt",
    editTitle: "Kontaktni tahrirlash",
    back: "Orqaga",
    save: "Saqlash",
    saving: "Saqlanmoqda...",
    delete: "O'chirish",
    deleteConfirm: "Kontakt o'chirilsinmi?",
    deleted: "O'chirildi",
    saved: "Saqlandi",
    created: "Yaratildi",
    loadError: "Yuklanishda xato",
    tabGeneral: "Asosiy",
    tabActivity: "Faoliyat tarixi",
    tabDeals: "Bitimlar",
    name: "Ism *",
    namePlaceholder: "To'liq ism...",
    nameRequired: "Ism kiritilishi shart",
    phone: "Telefon",
    phonePlaceholder: "+998 XX XXX XX XX",
    email: "Email",
    emailPlaceholder: "example@mail.com",
    source: "Manba",
    sourcePlaceholder: "Telegram, website...",
    notes: "Izohlar",
    notesPlaceholder: "Eslatmalar...",
    activityEmpty: "Faoliyat yo'q",
    activityCall: "Qo'ng'iroq",
    activityNote: "Eslatma",
    dealsEmpty: "Bitimlar yo'q",
    dealAdd: "Bitim qo'shish",
    error: "Xato yuz berdi",
    cancel: "Bekor",
    blocked: "Bloklangan",
    reminder: "Eslatma",
    reminderOverdue: "Eslatma muddati o'tdi",
    block: "Bloklash",
    unblock: "Blokdan chiqarish",
    tabFiles: "Fayllar",
    tabSettings: "Sozlama",
    activitySub: "Izohlar, qo'ng'iroqlar va o'zgarishlar",
    activityHint: "Kontakt saqlanganidan keyin izoh qo'sha olasiz",
    activityEmptyHint: "Birinchi izohni yozing",
  },

  inbox: {
    title: "Xabarlar",
    search: "Qidirish...",
    tabUnanswered: "Javob berilmagan",
    tabAccepted: "Qabul qilingan",
    tabClosed: "Yopilgan",
    noUnanswered: "Javob berilmagan xabar yo'q",
    noUnansweredHint: "Yangi xabarlar bu yerda ko'rinadi",
    noClosed: "Yopilgan chat yo'q",
    noClosedHint: "Yopilgan suhbatlar bu yerda ko'rinadi",
    noAccepted: "Qabul qilingan chat yo'q",
    noConvsTotal: "Suhbatlar yo'q",
    selectConv: "Suhbat tanlang",
    selectConvHint: "Chap tomondagi ro'yxatdan suhbatni oching",
    convCount: "{n} ta suhbat",
    sendPlaceholder: "Xabar yozing...",
    emailPlaceholder: "Email javobini yozing...",
    notePlaceholder: "Ichki eslatma yozing...",
    noteMode: "Ichki eslatma rejimi — faqat jamoa uchun ko'rinadi",
    deleteConv: "Suhbatni o'chirish",
    deleteMsg: "Xabarni o'chirish",
    markAnswered: "Javob berildi deb belgilash",
    markUnanswered: "Javob berilmagan deb belgilash",
    closeConv: "Suhbatni yopish",
    openConv: "Suhbatni ochish",
    reassign: "Tayinlash",
    reassignTitle: "Xodimga tayinlash",
    reassignNone: "Tayinsiz",
    labelTitle: "Yorliq",
    addLabel: "Yorliq qo'shish...",
    convInfo: "Ma'lumot",
    goToContact: "Kontaktga o'tish",
    createContact: "Kontakt yaratish",
    loadError: "Yuklanishda xato",
    sendError: "Yuborishda xato",
    deleteError: "O'chirishda xato",
    analytics: "Analitika",
    back: "Orqaga",
    noSubject: "(Mavzu yo'q)",
    from: "Kim:",
    to: "Kimga:",
    noAcceptedHint: "Ochilgan chatlar bu yerga o'tadi",
    delete: "O'chirish",
    msgNotFound: "Xabar topilmadi",
    noMsgs: "Xabarlar yo'q",
    captionPlaceholder: "Izoh qo'shing (ixtiyoriy)...",
    allConvs: "Barcha suhbatlar",
    assignedAgent: "Mas'ul agent",
    linkedContact: "Bog'langan kontakt",
    contactName: "Ism *",
    cancel: "Bekor",
    save: "Saqlash",
    noData: "Ma'lumot topilmadi",
  },

  dashboardHome: {
    showPeriod: "Ko'rsatish: {p}",
    secOverview: "Biznesda hozir",
    kpiOpenDeals: "Ochiq bitimlar",
    kpiNewContacts: "Bugungi yangi kontaktlar",
    kpiUnanswered: "Javobsiz",
    kpiUnansweredSub: "Xabarlardagi suhbatlar",
    kpiCalls: "Bugungi qo'ng'iroqlar",
    kpiNewContactsSub: "Bugun qo'shilgan",
    kpiCallsSub: "Kiruvchi va chiquvchi",
    dateLocale: "uz-UZ",
    loadError: "Ma'lumot yuklanmadi", retry: "Qayta urinish",
    overdueLabel: "Muddati o'tgan", overdueSubAlert: "Darhol e'tibor kerak", overdueSubOk: "Hammasi vaqtida",
    completedLabel: "Bajarilgan", completedSub: "Oxirgi bosqichdagi",
    activeLabel: "Faol vazifalar", activeSub: "Bajarilishi kerak",
    unassignedLabel: "Biriktirilmagan", unassignedSubNoLeads: "Belgilanmagan lidlar",
    goalsTitle: "Maqsadlar", gaugeSum: "Summa", gaugeDealCount: "Savdolar soni",
    byEmployee: "Xodimlar bo'yicha", donutSum: "Summa", donutCount: "Soni",
    byManager: "Menejerlar bo'yicha", dealsCountLabel: "Savdolar", sumLabel: "Summa",
    dealSources: "Savdolar manbai", other: "Boshqa", total: "Jami", unit: "ta",
    secCalls: "Qo'ng'iroqlar",
    secCallsSub: "Kiruvchi va chiquvchi, qabul qilingan va o'tkazib yuborilgan",
    secTasks: "Vazifalar",
    secSales: "Savdo",
    pToday: "Bugun",
    pWeek: "Hafta",
    pMonth: "Oy",
    allEmployees: "Barcha xodimlar",
    noEmployee: "Xodimsiz",
    cTotal: "Jami qo'ng'iroqlar",
    cIn: "Kiruvchi",
    cOut: "Chiquvchi",
    cMissed: "O'tkazib yuborilgan",
    cAvg: "O'rtacha davomiylik",
    cAnswered: "Qabul qilingan {n}",
    cMissedN: "O'tkazib yuborilgan {n}",
    cMissedPct: "Barcha qo'ng'iroqlarning {n}%",
    cTalk: "Umumiy suhbat vaqti: {t}",
    chartTitle: "Qo'ng'iroqlar dinamikasi",
    legIn: "Kiruvchi",
    legOut: "Chiquvchi",
    legMissed: "O'tkazib yuborilgan",
    empTitle: "Xodimlar bo'yicha",
    thEmployee: "Xodim",
    thTotal: "Jami",
    thIn: "Kir.",
    thOut: "Chiq.",
    thMissed: "O'tkaz.",
    thTalk: "Suhbat",
    noCalls: "Tanlangan davrda qo'ng'iroqlar yo'q",
    callsLoadError: "Qo'ng'iroqlar statistikasi yuklanmadi",
    openCalls: "Barcha qo'ng'iroqlar",
  
    cNoAnswerN: "Javobsiz {n}",
  },

  funnel: {
    journeyAnalytics: "Lidlar yo'li",
    newDeal: "Yangi bitim",
    addQuick: "Tez qo'shish",
    dealSearch: "Bitim, kontakt yoki raqam...",
    sortLabel: 'Saralash',
    sortManual: "Odatiy (qo'lda tartiblangan)",
    sortCreatedAsc: "Eski - yangi (yaratilgani bo'yicha)",
    sortCreatedDesc: "Yangi - eski (yaratilgani bo'yicha)",
    sortUpdatedAsc: "Eski - yangi (statusi o'zgargani bo'yicha)",
    sortUpdatedDesc: "Yangi - eski (statusi o'zgargani bo'yicha)",
    sortTitleAsc: 'A - Z',
    sortTitleDesc: 'Z - A',
    dateFrom: 'Yaratilgan sana — dan',
    dateTo: 'Yaratilgan sana — gacha',
    showClosed: 'Yopilganlar',
    bulkSelectTitle: 'Ommaviy tanlash',
    select: 'Tanlash',
    selectCancel: 'Bekor qilish',
    archiveBtn: 'Arxiv',
    statsBtn: 'Statistika',
    noDeals: "Bitim yo'q",
    totalDeals: "ta bitim",
    totalValue: "jami qiymat",
    loadError: "Yuklanishda xato",
    deleteConfirm: "Bitim o'chirilsinmi?",
    deleted: "O'chirildi",
    edit: "Tahrirlash",
    newLead: "Yangi bitim",
    leadNameLabel: "Mijoz ismi *",
    contactOpt: "Kontakt (ixtiyoriy)",
    noContact: "— Kontaktsiz",
    createContact: "+ Yangi kontakt yaratish",
    contactNamePh: "Ism *",
    contactPhonePh: "Telefon",
    contactEmailPh: "Email",
    contactCreated: "Kontakt yaratildi",
    contactExists: "Bunday kontakt allaqachon mavjud",
    responsibleLabel: "Mas'ul xodim",
    unassigned: "— Tanlanmagan",
    notesPlaceholder: "Qo'shimcha ma'lumot...",
    addBtn: "Qo'shish",
    titleRequired: "Sarlavha kiritilishi shart",
    searchPlaceholder: "Qidirish...",
    noFunnel: "Varonka topilmadi",
    stagePlaceholder: "Bosqich nomi...",
    moveTitle: "Bitim qiymati",
    moveHint: "Summani kiriting (ixtiyoriy)",
    moveSave: "Ko'chirish",
    moveCancel: "Bekor",
    export: "Eksport",
    import: "Import",
    exportDone: "Excel yuklab olindi",
    exportError: "Eksport xatosi",
    importTitle: "Excel import",
    importDone: "Import tugadi!",
    importCreated: "ta lead qo'shildi",
    importSkipped: "ta o'tkazib yuborildi",
    importFormat: "Excel (.xlsx) ustunlari:",
    importHint: "Birinchi qator — ustun nomlari. Faqat «Sarlavha» ustuni majburiy.",
    downloadTemplate: "Shablonni yuklab olish",
    templateError: "Shablonni yuklab bo'lmadi",
    importBtn: "Import qilish",
    importError: "Import xatosi",
    onlyXlsx: "Faqat .xlsx fayl qabul qilinadi",
    dropXlsx: "Excel (.xlsx) faylni bu yerga tashlang",
    orClick: "yoki bosing va tanlang",
    clear: "Tozalash",
    cancel: "Bekor",
    close: "Yopish",
    dealsCount: "{n} ta bitim",
    dealsCountFiltered: "{shown} / {total}",
    viewActive: "Faol",
    viewClosed: "Yopilgan",
    allSources: "Barcha manbalar",
    noSource: "Manbasiz",
    cfAll: "{name}: barchasi",
    cfNone: "{name} yo'q",
    chipSearch: "«{q}»",
    chipDates: "{from} — {to}",
    bulkMoved: "{n} ta lid ko'chirildi",
    bulkTransferred: "{n} ta lid o'tkazildi",
    bulkDeleted: "{n} ta lid o'chirildi",
    bulkArchived: "{n} ta lid arxivlandi",
    bulkAssigned: "{n} ta lidga biriktirildi",
    bulkSkipped: ", {n} tasi o'tkazib yuborildi",
  },

  deals: {
    moveStage: "Bosqich", moveStageTitle: "Bosqichga o‘tkazish", showMore: "Yana ko‘rsatish: {count}",
    nextStep: "Keyingi qadam",
    noNextStep: "Keyingi qadam yo'q: bitim yo'qolib qolmasligi uchun vazifa qo'ying",
    setNextStep: "Vazifa qo'yish",
    back: "Orqaga",
    newDeal: "Yangi bitim",
    editDeal: "Bitimni tahrirlash",
    save: "Saqlash",
    cancel: "Bekor",
    delete: "O'chirish",
    deleteConfirm: "Bitim o'chirilsinmi?",
    deleted: "O'chirildi",
    saved: "Saqlandi",
    created: "Yaratildi",
    loadError: "Yuklanishda xato",
    titleLabel: "Sarlavha *",
    titlePlaceholder: "Bitim nomi...",
    titleRequired: "Sarlavha kiritilishi shart",
    contact: "Kontakt",
    value: "Summa",
    currency: "Valyuta",
    stage: "Bosqich",
    moveToFunnel: "Boshqa varonkaga o'tkazish",
    moveFunnelLabel: "Varonka",
    moveFunnelPlaceholder: "Varonkani tanlang...",
    moveStagePlaceholder: "Bosqichni tanlang...",
    moveReasonLabel: "Sabab (ixtiyoriy)",
    moveReasonPlaceholder: "Nima uchun boshqa voronkaga o'tkazilyapti...",
    moveSubmit: "O'tkazish",
    moveSuccess: "Varonkaga o'tkazildi",
    assignee: "Mas'ul",
    dueDate: "Muddat",
    notes: "Izoh",
    notesPlaceholder: "Izoh...",
    wonTitle: "Bitim yutildi",
    lostTitle: "Bitim yo'qotildi",
    wonReason: "Sabab yoki izoh (ixtiyoriy)",
    lostReason: "Yo'qotish sababi (ixtiyoriy)",
    reasonPlaceholder: "Sabab...",
    confirm: "Tasdiqlash",
    activitySub: "Izohlar va o'zgarishlar",
    notePlaceholder: "Izoh yozing...",
    activityEmpty: "Faoliyat yo'q",
    activityHint: "Birinchi izohni yozing",
    noteTab: "Izoh",
    communicationTab: "Kontakt",
    contactTypeCall: "Qo'ng'iroq",
    contactTypeMessage: "Xabar",
    contactTypeMeeting: "Uchrashuv",
    durationLabel: "daqiqa",
    outcomeInterested: "Qiziqdi",
    outcomeThinking: "O'ylayapti",
    outcomeDeclined: "Rad etdi",
    outcomeNoAnswer: "Javob bermadi",
    outcomeOther: "Boshqa",
  },

  inboxAnalytics: {
    title: "Xabarlar analitikasi",
    back: "Xabarlar",
    tabGeneral: "Umumiy",
    tabAgents: "Xodimlar",
    preset7d: "7 kun",
    presetMonth: "Bu oy",
    presetPrevMonth: "O'tgan oy",
    presetQuarter: "Bu chorak",
    presetCustom: "Maxsus",
    apply: "Qo'llash",
    compare: "Oldingi davr bilan solishtir",
    totalConvs: "Jami suhbatlar",
    unanswered: "Javob berilmagan",
    closed: "Yopilgan",
    avgResponse: "O'rt. javob vaqti",
    firstResponse: "Birinchi javob",
    resolutionRate: "Hal qilish:",
    prevPeriod: "o'tgan davr:",
    dailyChart: "Kunlik suhbatlar",
    dayCount: "kun",
    comparison: "Davr solishtiruvchi",
    total: "Jami",
    closedPct: "Hal qilish %",
    byChannel: "Kanallar bo'yicha",
    agentStats: "Agentlar",
    labelStats: "Yorliqlar",
    noData: "Ma'lumot yo'q",
    noLabels: "Yorliq yo'q",
    agentReport: "Xodimlar bo'yicha hisobot",
    exportCsv: "CSV yuklab olish",
    thAgent: "Xodim",
    thTotal: "Suhbatlar",
    thClosed: "Yopilgan",
    thClosedPct: "Yopish %",
    thAvgResp: "O'rt. javob",
    thCalls: "Qo'ng'iroq",
    loadError: "Yuklanmadi",
  },

  contactAnalytics: {
    title: "Kontaktlar Analitikasi",
    back: "Kontaktlar",
    preset30d: "30 kun",
    presetMonth: "Bu oy",
    preset90d: "90 kun",
    presetCustom: "Maxsus",
    apply: "Qo'llash",
    periodNew: "Davr uchun yangi kontaktlar",
    totalAll: "Jami kontaktlar",
    allTime: "Barcha vaqt uchun",
    dailyChart: "Kunlik yangi kontaktlar",
    byChannel: "Kanal bo'yicha (Xabarlar orqali)",
    byOperator: "Operator bo'yicha",
    noPhone: "Telefon raqamlar yo'q",
    noData: "Ma'lumot yo'q",
    loadError: "Yuklanmadi",
  },

  leadJourney: {
    title: "Lidlar yo'li",
    back: "Voronkalar",
    preset30d: "30 kun",
    presetMonth: "Bu oy",
    preset90d: "90 kun",
    presetCustom: "Maxsus",
    apply: "Qo'llash",
    contactsWidgetTitle: "Bugungi/davrdagi kontaktlar",
    uniqueLeadsContacted: "noyob lid bilan aloqa bo'ldi",
    byType: "Turi bo'yicha",
    interactedTitle: "Aloqa bo'lgan mijozlar",
    calledTitle: "Gaplashilgan mijozlar",
    calledHint: "Qo'ng'iroq qilib gaplashilgan",
    sourceFunnelChange: "Voronka o'tkazish",
    sourceStageChange: "Bosqich o'tkazish",
    sourceComment: "Izoh qoldirish",
    sourceInbox: "Xabar (Telegram va h.k.)",
    transitionsWidgetTitle: "Voronkalararo o'tishlar",
    transitionsEmpty: "Bu davrda voronkalararo o'tish bo'lmagan",
    snapshotWidgetTitle: "Joriy holat — voronka/bosqich bo'yicha",
    loadError: "Yuklanmadi",
  },

  sheets: {
    title: "Google Jadvallar",
    subtitle: "Jadvaldagi lidlar (masalan, Meta Lead Ads arizalarni qo‘shadigan jadval) CRM’ga o‘zi tushadi: har bir yangi qator bitimga aylanadi.",
    add: "Jadvalni ulash",
    empty: "Jadvallar ulanmagan",
    paused: "to‘xtatilgan",
    destination: "Lidlar qayerga tushadi",
    lastSync: "Tekshirildi",
    neverSynced: "Hali tekshirilmagan",
    totalImported: "yaratilgan bitimlar: {n}",
    rows: "jadvaldagi qatorlar: {n}",
    syncNow: "Hozir tekshirish",
    pause: "To‘xtatib turish",
    resume: "Davom ettirish",
    edit: "O‘zgartirish",
    remove: "Uzish",
    removeConfirm: "«{name}» uzilsinmi? Yaratilgan bitimlar qoladi.",
    removed: "Jadval uzildi",
    imported: "Yangi bitimlar: {n}",
    nothingNew: "Yangi qatorlar yo‘q",
    error: "Nimadir xato ketdi",
    connected: "Jadval ulandi. Yangi qatorlar CRM’ga o‘zi tushadi",
    connectedImported: "Jadval ulandi, yuklangan bitimlar: {n}",
    saved: "Saqlandi",
    howTitle: "Bu qanday ishlaydi",
    "how1": "CRM jadvalga 2 daqiqada bir qaraydi va faqat yangi qatorlarni oladi.",
    "how2": "Bitta qator tanlangan voronka va bosqichda kontakt va bitimga aylanadi. Takror bo‘lmaydi: har bir qator bir marta o‘qiladi.",
    "how3": "Telefon ham, pochta ham yo‘q qatorlar o‘tkazib yuboriladi.",
    "how4": "Forma savollariga javoblar bitim izohiga tushadi, ularni «Lid maydonlari» bo‘limida maydonlarga taqsimlash mumkin.",
    addTitle: "Google Jadvalni ulash",
    editTitle: "Jadval sozlamalari",
    accessTitle: "Avval jadvalga kirishni oching",
    accessHint: "Jadvalda «Kirish sozlamalari» → «Havolasi bor har kim» → «Kuzatuvchi» rolini tanlang. CRM jadvalni faqat o‘qiydi, hech narsani o‘zgartirmaydi.",
    link: "Jadval havolasi",
    check: "Tekshirish",
    tabHint: "Kerakli varaq ochiq turganda manzil satridan havolani nusxalang: CRM aynan shu varaqni o‘qiydi.",
    found: "Jadval ochiq. Ma’lumotli qatorlar: {n}",
    name: "Manba nomi",
    namePh: "Masalan, Meta: noyabr",
    defaultName: "Google Jadval",
    funnel: "Voronka",
    stage: "Bosqich",
    source: "Bitim manbasi",
    sourceHint: "Bitimdagi manba yozuvi (masalan, Facebook yoki Instagram).",
    columns: "Qaysi ustun nimani bildiradi",
    none: "— yo‘q —",
    colIdHint: "Qatorning noyob raqami: CRM takror bitim yaratmaydi",
    restHint: "Qolgan ustunlar (forma javoblari, reklama, platforma) bitim izohiga tushadi.",
    needContact: "Telefon yoki pochta ustunini tanlang",
    col: {
      name: "Ism",
      phone: "Telefon",
      email: "Pochta",
      id: "Qator raqami (id)",
      createdAt: "Ariza vaqti",
    },
    importExisting: "Jadvalda allaqachon bor qatorlarni ham yuklash ({n})",
    importExistingHint: "Belgilanmasa, faqat ulangandan keyin qo‘shilgan qatorlar CRM’ga tushadi.",
    cancel: "Bekor qilish",
    connect: "Ulash",
    save: "Saqlash",
    meta: {
      enable: "Meta’ga natijalarni yuborish: «Yutildi» va «Yo‘qotildi»",
      enableHint: "Reklama xarid qiladiganlarga o‘xshash odamlarni topishni o‘rganadi (Conversions API for CRM). Meta lid id si id ustunidan olinadi.",
      dataset: "Dataset ID",
      token: "Kirish tokeni",
      tokenSaved: "•••• saqlangan (almashtirish uchun yangisini kiriting)",
      tokenHint: "Ikkala qiymatni Meta «Events Manager»da reklama kabineti administratori yaratadi: dataset → Sozlamalar → Conversions API → «Token yaratish». Token faqat serverda saqlanadi va ko‘rsatilmaydi.",
      wonEvent: "«Yutildi» uchun hodisa",
      lostEvent: "«Yo‘qotildi» uchun hodisa",
      testCode: "Test hodisa kodi (majburiy emas)",
      testCodeHint: "Kod ko‘rsatilgan paytda hodisalar «Test events» bo‘limiga tushadi va reklama statistikasiga kirmaydi. Ishchi yuborish uchun maydonni bo‘sh qoldiring.",
      check: "Ulanishni tekshirish",
      ok: "Ulanish bor: {name}",
      checkLater: "Ulanishni saqlagandan keyin tekshirish mumkin: manbani «O‘zgartirish» tugmasi bilan oching.",
      badge: "Meta: natijalar",
    },
    err: {
      bad_url: "Bu Google Jadval havolasi emas",
      private: "Jadvalga kirish yo‘q. «Havolasi bor har kim» → «Kuzatuvchi»ni yoqing va yana «Tekshirish»ni bosing.",
      bad_tab: "Jadvalda bunday varaq yo‘q. Kerakli varaqni oching va havolani qaytadan nusxalang.",
      not_found: "Jadval topilmadi. Havolani tekshiring.",
      empty: "Jadval bo‘sh",
      network: "Google bilan aloqa o‘rnatilmadi. Keyinroq urinib ko‘ring.",
      failed: "Jadvalni tekshirib bo‘lmadi",
    },
  },
  edu: {
    io: {
      import: "Import",
      export: "Eksport",
      title: "O‘quvchilarni Excel’dan import qilish",
      step1: "Shablonni yuklab oling",
      step1Hint: "Xodimlar uni to‘ldiradi: bitta o‘quvchi — bitta qator. «Yo‘riqnoma» varag‘ida hammasi tushuntirilgan, guruh ro‘yxatdan tanlanadi.",
      template: "Shablonni yuklab olish",
      step2: "To‘ldirilgan faylni yuklang",
      pick: "Fayl tanlash",
      change: "Boshqa fayl",
      drop: ".xlsx faylni shu yerga tashlang yoki tanlang",
      check: "Tekshirish",
      importN: "Yuklash: {n}",
      cancel: "Bekor qilish",
      close: "Yopish",
      checked: "Yuklash mumkin: {ok}. Tuzatish yoki o‘tkazib yuborish kerak: {bad}. Hali hech narsa saqlanmadi.",
      empty: "Faylda to‘ldirilgan qatorlar yo‘q",
      doneTitle: "Import yakunlandi",
      created: "qo‘shildi",
      skipped: "o‘tkazib yuborildi",
      problems: "Muammoli qatorlar: {n}",
      row: "{n}-qator",
      onlyXlsx: ".xlsx fayl kerak",
      templateError: "Shablonni yuklab bo‘lmadi",
      importError: "Faylni yuklab bo‘lmadi",
      exportError: "Faylni eksport qilib bo‘lmadi",
      err: { no_name: "F.I.Sh. ko‘rsatilmagan", no_group: "guruh ko‘rsatilmagan", group_unknown: "bunday guruh yo‘q", group_archived: "guruh arxivda", bad_date: "sana noto‘g‘ri", bad_number: "son noto‘g‘ri", bad_lang: "til uz yoki ru bo‘lishi kerak", duplicate: "bu o‘quvchi guruhda allaqachon bor", group_full: "guruh to‘lgan", bad_package: "paketdagi darslar soni ko‘rsatilmagan", too_many_rows: "qatorlar juda ko‘p (1000 gacha)", failed: "saqlab bo‘lmadi" },
    },
    deal: {
      enroll: "Guruhga yozish",
      enrollAnother: "Yana bir guruhga yozish",
      enrolled: "{group}: {n} ta dars qoldi",
      openStudents: "O‘quvchilarni ochish",
      noGroups: "Hali guruh yo‘q. Avval «Ta’lim» bo‘limida guruh yarating.",
      toGroups: "Guruhlarga",
      linkHint: "Ism, telefon va kontakt bitimdan olindi, qaytadan kiritish shart emas. To‘lovni o‘quvchi kartochkasida kiriting.",
      openDeal: "Bitim",
      openContact: "Kontakt",
    },
    title: "Ta’lim",
    add: "Qo‘shish",
    all: "Hammasi",
    archive: "Arxivga",
    restore: "Qaytarish",
    cancel: "Bekor qilish",
    close: "Yopish",
    copied: "Nusxalandi",
    copy: "Nusxalash",
    date: "Sana",
    delete: "O‘chirish",
    edit: "O‘zgartirish",
    end: "Tugashi",
    start: "Boshlanishi",
    group: "Guruh",
    loading: "Yuklanmoqda…",
    note: "Izoh",
    save: "Saqlash",
    saved: "Saqlandi",
    d1: "Du",
    d2: "Se",
    d3: "Chor",
    d4: "Pay",
    d5: "Ju",
    d6: "Sha",
    d7: "Yak",
    dl1: "Dushanba",
    dl2: "Seshanba",
    dl3: "Chorshanba",
    dl4: "Payshanba",
    dl5: "Juma",
    dl6: "Shanba",
    dl7: "Yakshanba",
    status: {
      present: "Keldi",
      late: "Kechikdi",
      absent: "Kelmadi",
      excused: "Sababli",
    },
    st: {
      active: "O‘qiyapti",
      frozen: "Muzlatilgan",
      left: "Chiqib ketgan",
      completed: "Tugatgan",
    },
    method: {
      cash: "Naqd",
      card: "Karta",
      transfer: "O‘tkazma",
      other: "Boshqa",
    },
    tabs: {
      today: "Bugun",
      groups: "Guruhlar",
      students: "O‘quvchilar",
      debts: "Qarzlar",
      report: "Davomat",
      settings: "Sozlamalar",
    },
    sum: {
      students: "o‘quvchi o‘qiyapti",
      lessonsToday: "bugungi dars belgilandi",
      debt: "qarz ({n} o‘q.)",
      low: "paket tugayapti",
    },
    today: {
      prev: "Oldingi kun",
      next: "Keyingi kun",
      goToday: "Bugunga qaytish",
      noLessons: "Bu kunga dars yo‘q",
      markAll: "Hammasi keldi",
      save: "Saqlash",
      saved: "Davomat saqlandi",
      progress: "{n} tadan {m} tasi belgilandi",
      notMarked: "Belgilanmagan",
      held: "O‘tkazildi",
      cancelled: "Bekor qilindi",
      cancel: "Darsni bekor qilish",
      reopen: "Qaytarish",
      cancelPrompt: "Bekor qilish sababi (ixtiyoriy):",
      readonly: "Tahrirlash yopiq: belgilarni faqat oxirgi {n} kun ichida o‘zgartirish mumkin.",
      extra: "qo‘shimcha dars",
      addLesson: "Qo‘shimcha dars",
      left: "{n} ta qoldi",
      debt: "qarz",
      noStudents: "Guruhda o‘quvchi yo‘q",
    },
    groups: {
      new: "Yangi guruh",
      edit: "Guruhni o‘zgartirish",
      name: "Nomi",
      course: "Kurs",
      teacher: "O‘qituvchi",
      room: "Xona",
      color: "Rang",
      schedule: "Jadval",
      day: "Kun",
      addSlot: "Kun qo‘shish",
      startDate: "Kurs boshlanishi",
      endDate: "Kurs tugashi",
      capacity: "Guruhdagi o‘rinlar",
      capacityHint: "0 — cheklovsiz",
      packageLessons: "Paketdagi darslar",
      packagePrice: "Paket narxi",
      showArchived: "Arxivdagilarni ko‘rsatish",
      archiveConfirm: "«{name}» guruhini arxivga o‘tkazasizmi? Unga yangi darslar yaratilmaydi.",
      none: "Hozircha guruh yo‘q",
      studentsCount: "{n} o‘q.",
      frozenCount: "{n} muzlatilgan",
      packageShort: "paket {n} dars · {price}",
    },
    students: {
      new: "Yangi o‘quvchi",
      name: "Ism",
      phone: "Telefon",
      parent: "Ota-ona",
      parentName: "Ota-ona ismi",
      parentPhone: "Ota-ona telefoni",
      parentLang: "Ota-onaga xabar tili",
      langDefault: "Standart",
      joined: "Yozilgan sana",
      withPackage: "Dars paketi bilan yozish",
      lessons: "Darslar",
      price: "Narxi",
      paid: "To‘langan",
      contactHint: "Telefon kiritilsa, CRMda kontakt kartochkasi avtomatik yaratiladi.",
      search: "Ism yoki telefon",
      allGroups: "Barcha guruhlar",
      activeFrozen: "O‘qiyotgan va muzlatilgan",
      anyBalance: "Har qanday balans",
      onlyDebt: "Faqat qarzdorlar",
      onlyLow: "Paket tugayapti",
      needGroup: "Avval «Guruhlar» bo‘limida guruh yarating.",
      none: "O‘quvchilar yo‘q",
      leftLessons: "dars qoldi",
      debt: "qarz",
      credit: "ortiqcha to‘lov",
      leftAt: "Chiqib ketgan",
      balanceHint: "Sotib olingan {bought}, yechilgan {used}, tuzatish {adjust}",
      packages: "Paketlar va to‘lovlar",
      addPackage: "Yangi paket",
      addPayment: "To‘lov",
      noPackages: "Paket yo‘q",
      packageLine: "{n} darslik paket",
      amount: "Summa",
      method: "Usul",
      deletePaymentConfirm: "Bu to‘lovni o‘chirasizmi?",
      deletePackageConfirm: "Paketni to‘lovlari bilan o‘chirasizmi?",
      telegram: "Ota-ona Telegrami",
      noBot: "Bot ulanmagan: Sozlamalar → Ta’lim.",
      tgLinked: "Ota-ona ulangan",
      tgMuted: "ota-ona xabarnomalarni o‘chirgan",
      tgNotLinked: "Ota-ona hali ulanmagan: unga havolani yuboring",
      remindDebt: "Qarzni eslatish",
      remindLow: "To‘lovni eslatish",
      reminded: "Eslatma yuborildi",
      history: "Qatnashish tarixi",
      noHistory: "Hali dars bo‘lmagan",
      status: "Holati",
      transfer: "Guruh",
      transferConfirm: "O‘quvchini boshqa guruhga o‘tkazasizmi?",
      adjust: "Darslarni tuzatish",
      adjustHint: "+N yoki −N: kompensatsiya, ko‘chirish va h.k.",
      leftReasonPrompt: "Sabab (ixtiyoriy):",
      delete: "O‘quvchini o‘chirish",
      deleteConfirm: "O‘quvchini o‘chirasizmi? Faqat davomat belgilari bo‘lmasa mumkin.",
    },
    debts: {
      total: "Umumiy qarz",
      count: "O‘quvchilar: {n}",
      none: "Qarz va tugayotgan paketlar yo‘q",
      remind: "Eslatish",
    },
    report: {
      from: "Dan",
      to: "Gacha",
      rate: "Davomat",
      lessons: "o‘tkazilgan darslar: {n}",
      none: "Bu davrda belgilar yo‘q",
    },
    settings: {
      open: "Sozlamalar",
      charge: "Qaysi holat paketdan darsni yechadi",
      chargeHint: "Belgilangan holatlar o‘quvchining qolgan darslarini kamaytiradi. Qoldiq har safar qayta hisoblanadi, shuning uchun qoida o‘zgarsa barcha balanslar yangilanadi.",
      rules: "Qoidalar va chegaralar",
      lowBalance: "Quyidagi dars qolganda ogohlantirish",
      lowBalanceHint: "0 — ogohlantirmaslik",
      absentStreak: "Menejerga vazifa uchun ketma-ket qoldirilgan darslar",
      absentStreakHint: "0 — vazifa yaratmaslik",
      assignee: "Vazifa kimga qo‘yiladi",
      assigneeAuto: "Guruh yaratuvchisiga",
      editDays: "Resepshn necha kun oldingi belgilarni o‘zgartira oladi",
      editDaysHint: "Egasi va administrator istalgan kunni o‘zgartira oladi.",
      defaultPackage: "Standart paket",
      defaultPackageHint: "Guruhda paket belgilanmagan bo‘lsa, shu qo‘yiladi.",
      regional: "Vaqt va til",
      timezone: "Vaqt mintaqasi",
      parentLang: "Ota-onalarga xabar tili",
      bot: "Ota-onalar uchun Telegram-bot",
      botHint: "Har bir o‘quv markazning o‘z boti bor: ota-onalar uning nomi va rasmini ko‘radi.",
      botStep1: "Telegramda @BotFather ni oching va /newbot yuboring.",
      botStep2: "Bot nomi va username kiriting (masalan, «Rustamov Academy» va rustamov_academy_bot).",
      botStep3: "Olingan tokenni nusxalab shu yerga qo‘ying.",
      botConnect: "Ulash",
      botConnected: "Bot ulandi",
      botDisconnect: "Uzish",
      botDisconnectConfirm: "Botni uzasizmi? Ota-onalar xabar olmay qoladi.",
      notify: "Ota-onalarga xabarnomalar",
      notifyHint: "Xabarlar faqat o‘quvchi kartochkasidagi havola orqali ulangan ota-onalarga boradi.",
      notifyEnabled: "Xabarnomalarni yuborish",
      notifyNeedBot: "Avval botni ulang.",
      onAbsent: "O‘quvchi kelmaganda",
      onLate: "O‘quvchi kechikkanda",
      onLow: "Paket tugayotganda",
      templates: "Xabar matnlari",
      templatesHint: "Standart matn uchun bo‘sh qoldiring. Ishlatish mumkin: {vars}",
    },
    tpl: {
      absent: "Kelmadi",
      late: "Kechikdi",
      low: "Paket tugayapti",
      debt: "Qarz",
    },
  },

  bottomNav: {
    more: "Yana", label: "Asosiy navigatsiya",
    education: "Ta’lim",
    dashboard: "Bosh",
    contacts: "Kontaktlar",
    tasks: "Vazifalar",
    inbox: "Xabarlar",
    calls: "Qo'ng'iroqlar",
    reviews: "Sharhlar",
    funnels: "Voronkalar",
    analytics: "Analitika",
  },

    serverText: { unknownPhone: "Noma'lum ({phone})", 
    unknown: "Noma'lum",
  
    assignedTo: "{name}ga biriktirildi",
  
    bulk: " — ommaviy",
  
    archived: "Arxivlandi",
  
    unarchived: "Arxivdan qaytarildi",
  
    unassigned: "Biriktirilishi bekor qilindi",
  
    claimed: "O'ziga biriktirib oldi",
  },
  };
